/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface AIAnnotationExternalCreateRequest {
  /**
   *
   *
   * 0 = StrokeDraw
   *
   * 1 = StrokeErase
   *
   * 2 = Laser
   *
   * 3 = Text
   *
   * 4 = Audio
   *
   * 5 = Text_Callout
   *
   * 6 = HotSpot
   *
   * 7 = LinkedPage
   *
   * 8 = AI
   *
   * 9 = AIHotspot
   *
   * 10 = Box
   *
   * 11 = Distance
   *
   * 12 = Model
   *
   * 13 = Height
   *
   * 14 = Area
   *
   * 15 = Cylinder
   *
   * 16 = Polyline
   *
   * 100 = StrokeDraw_Shape_Line
   *
   * 101 = StrokeDraw_Shape_Rectangle
   *
   * 102 = StrokeDraw_Shape_Ellipse
   *
   * 103 = StrokeDraw_Shape_Rectangle_Filled
   *
   * 104 = StrokeDraw_Shape_Ellipse_Filled
   *
   * 105 = StrokeDraw_Shape_Line_ArrowEnd
   *
   * 106 = StrokeDraw_Shape_Line_ArrowBoth
   *
   * 107 = Polygon
   */
  Type: AnnotationType
  /**
   * Unique id of the AI object within the system
   * @format int32
   */
  AIObjectId: number
  /**
   * Unique id of the unique AI object within the system
   * @format int32
   */
  UniqueAIObjectId?: number | null
  /**
   * Coordinates of the annotation. Required for annotations with types:
   *
   * Tabeeb.Shared.Common.Enums.AnnotationType.StrokeDraw
   * Tabeeb.Shared.Common.Enums.AnnotationType.StrokeDraw_Shape_Line
   * Tabeeb.Shared.Common.Enums.AnnotationType.StrokeDraw_Shape_Rectangle
   * Tabeeb.Shared.Common.Enums.AnnotationType.StrokeDraw_Shape_Ellipse
   * Tabeeb.Shared.Common.Enums.AnnotationType.StrokeDraw_Shape_Rectangle_Filled
   * Tabeeb.Shared.Common.Enums.AnnotationType.StrokeDraw_Shape_Ellipse_Filled
   * Tabeeb.Shared.Common.Enums.AnnotationType.StrokeDraw_Shape_Line_ArrowEnd
   * Tabeeb.Shared.Common.Enums.AnnotationType.StrokeDraw_Shape_Line_ArrowBoth
   * Tabeeb.Shared.Common.Enums.AnnotationType.Polygon
   */
  Coordinates?: Coordinates[] | null
  Anchor?: Point
  Rotation?: EulerRotation
  Scale?: Scale
  /** Annotation points */
  Points?: Point[] | null
  /** Annotation name */
  Name?: string | null
  /**
   * Unique id of the page within the system
   * @format int32
   */
  PageId: number
  /**
   * The time on video/audio when an annotation has been created. Optional
   * @format float
   * @default -1
   */
  Timestamp: number
  /**
   * The color of the annotation. Optional
   * @default "#FB000E"
   */
  Color?: string | null
  /**
   * The width of the annotation lines/font. Optional
   * @format int32
   * @default 3
   */
  Width: number
  /**
   * Unique id of the parent annotation within the system. Optional
   * @format int32
   */
  ParentAnnotationId?: number | null
}

export interface AICounterResponse {
  /** @format int32 */
  Id: number
  /**
   *
   *
   * 1 = Text
   *
   * 2 = Textarea
   *
   * 3 = Checkboxlist
   *
   * 4 = Radiobuttonlist
   *
   * 5 = Selectlist
   *
   * 6 = Tabs
   *
   * 7 = Counter
   *
   * 8 = Date
   *
   * 9 = DateTime
   */
  ControlType: ControlType
  /** @format int32 */
  CounterLimit?: number | null
  /** @format int32 */
  AIObjectId: number
  CountAIObjects: boolean
  /** @format int32 */
  FormId: number
  Label?: string | null
  /** @format int32 */
  Order: number
  /** @format int32 */
  IncrementValue?: number | null
  /** @format int32 */
  IncrementPeriod?: number | null
  Conditions?: ConditionsResponse[] | null
}

export interface AIObjectsCountResponse {
  /** @format int32 */
  AIObjectId: number
  /** @format int32 */
  ObjectsPerSessionCount: number
  /** @format int32 */
  ClassesPerSessionCount: number
  /** @format int32 */
  PageId?: number | null
  /** @format int32 */
  ObjectsPerPageCount: number
  /** @format int32 */
  ClassesPerPageCount: number
}

export interface AIObjectsInfoResponse {
  /** @format int32 */
  PageId: number
  /** @format int32 */
  UniqueObjectId?: number | null
  /** @format int32 */
  AIObjectId: number
  /** @format int32 */
  ObjectsCount: number
}

export interface AcceptPoliciesRequest {
  PoliciesIds?: number[] | null
}

/**
 *
 *
 * 0 = All
 *
 * 1 = AIFlag
 *
 * 2 = Flag
 *
 * 3 = Drawing
 *
 * 4 = Image
 *
 * 5 = Shape
 *
 * 6 = Text
 *
 * 7 = Audio
 * @format int32
 */
export enum ActivitiesType {
  All = 0,
  AIFlag = 1,
  Flag = 2,
  Drawing = 3,
  Image = 4,
  Shape = 5,
  Text = 6,
  Audio = 7,
}

export interface AddClassificationAnnotationsRequest {
  /**
   * Unique id of the session within the system.
   * @format int32
   */
  ContentId: number
  /**
   * List of Annotations.
   * @minItems 1
   */
  Annotations: ClassificationAnnotationRequest[]
}

export interface AddUsersContentRequest {
  /**
   * The id of a particular session.
   * @format int32
   */
  ContentId: number
  /**
   * The ids of the added users.
   * @minItems 1
   */
  UserIds: number[]
  /** Ids of qualifications that will be required for user to use the session */
  QualificationIds?: number[] | null
  /**
   *
   *
   * 0 = User
   *
   * 1 = Owner
   *
   * 2 = AIUser
   *
   * 3 = Reviewer
   *
   * 4 = Viewer
   *
   * 5 = Labeler
   *
   * 6 = Approver
   *
   * 7 = Guest
   */
  Role: ContentUserRole
}

export interface AddUsersFolderRequest {
  /** @format int32 */
  FolderId: number
  /** @minItems 1 */
  UserIds: number[]
  /**
   *
   *
   * 0 = User
   *
   * 1 = Owner
   *
   * 2 = Viewer
   *
   * 3 = Guest
   */
  Role: FolderUserRole
}

export interface AdminUsersSearchRequest {
  /**
   *
   *
   * 1 = Tenant
   *
   * 2 = Corporation
   */
  Scope: Scope
  Sorting?: Sorting
  Filtering?: Filtering
  /**
   * @format int32
   * @default 1
   */
  PageNumber: number
  /**
   * @format int32
   * @default 25
   */
  PageSize: number
}

/**
 *
 *
 * 1 = Name
 *
 * 2 = Email
 *
 * 3 = Role
 *
 * 4 = Tenant
 *
 * 5 = IsDisabled
 *
 * 6 = IsCreatedByAdmin
 * @format int32
 */
export enum AdminUsersSortingColumnEnum {
  Name = 1,
  Email = 2,
  Role = 3,
  Tenant = 4,
  IsDisabled = 5,
  IsCreatedByAdmin = 6,
}

export interface AllTenantFormsView {
  Name?: string | null
  OwnerEmail?: string | null
  /** @format int32 */
  ControlsNumber?: number | null
  IsPublished: boolean
  /** @format int32 */
  TotalCount: number
  /** @format int32 */
  Id: number
  IsDeleted: boolean
  /** @format date-time */
  CreatedOn?: string | null
}

export interface AnnotationCreateRequest {
  /**
   * Unique id of the Page within the system.
   * @format int32
   */
  PageId: number
  /**
   *
   *
   * 0 = StrokeDraw
   *
   * 1 = StrokeErase
   *
   * 2 = Laser
   *
   * 3 = Text
   *
   * 4 = Audio
   *
   * 5 = Text_Callout
   *
   * 6 = HotSpot
   *
   * 7 = LinkedPage
   *
   * 8 = AI
   *
   * 9 = AIHotspot
   *
   * 10 = Box
   *
   * 11 = Distance
   *
   * 12 = Model
   *
   * 13 = Height
   *
   * 14 = Area
   *
   * 15 = Cylinder
   *
   * 16 = Polyline
   *
   * 100 = StrokeDraw_Shape_Line
   *
   * 101 = StrokeDraw_Shape_Rectangle
   *
   * 102 = StrokeDraw_Shape_Ellipse
   *
   * 103 = StrokeDraw_Shape_Rectangle_Filled
   *
   * 104 = StrokeDraw_Shape_Ellipse_Filled
   *
   * 105 = StrokeDraw_Shape_Line_ArrowEnd
   *
   * 106 = StrokeDraw_Shape_Line_ArrowBoth
   *
   * 107 = Polygon
   */
  Type: AnnotationType
  /**
   * The id of the parent annotation if this annotation is nested.
   * Null if there is no parent.
   * @format int32
   */
  ParentAnnotationId?: number | null
  /**
   * The color of the annotation. This property is `IGNORED` for the following annotation types:
   * <list type="bullet"><item>Tabeeb.Shared.Common.Enums.AnnotationType.AI</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.Audio</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.Model</item></list>
   * It is used for all other annotation types.
   */
  Color?: string | null
  /**
   * The elevation of the annotation. This property is only used when Tabeeb.Web.Domain.Annotations.AnnotationCreateRequest.Type equals one of the following:
   * <list type="bullet"><item>Tabeeb.Shared.Common.Enums.AnnotationType.Cylinder</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.Box</item></list>
   * Otherwise, it is ignored.
   * @format double
   */
  Elevation: number
  /**
   * The stroke width of the annotation.This property is only used when Tabeeb.Web.Domain.Annotations.AnnotationCreateRequest.Type equals one of the following:
   * <list type="bullet"><item>Tabeeb.Shared.Common.Enums.AnnotationType.StrokeDraw_Shape_Line</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.StrokeDraw_Shape_Rectangle</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.StrokeDraw_Shape_Ellipse</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.StrokeDraw_Shape_Rectangle_Filled</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.StrokeDraw_Shape_Ellipse_Filled</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.StrokeDraw_Shape_Line_ArrowEnd</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.StrokeDraw_Shape_Line_ArrowBoth</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.Polygon</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.Text</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.Text_Callout</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.Cylinder</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.Box</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.Distance</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.Height</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.Area</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.Polyline</item></list>
   * Otherwise, it is ignored.
   * @format int32
   */
  Width: number
  /**
   * The coordinates of the annotation.This property is only used when Tabeeb.Web.Domain.Annotations.AnnotationCreateRequest.Type equals one of the following:
   * <list type="bullet"><item>Tabeeb.Shared.Common.Enums.AnnotationType.StrokeDraw_Shape_Line</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.StrokeDraw_Shape_Rectangle</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.StrokeDraw_Shape_Ellipse</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.StrokeDraw_Shape_Rectangle_Filled</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.StrokeDraw_Shape_Ellipse_Filled</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.StrokeDraw_Shape_Line_ArrowEnd</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.StrokeDraw_Shape_Line_ArrowBoth</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.Polygon</item></list>
   * Otherwise, it is ignored.
   */
  Coordinates?: Coordinates[] | null
  /**
   * The font size of the annotation.This property is only used when Tabeeb.Web.Domain.Annotations.AnnotationCreateRequest.Type equals one of the following:
   * <list type="bullet"><item>Tabeeb.Shared.Common.Enums.AnnotationType.Text</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.Text_Callout</item></list>
   * Otherwise, it is ignored.
   * @format int32
   */
  FontSize: number
  TopLeft?: Point
  /**
   * The Azimuth of the annotation.This property is only used when Tabeeb.Web.Domain.Annotations.AnnotationCreateRequest.Type equals Tabeeb.Shared.Common.Enums.AnnotationType.Model.
   * Otherwise, it is ignored.
   * @format double
   */
  Azimuth: number
  Anchor?: Point
  /**
   * The name of the annotation.This property is only used when Tabeeb.Web.Domain.Annotations.AnnotationCreateRequest.Type equals one of the following:
   * <list type="bullet"><item>Tabeeb.Shared.Common.Enums.AnnotationType.StrokeDraw_Shape_Line</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.StrokeDraw_Shape_Rectangle</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.StrokeDraw_Shape_Ellipse</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.StrokeDraw_Shape_Rectangle_Filled</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.StrokeDraw_Shape_Ellipse_Filled</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.StrokeDraw_Shape_Line_ArrowEnd</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.StrokeDraw_Shape_Line_ArrowBoth</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.Polygon</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.AIHotspot</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.Model</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.Box</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.Cylinder</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.Distance</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.Height</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.Area</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.Polyline</item></list>
   * Otherwise, it is ignored.
   */
  Name?: string | null
  /**
   * The text of the annotation.This property is only used when Tabeeb.Web.Domain.Annotations.AnnotationCreateRequest.Type equals one of the following:
   * <list type="bullet"><item>Tabeeb.Shared.Common.Enums.AnnotationType.Text</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.Text_Callout</item></list>
   * Otherwise, it is ignored.
   */
  Text?: string | null
  /**
   * The tilt of the annotation.This property is only used when Tabeeb.Web.Domain.Annotations.AnnotationCreateRequest.Type equals Tabeeb.Shared.Common.Enums.AnnotationType.Model.
   * Otherwise, it is ignored.
   * @format double
   */
  Tilt: number
  /**
   * The timestamp of the annotation.This property is only used when Tabeeb.Web.Domain.Annotations.AnnotationCreateRequest.Type equals one of the following:
   * <list type="bullet"><item>Tabeeb.Shared.Common.Enums.AnnotationType.StrokeDraw_Shape_Line</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.StrokeDraw_Shape_Rectangle</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.StrokeDraw_Shape_Ellipse</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.StrokeDraw_Shape_Rectangle_Filled</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.StrokeDraw_Shape_Ellipse_Filled</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.StrokeDraw_Shape_Line_ArrowEnd</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.StrokeDraw_Shape_Line_ArrowBoth</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.Polygon</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.Text</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.Text_Callout</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.Audio</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.HotSpot</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.LinkedPage</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.AI</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.AIHotspot</item></list>
   * Otherwise, it is ignored.
   * @format float
   */
  Timestamp: number
  /**
   * The TargetTimestamp of the annotation.This property is only used when Tabeeb.Web.Domain.Annotations.AnnotationCreateRequest.Type equals Tabeeb.Shared.Common.Enums.AnnotationType.LinkedPage.
   * Otherwise, it is ignored.
   * @format float
   */
  TargetTimestamp: number
  /**
   * The Url of the annotation.This property is only used when Tabeeb.Web.Domain.Annotations.AnnotationCreateRequest.Type equals one of the following:
   * <list type="bullet"><item>Tabeeb.Shared.Common.Enums.AnnotationType.Audio</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.Model</item></list>
   * Otherwise, it is ignored.
   */
  Url?: string | null
  /**
   * The Points of the annotation.This property is only used when Tabeeb.Web.Domain.Annotations.AnnotationCreateRequest.Type equals one of the following:
   * <list type="bullet"><item>Tabeeb.Shared.Common.Enums.AnnotationType.Distance</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.Height</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.Area</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.Polyline</item></list>
   * Otherwise, it is ignored.
   */
  Points?: Point[] | null
  Rotation?: EulerRotation
  Scale?: Scale
  /**
   * The id of the linked Page. This property is only used when Tabeeb.Web.Domain.Annotations.AnnotationCreateRequest.Type equals Tabeeb.Shared.Common.Enums.AnnotationType.LinkedPage.
   * Otherwise, it is ignored.
   * @format int32
   */
  LinkedPageId?: number | null
  /**
   * The duration of the audio of the annotation. This property is only used when Tabeeb.Web.Domain.Annotations.AnnotationCreateRequest.Type equals Tabeeb.Shared.Common.Enums.AnnotationType.Audio.
   * Otherwise, it is ignored.
   * @format float
   */
  Duration: number
  /**
   * The size of the audio of the annotation. This property is only used when Tabeeb.Web.Domain.Annotations.AnnotationCreateRequest.Type equals Tabeeb.Shared.Common.Enums.AnnotationType.Audio.
   * Otherwise, it is ignored.
   * @format int64
   */
  Size: number
  /**
   * This property is only used when Tabeeb.Web.Domain.Annotations.AnnotationCreateRequest.Type equals Tabeeb.Shared.Common.Enums.AnnotationType.AI.
   * Otherwise, it is ignored.
   */
  IsAIDetectCorrect?: boolean | null
  /**
   * This property is only used when Tabeeb.Web.Domain.Annotations.AnnotationCreateRequest.Type equals Tabeeb.Shared.Common.Enums.AnnotationType.AI.
   * Otherwise, it is ignored.
   */
  UserFeedback?: string | null
  /**
   * Unique id of the UniqueAIObject within the system. This property is only used when Tabeeb.Web.Domain.Annotations.AnnotationCreateRequest.Type equals Tabeeb.Shared.Common.Enums.AnnotationType.AI.
   * Otherwise, it is ignored.
   * @format int32
   */
  UniqueAIObjectId?: number | null
  /**
   * Unique id of the AIObject within the system. This property is only used when Tabeeb.Web.Domain.Annotations.AnnotationCreateRequest.Type equals Tabeeb.Shared.Common.Enums.AnnotationType.AI.
   * Otherwise, it is ignored.
   * @format int32
   */
  AIObjectId?: number | null
}

export interface AnnotationInfoResponse {
  /** @format int32 */
  Id: number
  /** @format int32 */
  PageId: number
  /** @format int32 */
  UserId: number
  /** @format int32 */
  ParentAnnotationId?: number | null
  /** @format int32 */
  CopyOfId?: number | null
  /**
   *
   *
   * 0 = StrokeDraw
   *
   * 1 = StrokeErase
   *
   * 2 = Laser
   *
   * 3 = Text
   *
   * 4 = Audio
   *
   * 5 = Text_Callout
   *
   * 6 = HotSpot
   *
   * 7 = LinkedPage
   *
   * 8 = AI
   *
   * 9 = AIHotspot
   *
   * 10 = Box
   *
   * 11 = Distance
   *
   * 12 = Model
   *
   * 13 = Height
   *
   * 14 = Area
   *
   * 15 = Cylinder
   *
   * 16 = Polyline
   *
   * 100 = StrokeDraw_Shape_Line
   *
   * 101 = StrokeDraw_Shape_Rectangle
   *
   * 102 = StrokeDraw_Shape_Ellipse
   *
   * 103 = StrokeDraw_Shape_Rectangle_Filled
   *
   * 104 = StrokeDraw_Shape_Ellipse_Filled
   *
   * 105 = StrokeDraw_Shape_Line_ArrowEnd
   *
   * 106 = StrokeDraw_Shape_Line_ArrowBoth
   *
   * 107 = Polygon
   */
  Type: AnnotationType
  IsDeleted: boolean
  /** @format date-time */
  CreatedOn?: string | null
  IsProcessed: boolean
  /** @format date-time */
  UpdatedOn?: string | null
  /** @format date-time */
  DeletedOn?: string | null
  Anchor?: Point
  Color?: string | null
  Coordinates?: Coordinates[] | null
  Points?: Point[] | null
  Rotation?: EulerRotation
  Scale?: Scale
  /** @format int32 */
  FontSize: number
  Text?: string | null
  /** @format float */
  Timestamp: number
  TopLeft?: Point
  /** @format float */
  Duration: number
  /** @format int32 */
  FormAnswerId?: number | null
  /** @format int32 */
  FormAnswererId?: number | null
  /** @format int32 */
  FormControlId?: number | null
  FormTabIds?: number[] | null
  /** @format int32 */
  FormId?: number | null
  /** @format int32 */
  LinkedPageId?: number | null
  /** @format int64 */
  Size: number
  /** @format float */
  TargetTimestamp: number
  /** @format int32 */
  Width: number
}

export interface AnnotationResponse {
  /** @format int32 */
  UserId: number
  User?: UserInfoResponse
  /** @format int32 */
  PageId: number
  /** @format int32 */
  ContentId: number
  /**
   *
   *
   * 0 = StrokeDraw
   *
   * 1 = StrokeErase
   *
   * 2 = Laser
   *
   * 3 = Text
   *
   * 4 = Audio
   *
   * 5 = Text_Callout
   *
   * 6 = HotSpot
   *
   * 7 = LinkedPage
   *
   * 8 = AI
   *
   * 9 = AIHotspot
   *
   * 10 = Box
   *
   * 11 = Distance
   *
   * 12 = Model
   *
   * 13 = Height
   *
   * 14 = Area
   *
   * 15 = Cylinder
   *
   * 16 = Polyline
   *
   * 100 = StrokeDraw_Shape_Line
   *
   * 101 = StrokeDraw_Shape_Rectangle
   *
   * 102 = StrokeDraw_Shape_Ellipse
   *
   * 103 = StrokeDraw_Shape_Rectangle_Filled
   *
   * 104 = StrokeDraw_Shape_Ellipse_Filled
   *
   * 105 = StrokeDraw_Shape_Line_ArrowEnd
   *
   * 106 = StrokeDraw_Shape_Line_ArrowBoth
   *
   * 107 = Polygon
   */
  Type: AnnotationType
  /** @format date-time */
  CreatedOn: string
  Color?: string | null
  /** @format double */
  Elevation: number
  /** @format int32 */
  Width: number
  Coordinates?: Coordinates[] | null
  /** @format int32 */
  FontSize: number
  TopLeft?: Point
  /** @format double */
  Azimuth: number
  Anchor?: Point
  Name?: string | null
  Text?: string | null
  /** @format double */
  Tilt: number
  /** @format float */
  Timestamp: number
  /** @format float */
  TargetTimestamp: number
  Url?: string | null
  /** @format int32 */
  ParentAnnotationId?: number | null
  Points?: Point[] | null
  Rotation?: EulerRotation
  Scale?: Scale
  /** @format int32 */
  LinkedPageId?: number | null
  /** @format float */
  Duration: number
  /** @format int64 */
  Size: number
  IsAIDetectCorrect?: boolean | null
  UserFeedback?: string | null
  /** @format int32 */
  Id: number
}

/**
 *
 *
 * 0 = StrokeDraw
 *
 * 1 = StrokeErase
 *
 * 2 = Laser
 *
 * 3 = Text
 *
 * 4 = Audio
 *
 * 5 = Text_Callout
 *
 * 6 = HotSpot
 *
 * 7 = LinkedPage
 *
 * 8 = AI
 *
 * 9 = AIHotspot
 *
 * 10 = Box
 *
 * 11 = Distance
 *
 * 12 = Model
 *
 * 13 = Height
 *
 * 14 = Area
 *
 * 15 = Cylinder
 *
 * 16 = Polyline
 *
 * 100 = StrokeDraw_Shape_Line
 *
 * 101 = StrokeDraw_Shape_Rectangle
 *
 * 102 = StrokeDraw_Shape_Ellipse
 *
 * 103 = StrokeDraw_Shape_Rectangle_Filled
 *
 * 104 = StrokeDraw_Shape_Ellipse_Filled
 *
 * 105 = StrokeDraw_Shape_Line_ArrowEnd
 *
 * 106 = StrokeDraw_Shape_Line_ArrowBoth
 *
 * 107 = Polygon
 * @format int32
 */
export enum AnnotationType {
  StrokeDraw = 0,
  StrokeErase = 1,
  Laser = 2,
  Text = 3,
  Audio = 4,
  TextCallout = 5,
  HotSpot = 6,
  LinkedPage = 7,
  AI = 8,
  AIHotspot = 9,
  Box = 10,
  Distance = 11,
  Model = 12,
  Height = 13,
  Area = 14,
  Cylinder = 15,
  Polyline = 16,
  StrokeDrawShapeLine = 100,
  StrokeDrawShapeRectangle = 101,
  StrokeDrawShapeEllipse = 102,
  StrokeDrawShapeRectangleFilled = 103,
  StrokeDrawShapeEllipseFilled = 104,
  StrokeDrawShapeLineArrowEnd = 105,
  StrokeDrawShapeLineArrowBoth = 106,
  Polygon = 107,
}

export interface AnnotationUpdateRequest {
  /**
   * Unique id of the Annotation within the system.
   * @format int32
   */
  Id: number
  /**
   * Unique id of the Page within the system.
   * @format int32
   */
  PageId: number
  /**
   *
   *
   * 0 = StrokeDraw
   *
   * 1 = StrokeErase
   *
   * 2 = Laser
   *
   * 3 = Text
   *
   * 4 = Audio
   *
   * 5 = Text_Callout
   *
   * 6 = HotSpot
   *
   * 7 = LinkedPage
   *
   * 8 = AI
   *
   * 9 = AIHotspot
   *
   * 10 = Box
   *
   * 11 = Distance
   *
   * 12 = Model
   *
   * 13 = Height
   *
   * 14 = Area
   *
   * 15 = Cylinder
   *
   * 16 = Polyline
   *
   * 100 = StrokeDraw_Shape_Line
   *
   * 101 = StrokeDraw_Shape_Rectangle
   *
   * 102 = StrokeDraw_Shape_Ellipse
   *
   * 103 = StrokeDraw_Shape_Rectangle_Filled
   *
   * 104 = StrokeDraw_Shape_Ellipse_Filled
   *
   * 105 = StrokeDraw_Shape_Line_ArrowEnd
   *
   * 106 = StrokeDraw_Shape_Line_ArrowBoth
   *
   * 107 = Polygon
   */
  Type: AnnotationType
  /**
   * The id of the parent annotation if this annotation is nested.
   * Null if there is no parent.
   * @format int32
   */
  ParentAnnotationId?: number | null
  /**
   * The color of the annotation. This property is `IGNORED` for the following annotation types:
   * <list type="bullet"><item>Tabeeb.Shared.Common.Enums.AnnotationType.AI</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.Audio</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.Model</item></list>
   * It is used for all other annotation types.
   */
  Color?: string | null
  /**
   * The elevation of the annotation. This property is only used when Tabeeb.Web.Domain.Annotations.AnnotationCreateRequest.Type equals one of the following:
   * <list type="bullet"><item>Tabeeb.Shared.Common.Enums.AnnotationType.Cylinder</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.Box</item></list>
   * Otherwise, it is ignored.
   * @format double
   */
  Elevation: number
  /**
   * The stroke width of the annotation.This property is only used when Tabeeb.Web.Domain.Annotations.AnnotationCreateRequest.Type equals one of the following:
   * <list type="bullet"><item>Tabeeb.Shared.Common.Enums.AnnotationType.StrokeDraw_Shape_Line</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.StrokeDraw_Shape_Rectangle</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.StrokeDraw_Shape_Ellipse</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.StrokeDraw_Shape_Rectangle_Filled</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.StrokeDraw_Shape_Ellipse_Filled</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.StrokeDraw_Shape_Line_ArrowEnd</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.StrokeDraw_Shape_Line_ArrowBoth</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.Polygon</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.Text</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.Text_Callout</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.Cylinder</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.Box</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.Distance</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.Height</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.Area</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.Polyline</item></list>
   * Otherwise, it is ignored.
   * @format int32
   */
  Width: number
  /**
   * The coordinates of the annotation.This property is only used when Tabeeb.Web.Domain.Annotations.AnnotationCreateRequest.Type equals one of the following:
   * <list type="bullet"><item>Tabeeb.Shared.Common.Enums.AnnotationType.StrokeDraw_Shape_Line</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.StrokeDraw_Shape_Rectangle</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.StrokeDraw_Shape_Ellipse</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.StrokeDraw_Shape_Rectangle_Filled</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.StrokeDraw_Shape_Ellipse_Filled</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.StrokeDraw_Shape_Line_ArrowEnd</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.StrokeDraw_Shape_Line_ArrowBoth</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.Polygon</item></list>
   * Otherwise, it is ignored.
   */
  Coordinates?: Coordinates[] | null
  /**
   * The font size of the annotation.This property is only used when Tabeeb.Web.Domain.Annotations.AnnotationCreateRequest.Type equals one of the following:
   * <list type="bullet"><item>Tabeeb.Shared.Common.Enums.AnnotationType.Text</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.Text_Callout</item></list>
   * Otherwise, it is ignored.
   * @format int32
   */
  FontSize: number
  TopLeft?: Point
  /**
   * The Azimuth of the annotation.This property is only used when Tabeeb.Web.Domain.Annotations.AnnotationCreateRequest.Type equals Tabeeb.Shared.Common.Enums.AnnotationType.Model.
   * Otherwise, it is ignored.
   * @format double
   */
  Azimuth: number
  Anchor?: Point
  /**
   * The name of the annotation.This property is only used when Tabeeb.Web.Domain.Annotations.AnnotationCreateRequest.Type equals one of the following:
   * <list type="bullet"><item>Tabeeb.Shared.Common.Enums.AnnotationType.StrokeDraw_Shape_Line</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.StrokeDraw_Shape_Rectangle</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.StrokeDraw_Shape_Ellipse</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.StrokeDraw_Shape_Rectangle_Filled</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.StrokeDraw_Shape_Ellipse_Filled</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.StrokeDraw_Shape_Line_ArrowEnd</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.StrokeDraw_Shape_Line_ArrowBoth</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.Polygon</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.AIHotspot</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.Model</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.Box</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.Cylinder</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.Distance</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.Height</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.Area</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.Polyline</item></list>
   * Otherwise, it is ignored.
   */
  Name?: string | null
  /**
   * The text of the annotation.This property is only used when Tabeeb.Web.Domain.Annotations.AnnotationCreateRequest.Type equals one of the following:
   * <list type="bullet"><item>Tabeeb.Shared.Common.Enums.AnnotationType.Text</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.Text_Callout</item></list>
   * Otherwise, it is ignored.
   */
  Text?: string | null
  /**
   * The tilt of the annotation.This property is only used when Tabeeb.Web.Domain.Annotations.AnnotationCreateRequest.Type equals Tabeeb.Shared.Common.Enums.AnnotationType.Model.
   * Otherwise, it is ignored.
   * @format double
   */
  Tilt: number
  /**
   * The timestamp of the annotation.This property is only used when Tabeeb.Web.Domain.Annotations.AnnotationCreateRequest.Type equals one of the following:
   * <list type="bullet"><item>Tabeeb.Shared.Common.Enums.AnnotationType.StrokeDraw_Shape_Line</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.StrokeDraw_Shape_Rectangle</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.StrokeDraw_Shape_Ellipse</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.StrokeDraw_Shape_Rectangle_Filled</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.StrokeDraw_Shape_Ellipse_Filled</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.StrokeDraw_Shape_Line_ArrowEnd</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.StrokeDraw_Shape_Line_ArrowBoth</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.Polygon</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.Text</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.Text_Callout</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.Audio</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.HotSpot</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.LinkedPage</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.AI</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.AIHotspot</item></list>
   * Otherwise, it is ignored.
   * @format float
   */
  Timestamp: number
  /**
   * The TargetTimestamp of the annotation.This property is only used when Tabeeb.Web.Domain.Annotations.AnnotationCreateRequest.Type equals Tabeeb.Shared.Common.Enums.AnnotationType.LinkedPage.
   * Otherwise, it is ignored.
   * @format float
   */
  TargetTimestamp: number
  /**
   * The Url of the annotation.This property is only used when Tabeeb.Web.Domain.Annotations.AnnotationCreateRequest.Type equals one of the following:
   * <list type="bullet"><item>Tabeeb.Shared.Common.Enums.AnnotationType.Audio</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.Model</item></list>
   * Otherwise, it is ignored.
   */
  Url?: string | null
  /**
   * The Points of the annotation.This property is only used when Tabeeb.Web.Domain.Annotations.AnnotationCreateRequest.Type equals one of the following:
   * <list type="bullet"><item>Tabeeb.Shared.Common.Enums.AnnotationType.Distance</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.Height</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.Area</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.Polyline</item></list>
   * Otherwise, it is ignored.
   */
  Points?: Point[] | null
  Rotation?: EulerRotation
  Scale?: Scale
  /**
   * The id of the linked Page. This property is only used when Tabeeb.Web.Domain.Annotations.AnnotationCreateRequest.Type equals Tabeeb.Shared.Common.Enums.AnnotationType.LinkedPage.
   * Otherwise, it is ignored.
   * @format int32
   */
  LinkedPageId?: number | null
  /**
   * The duration of the audio of the annotation. This property is only used when Tabeeb.Web.Domain.Annotations.AnnotationCreateRequest.Type equals Tabeeb.Shared.Common.Enums.AnnotationType.Audio.
   * Otherwise, it is ignored.
   * @format float
   */
  Duration: number
  /**
   * The size of the audio of the annotation. This property is only used when Tabeeb.Web.Domain.Annotations.AnnotationCreateRequest.Type equals Tabeeb.Shared.Common.Enums.AnnotationType.Audio.
   * Otherwise, it is ignored.
   * @format int64
   */
  Size: number
  /**
   * This property is only used when Tabeeb.Web.Domain.Annotations.AnnotationCreateRequest.Type equals Tabeeb.Shared.Common.Enums.AnnotationType.AI.
   * Otherwise, it is ignored.
   */
  IsAIDetectCorrect?: boolean | null
  /**
   * This property is only used when Tabeeb.Web.Domain.Annotations.AnnotationCreateRequest.Type equals Tabeeb.Shared.Common.Enums.AnnotationType.AI.
   * Otherwise, it is ignored.
   */
  UserFeedback?: string | null
  /**
   * Unique id of the UniqueAIObject within the system. This property is only used when Tabeeb.Web.Domain.Annotations.AnnotationCreateRequest.Type equals Tabeeb.Shared.Common.Enums.AnnotationType.AI.
   * Otherwise, it is ignored.
   * @format int32
   */
  UniqueAIObjectId?: number | null
  /**
   * Unique id of the AIObject within the system. This property is only used when Tabeeb.Web.Domain.Annotations.AnnotationCreateRequest.Type equals Tabeeb.Shared.Common.Enums.AnnotationType.AI.
   * Otherwise, it is ignored.
   * @format int32
   */
  AIObjectId?: number | null
}

export interface AnnotationsDeleteRequest {
  /** @minItems 1 */
  AnnotationIds: number[]
}

export interface AnnotationsFromStructureModelCreateRequest {
  /** @format int32 */
  ContentId: number
  /** @format int32 */
  UserId: number
  UniqueObjects: UniqueAIObjectFromStructureModelCreateRequest[]
}

export interface AnnotationsRestoreRequest {
  /** @minItems 1 */
  AnnotationIds: number[]
}

export interface ApiErrorResponse {
  Error: Error
}

export interface AppointmentSlotBookRequest {
  /**
   * Unique id of the session within the system
   * @format int32
   */
  ContentId?: number | null
  /**
   * Title of the event
   * @maxLength 120
   */
  Title?: string | null
  /**
   * Description of the event
   * @maxLength 120
   */
  Description?: string | null
  /**
   * Start date of the event
   * @format date-time
   */
  StartDate: string
  /**
   * End date of the event
   * @format date-time
   */
  EndDate: string
}

export interface AppointmentSlotsCreateRequest {
  /**
   * Appointments slots interval in minutes
   * @format int32
   * @min 1
   * @max 2147483647
   */
  Interval: number
  /**
   * Title of the event
   * @maxLength 120
   */
  Title?: string | null
  /**
   * Description of the event
   * @maxLength 120
   */
  Description?: string | null
  /**
   * Start date of the event
   * @format date-time
   */
  StartDate: string
  /**
   * End date of the event
   * @format date-time
   */
  EndDate: string
}

export interface ApprovalIdRequest {
  /** @format int32 */
  NotificationId: number
  /** @format int32 */
  ContentSharingId?: number | null
  /** @format int32 */
  BillingActivityId?: number | null
}

export interface ApprovalRequest {
  /** @format int32 */
  Id: number
  /** @format int32 */
  UserId: number
  /** @format int32 */
  ContentId: number
  /** @format int32 */
  NotificationId: number
  Approver?: ApprovalUserModelRequest
  Requestor?: ApprovalUserModelRequest
  Accepted: boolean
  Ignored: boolean
  IsProcessing: boolean
  Description?: string | null
  /** @format int32 */
  InvitationId?: number | null
  /** @format int32 */
  BillingActivityId?: number | null
  /** @format int32 */
  ContentSharingId?: number | null
  /** @format int32 */
  CalendarEventId?: number | null
  /** @format int32 */
  ContentsLinkId?: number | null
  /** @format int32 */
  TrainingMaterialId: number
  /** @format int32 */
  ContentTrainingMaterialId: number
  /** @format int32 */
  ContentFormId: number
  /** @format int32 */
  SessionId: number
  SessionName?: string | null
  UserName?: string | null
  /**
   *
   *
   * 0 = Created
   *
   * 1 = Pending
   *
   * 2 = Rejected
   */
  ContentStatus: ContentStatus
  /**
   *
   *
   * 100 = InviteToContent
   *
   * 200 = ContentActivity
   *
   * 300 = ChatMessage
   *
   * 400 = StartCall
   *
   * 500 = YouNewOwner
   *
   * 600 = YouOldOwner
   *
   * 700 = ApprovalResult
   *
   * 800 = ShareContent
   *
   * 810 = MergeContent
   *
   * 900 = AlertOwner
   *
   * 1000 = ReviewContent
   *
   * 1010 = ContentReviewResumed
   *
   * 1020 = InContentReview
   *
   * 1100 = YouNewReviewer
   *
   * 1200 = YouOldReviewer
   *
   * 1300 = ReviewCompleted
   *
   * 1310 = ReviewFeedback
   *
   * 1320 = AnswerApproved
   *
   * 1330 = AnswerRejected
   *
   * 1400 = AddUserToContent
   *
   * 1500 = AnswerQuestionReminder
   *
   * 1600 = AddUsersToFolder
   *
   * 1800 = LinkContentsApprovalResult
   *
   * 1900 = UnreadTrainingMaterialReminder
   *
   * 1910 = TrainingMaterialAssigned
   *
   * 2000 = MyCertificateExpiration
   *
   * 2005 = UserCertificateExpiration
   *
   * 2010 = QualificationExpiration
   *
   * 2020 = MyUserQualificationExpiration
   *
   * 2025 = UserQualificationExpiration
   *
   * 2030 = ContractExpiration
   *
   * 2035 = WebCallRingNotification
   */
  NotificationType: NotificationTypeEnum
  NotificationData?: string | null
  /** @format date-time */
  UpdatedOn?: string | null
  CanBeRevoked: boolean
  FolderName?: string | null
  /**
   *
   *
   * 0 = Shared
   *
   * 1 = Published
   *
   * 2 = ForReview
   *
   * 3 = ContentsMerging
   *
   * 4 = LinkedContentsMerging
   *
   * 5 = MergeForReview
   *
   * 6 = MergeReviewedData
   */
  ContentSharingType: ContentSharingType
  /**
   *
   *
   * 0 = Event
   *
   * 1 = Appointment
   *
   * 2 = AppointmentSlots
   */
  CalendarEventType: CalendarEventType
  CalendarEventName?: string | null
  TargetContentName?: string | null
  /**
   *
   *
   * 0 = Invitation
   *
   * 1 = SessionApproval
   *
   * 2 = ChangeOwner
   *
   * 3 = ShareContent
   *
   * 4 = Notification
   *
   * 5 = Reminder
   *
   * 6 = CalendarEvent
   */
  Type: ApprovalRequestType
  IsReminderNotification: boolean
  IsApprovingReminderNotification: boolean
  IsContentSharingNotification: boolean
  IsTrainingMaterialNotification: boolean
  NeedApprove: boolean
}

/**
 *
 *
 * 0 = Invitation
 *
 * 1 = SessionApproval
 *
 * 2 = ChangeOwner
 *
 * 3 = ShareContent
 *
 * 4 = Notification
 *
 * 5 = Reminder
 *
 * 6 = CalendarEvent
 * @format int32
 */
export enum ApprovalRequestType {
  Invitation = 0,
  SessionApproval = 1,
  ChangeOwner = 2,
  ShareContent = 3,
  Notification = 4,
  Reminder = 5,
  CalendarEvent = 6,
}

export interface ApprovalUserModelRequest {
  /** @format int32 */
  Id: number
  Name?: string | null
  Email?: string | null
}

export interface AssetRequest {
  /** @maxLength 256 */
  Name?: string | null
  /**
   *
   *
   * 0 = Unknown
   *
   * 1 = Image
   *
   * 2 = Video
   *
   * 3 = Preview
   *
   * 4 = Audio
   *
   * 5 = CloudFile
   *
   * 6 = RecordedVideo
   *
   * 7 = Thumbnail
   *
   * 10 = Snapshot
   *
   * 11 = ConcatenatedVideo
   *
   * 12 = WebPage
   *
   * 13 = SpatialModelImage
   *
   * 14 = DocDocument
   *
   * 15 = PptDocument
   *
   * 16 = ExcelDocument
   *
   * 17 = File
   *
   * 18 = StructureModel
   *
   * 20 = TwoDLineDrawing
   *
   * 22 = AutodeskFile
   *
   * 23 = PointCloud
   *
   * 24 = PotreePointCloud
   *
   * 101 = UnencodedVideo
   *
   * 102 = UnencodedRecordedVideo
   *
   * 103 = UnencodedConcatenatedVideo
   *
   * 104 = RecordedCloudFileVideo
   *
   * 105 = StreamVideo
   */
  Type: AssetType
  /** @maxLength 4000 */
  Url?: string | null
  CompressedMediaUrls?: CompressedMediaUrlResponse[] | null
  Metadata?: MetadataResponse
  /** @format int32 */
  PageId: number
  /** @format double */
  Latitude?: number | null
  /** @format double */
  Longitude?: number | null
  /** @format int64 */
  Size?: number | null
  /** @format int32 */
  Duration?: number | null
  /** @format date-time */
  OriginalCreatedOn?: string | null
  /** @format int32 */
  Order: number
  /** @format int32 */
  LinkedPageId?: number | null
  /** @format int32 */
  CopyOfId?: number | null
  /**
   *
   *
   * 0 = NotCreated
   *
   * 1 = ModelCreating
   *
   * 2 = ModelCreated
   */
  MeasurementStatus: PointCloudModelStatus
  /** @format int32 */
  Id: number
}

export interface AssetResponse {
  /** @format int32 */
  Id: number
  /** @maxLength 256 */
  Name?: string | null
  /**
   *
   *
   * 0 = Unknown
   *
   * 1 = Image
   *
   * 2 = Video
   *
   * 3 = Preview
   *
   * 4 = Audio
   *
   * 5 = CloudFile
   *
   * 6 = RecordedVideo
   *
   * 7 = Thumbnail
   *
   * 10 = Snapshot
   *
   * 11 = ConcatenatedVideo
   *
   * 12 = WebPage
   *
   * 13 = SpatialModelImage
   *
   * 14 = DocDocument
   *
   * 15 = PptDocument
   *
   * 16 = ExcelDocument
   *
   * 17 = File
   *
   * 18 = StructureModel
   *
   * 20 = TwoDLineDrawing
   *
   * 22 = AutodeskFile
   *
   * 23 = PointCloud
   *
   * 24 = PotreePointCloud
   *
   * 101 = UnencodedVideo
   *
   * 102 = UnencodedRecordedVideo
   *
   * 103 = UnencodedConcatenatedVideo
   *
   * 104 = RecordedCloudFileVideo
   *
   * 105 = StreamVideo
   */
  Type: AssetType
  /** @maxLength 4000 */
  Url?: string | null
  CompressedMediaUrls?: CompressedMediaUrlResponse[] | null
  Metadata?: MetadataResponse
  /** @format int32 */
  PageId: number
  /** @format double */
  Latitude?: number | null
  /** @format double */
  Longitude?: number | null
  /** @format int64 */
  Size?: number | null
  /** @format int32 */
  Duration?: number | null
  /** @format date-time */
  OriginalCreatedOn?: string | null
  /** @format int32 */
  Order: number
  /** @format int32 */
  LinkedPageId?: number | null
  /** @format int32 */
  CopyOfId?: number | null
  /**
   *
   *
   * 0 = NotCreated
   *
   * 1 = ModelCreating
   *
   * 2 = ModelCreated
   */
  MeasurementStatus: PointCloudModelStatus
}

/**
 *
 *
 * 0 = Unknown
 *
 * 1 = Image
 *
 * 2 = Video
 *
 * 3 = Preview
 *
 * 4 = Audio
 *
 * 5 = CloudFile
 *
 * 6 = RecordedVideo
 *
 * 7 = Thumbnail
 *
 * 10 = Snapshot
 *
 * 11 = ConcatenatedVideo
 *
 * 12 = WebPage
 *
 * 13 = SpatialModelImage
 *
 * 14 = DocDocument
 *
 * 15 = PptDocument
 *
 * 16 = ExcelDocument
 *
 * 17 = File
 *
 * 18 = StructureModel
 *
 * 20 = TwoDLineDrawing
 *
 * 22 = AutodeskFile
 *
 * 23 = PointCloud
 *
 * 24 = PotreePointCloud
 *
 * 101 = UnencodedVideo
 *
 * 102 = UnencodedRecordedVideo
 *
 * 103 = UnencodedConcatenatedVideo
 *
 * 104 = RecordedCloudFileVideo
 *
 * 105 = StreamVideo
 * @format int32
 */
export enum AssetType {
  Unknown = 0,
  Image = 1,
  Video = 2,
  Preview = 3,
  Audio = 4,
  CloudFile = 5,
  RecordedVideo = 6,
  Thumbnail = 7,
  Snapshot = 10,
  ConcatenatedVideo = 11,
  WebPage = 12,
  SpatialModelImage = 13,
  DocDocument = 14,
  PptDocument = 15,
  ExcelDocument = 16,
  File = 17,
  StructureModel = 18,
  TwoDLineDrawing = 20,
  AutodeskFile = 22,
  PointCloud = 23,
  PotreePointCloud = 24,
  UnencodedVideo = 101,
  UnencodedRecordedVideo = 102,
  UnencodedConcatenatedVideo = 103,
  RecordedCloudFileVideo = 104,
  StreamVideo = 105,
}

export interface AttachFormRequest {
  /**
   * The id of a session.
   * @format int32
   */
  ContentId: number
  /**
   * The id of attached form.
   * @format int32
   */
  FormId: number
  IsAttachedFromCondition: boolean
}

export interface AttachFormToTenantRequest {
  Subdomain?: string | null
  /** @format int32 */
  FormId: number
}

export interface AttachFormsRequest {
  /**
   * The id of a session.
   * @format int32
   */
  ContentId: number
  /** The list of Ids of attached forms. */
  FormsId: number[]
}

export interface BaseUserInfoResponse {
  /** @format int32 */
  Id: number
  Name?: string | null
  UserName?: string | null
  FirstName?: string | null
  LastName?: string | null
  Email?: string | null
  AvatarUrl?: string | null
  IsAccountDeleted: boolean
}

export interface BaseUserInfoWithoutAvatarResponse {
  AvatarUrl?: string | null
  /** @format int32 */
  Id: number
  Name?: string | null
  UserName?: string | null
  FirstName?: string | null
  LastName?: string | null
  Email?: string | null
  IsAccountDeleted: boolean
}

export interface BentleyBoundingBoxModel {
  IsAuto: boolean
  /**
   * Imperial feet. Only used when IsAuto set to false.
   * @format int32
   */
  Width?: number | null
  /**
   * Imperial feet. Only used when IsAuto set to false.
   * @format int32
   */
  Height?: number | null
}

export interface BentleySettingsModel {
  BoundingBox?: BentleyBoundingBoxModel
}

export interface BoundingBoxFromStructureModelCreateRequest {
  /** @format double */
  Left: number
  /** @format double */
  Top: number
  /** @format double */
  Width: number
  /** @format double */
  Height: number
}

export interface CalendarEventAttachedContentModel {
  ThumbnailUrl?: string | null
  /** @format date-time */
  CreatedOn: string
  Owner?: BaseUserInfoWithoutAvatarResponse
  Description?: string | null
  /** @format int32 */
  Id: number
}

export interface CalendarEventAttendeeModel {
  /** @format int32 */
  UserId: number
  User?: BaseUserInfoResponse
  /**
   *
   *
   * 0 = Pending
   *
   * 1 = Declined
   *
   * 2 = Accepted
   */
  Status: CalendarEventAttendeeStatus
  /** @format int32 */
  Id: number
}

/**
 *
 *
 * 0 = Pending
 *
 * 1 = Declined
 *
 * 2 = Accepted
 * @format int32
 */
export enum CalendarEventAttendeeStatus {
  Pending = 0,
  Declined = 1,
  Accepted = 2,
}

export interface CalendarEventBaseResponse {
  /**
   * Creation time of the event
   * @format date-time
   */
  CreatedOn?: string | null
  /**
   * Last modification time of the event
   * @format date-time
   */
  UpdatedOn?: string | null
  IsDeleted: boolean
  /**
   * Start date of the event
   * @format date-time
   */
  StartDate: string
  /**
   * End date of the event
   * @format date-time
   */
  EndDate: string
  /** Title of the event */
  Title?: string | null
  /**
   *
   *
   * 0 = Public
   *
   * 1 = Private
   */
  Visibility: CalendarEventVisibility
  /**
   *
   *
   * 0 = Opaque
   *
   * 1 = Transparent
   */
  Transparency: CalendarEventTransparency
  Recurrence?: string | null
  /**
   *
   *
   * 0 = Event
   *
   * 1 = Appointment
   *
   * 2 = AppointmentSlots
   */
  Type: CalendarEventType
  /**
   * Appointment slots interval in minutes
   * @format int32
   */
  Interval?: number | null
  /**
   * Event creator id
   * @format int32
   */
  UserId: number
  /** @format int32 */
  Id: number
}

export interface CalendarEventContentUpdateRequest {
  /** @format int32 */
  ContentId?: number | null
}

export interface CalendarEventCreateRequest {
  /**
   *
   *
   * 0 = Public
   *
   * 1 = Private
   */
  Visibility: CalendarEventVisibility
  /**
   *
   *
   * 0 = Opaque
   *
   * 1 = Transparent
   */
  Transparency: CalendarEventTransparency
  /**
   * List of RRULE, EXRULE, RDATE and EXDATE lines for a recurring event, as specified in RFC5545. This field is omitted for single events.
   *
   * Examples:
   * - "RRULE:FREQ=DAILY;UNTIL=20231110T023500Z" - A recurring event that occurs daily until 10th of November 10, 2023;
   * - "RRULE:FREQ=WEEKLY;COUNT=10;BYDAY=MO,WE,FR" - A recurring event that repeats weekly on Mondays, Wednesdays, and Fridays for a total of 10 occurrences;
   * - "RRULE:FREQ=MONTHLY;COUNT=12" - A recurring event that repeats monthly, producing a total of 12 occurrences;
   * - "RRULE:FREQ=YEARLY" - A recurring event that repeats yearly.
   */
  Recurrence?: string | null
  /**
   * Unique id of the session within the system
   * @format int32
   */
  ContentId?: number | null
  /** Participants ids */
  Attendees?: number[] | null
  /**
   * Title of the event
   * @maxLength 120
   */
  Title?: string | null
  /**
   * Description of the event
   * @maxLength 120
   */
  Description?: string | null
  /**
   * Start date of the event
   * @format date-time
   */
  StartDate: string
  /**
   * End date of the event
   * @format date-time
   */
  EndDate: string
}

export interface CalendarEventDateUpdateRequest {
  /**
   * Event start date
   * @format date-time
   */
  StartDate: string
  /**
   * Event end date
   * @format date-time
   */
  EndDate: string
}

export interface CalendarEventOwnerUpdateRequest {
  /** @format int32 */
  UserId: number
}

export interface CalendarEventResponse {
  User?: BaseUserInfoResponse
  /** Description of the event */
  Description?: string | null
  /**
   * Unique id of the session within the system
   * @format int32
   */
  ContentId?: number | null
  Content?: CalendarEventAttachedContentModel
  /** Event attendees */
  Attendees?: CalendarEventAttendeeModel[] | null
  /**
   * Creation time of the event
   * @format date-time
   */
  CreatedOn?: string | null
  /**
   * Last modification time of the event
   * @format date-time
   */
  UpdatedOn?: string | null
  IsDeleted: boolean
  /**
   * Start date of the event
   * @format date-time
   */
  StartDate: string
  /**
   * End date of the event
   * @format date-time
   */
  EndDate: string
  /** Title of the event */
  Title?: string | null
  /**
   *
   *
   * 0 = Public
   *
   * 1 = Private
   */
  Visibility: CalendarEventVisibility
  /**
   *
   *
   * 0 = Opaque
   *
   * 1 = Transparent
   */
  Transparency: CalendarEventTransparency
  Recurrence?: string | null
  /**
   *
   *
   * 0 = Event
   *
   * 1 = Appointment
   *
   * 2 = AppointmentSlots
   */
  Type: CalendarEventType
  /**
   * Appointment slots interval in minutes
   * @format int32
   */
  Interval?: number | null
  /**
   * Event creator id
   * @format int32
   */
  UserId: number
  /** @format int32 */
  Id: number
}

/**
 *
 *
 * 0 = Opaque
 *
 * 1 = Transparent
 * @format int32
 */
export enum CalendarEventTransparency {
  Opaque = 0,
  Transparent = 1,
}

/**
 *
 *
 * 0 = Event
 *
 * 1 = Appointment
 *
 * 2 = AppointmentSlots
 * @format int32
 */
export enum CalendarEventType {
  Event = 0,
  Appointment = 1,
  AppointmentSlots = 2,
}

export interface CalendarEventUpdateRequest {
  /**
   * Title of the event
   * @maxLength 120
   */
  Title?: string | null
  /**
   * Description of the event
   * @maxLength 120
   */
  Description?: string | null
  /**
   * Start date of the event
   * @format date-time
   */
  StartDate: string
  /**
   * End date of the event
   * @format date-time
   */
  EndDate: string
  /**
   *
   *
   * 0 = Public
   *
   * 1 = Private
   */
  Visibility: CalendarEventVisibility
  /**
   *
   *
   * 0 = Opaque
   *
   * 1 = Transparent
   */
  Transparency: CalendarEventTransparency
  /**
   * Appointments slots interval in minutes
   * @format int32
   * @min 1
   * @max 2147483647
   */
  Interval?: number | null
  /**
   * Unique id of the session within the system
   * @format int32
   */
  ContentId?: number | null
  /** Event attendees */
  Attendees?: number[] | null
}

/**
 *
 *
 * 0 = Public
 *
 * 1 = Private
 * @format int32
 */
export enum CalendarEventVisibility {
  Public = 0,
  Private = 1,
}

/**
 *
 *
 * 0 = Hide
 *
 * 1 = Display
 *
 * 2 = DisplayThisOnly
 * @format int32
 */
export enum CalendarSubscriptionDisplayMode {
  Hide = 0,
  Display = 1,
  DisplayThisOnly = 2,
}

export interface CalendarSubscriptionResponse {
  /** Whether the calendar content shows up in the calendar UI */
  Enabled: boolean
  /** The main color of the calendar in the hexadecimal format */
  Color?: string | null
  /**
   * Unique id of the user within the system
   * @format int32
   */
  CalendarOwnerId: number
  CalendarOwner?: BaseUserInfoResponse
}

/**
 *
 *
 * 1 = UserCertificate
 *
 * 2 = ProfileCertificate
 *
 * 3 = TenantCertificate
 * @format int32
 */
export enum CertificateScopeType {
  UserCertificate = 1,
  ProfileCertificate = 2,
  TenantCertificate = 3,
}

/**
 *
 *
 * 1 = PendingReview
 *
 * 2 = Approved
 *
 * 3 = Rejected
 *
 * 4 = Expired
 *
 * 5 = Draft
 *
 * 6 = Obsolete
 *
 * 7 = Processed
 * @format int32
 */
export enum CertificateStatusType {
  PendingReview = 1,
  Approved = 2,
  Rejected = 3,
  Expired = 4,
  Draft = 5,
  Obsolete = 6,
  Processed = 7,
}

export interface ChangeUserRoleRequest {
  /** @format int32 */
  UserId: number
  /** @format int32 */
  TenantId: number
  /** @minLength 1 */
  Role: string
}

export interface ChatInfoResponse {
  /**
   * Unique id of the user within the system
   * @format int32
   */
  UserId?: number | null
  /**
   * Exact day and time (in UTC) of the last message
   * @format date-time
   */
  LastMessageDate: string
  /**
   * Last readed message id
   * @format int32
   */
  LastReadedMessageId?: number | null
  /**
   * Last readed message date
   * @format date-time
   */
  LastReadedMessageDate?: string | null
  /**
   * Unread messages count
   * @format int32
   */
  UnreadedMessagesCount: number
}

export interface ChatMessageAssetResponse {
  /**
   *
   *
   * 0 = Unknown
   *
   * 1 = Audio
   */
  Type: ChatMessageAssetType
  /** @maxLength 4000 */
  Url?: string | null
  /** @format int32 */
  Duration: number
  /** @format int32 */
  Id: number
}

/**
 *
 *
 * 0 = Unknown
 *
 * 1 = Audio
 * @format int32
 */
export enum ChatMessageAssetType {
  Unknown = 0,
  Audio = 1,
}

export interface ChatMessageResponse {
  /** @format int32 */
  UserId: number
  User?: BaseUserInfoResponse
  /** @format int32 */
  ContentId: number
  Message?: string | null
  Translations?: Record<string, string | null>
  Asset?: ChatMessageAssetResponse
  /** @format date-time */
  CreatedOn: string
  /** @format int32 */
  ReceiverId?: number | null
  Receiver?: BaseUserInfoWithoutAvatarResponse
  /** @format int32 */
  TopicId: number
  /**
   *
   *
   * 1 = Session
   *
   * 2 = Page
   *
   * 3 = FormAnswer
   */
  TopicType: TopicType
  /** @format int32 */
  Id: number
}

export interface ChatMessageTranslationRequest {
  /**
   * Unique id of chat message within the system
   * @format int32
   */
  MessageId: number
  /**
   * Short language name
   * @minLength 1
   */
  TargetLanguage: string
}

export interface CheckAIAnnotationsExistanceRequest {
  /** @format int32 */
  ContentId: number
  PageIds: number[]
}

export interface CheckAIAnnotationsExistanceResponse {
  /** @format int32 */
  AnnotationId: number
  /** @format int32 */
  PageId: number
}

export interface CheckConditionsRequest {
  /** @format int32 */
  ContentId: number
  /** @format int32 */
  UserId?: number | null
}

export interface CheckFormControlConditionsRequest {
  /** @format int32 */
  UserId: number
  /** @format int32 */
  FormControlId: number
  Value?: string | null
  /** @format int32 */
  CheckedFormControlOptionId?: number | null
}

export interface ClassificationAnnotationRequest {
  /**
   * Unique id of the Page within the system.
   * @format int32
   */
  PageId: number
  /**
   * Unique id of the AIObject within the system.
   * @format int32
   */
  AIObjectId: number
  /**
   * The Color of the AIObject.
   * @minLength 1
   */
  Color: string
}

export interface CompressedMediaUrlResponse {
  /** @format int32 */
  AssetId: number
  /**
   *
   *
   * 0 = Unscaled
   *
   * 1 = Scaled
   *
   * 2 = Lowest
   */
  CompressionType: CompressionType
  Url?: string | null
  /** @format int32 */
  Id: number
}

/**
 *
 *
 * 0 = Unscaled
 *
 * 1 = Scaled
 *
 * 2 = Lowest
 * @format int32
 */
export enum CompressionType {
  Unscaled = 0,
  Scaled = 1,
  Lowest = 2,
}

export interface ConditionRecipientResponse {
  /**
   *
   *
   * 1 = AllParticipant
   *
   * 2 = SessionOwner
   *
   * 3 = SpecificUsers
   */
  Type: SendEmailConditionType
  Recipients?: RecipientResponse[] | null
}

/**
 *
 *
 * 0 = AnyEntry
 *
 * 1 = Equals
 *
 * 2 = GreaterThan
 *
 * 3 = LessThan
 *
 * 4 = UnansweredQuestions
 * @format int32
 */
export enum ConditionTriggerType {
  AnyEntry = 0,
  Equals = 1,
  GreaterThan = 2,
  LessThan = 3,
  UnansweredQuestions = 4,
}

/**
 *
 *
 * 0 = Unknown
 *
 * 1 = AttachForm
 *
 * 2 = SendEmail
 *
 * 3 = AddVideoByUrl
 *
 * 4 = ShowInfoMessage
 *
 * 5 = RunWorkflow
 * @format int32
 */
export enum ConditionType {
  Unknown = 0,
  AttachForm = 1,
  SendEmail = 2,
  AddVideoByUrl = 3,
  ShowInfoMessage = 4,
  RunWorkflow = 5,
}

export interface ConditionsRecipientRequest {
  /**
   *
   *
   * 1 = AllParticipant
   *
   * 2 = SessionOwner
   *
   * 3 = SpecificUsers
   */
  Type: SendEmailConditionType
  Recipients?: RecipientRequest[] | null
}

export interface ConditionsResponse {
  /** @format int32 */
  Id: number
  /**
   *
   *
   * 0 = Unknown
   *
   * 1 = AttachForm
   *
   * 2 = SendEmail
   *
   * 3 = AddVideoByUrl
   *
   * 4 = ShowInfoMessage
   *
   * 5 = RunWorkflow
   */
  Type: ConditionType
  Solution?: string | null
  TriggerValue?: string | null
  /**
   *
   *
   * 0 = AnyEntry
   *
   * 1 = Equals
   *
   * 2 = GreaterThan
   *
   * 3 = LessThan
   *
   * 4 = UnansweredQuestions
   */
  TriggerType: ConditionTriggerType
  ConditionsRecipient?: ConditionRecipientResponse[] | null
}

export interface ContentActivateRequest {
  /**
   * Unique id of the content within the system
   * @format int32
   */
  ContentId: number
}

export interface ContentByDescriptionRequest {
  /**
   * The name of the session.
   * @minLength 1
   * @maxLength 4000
   */
  Description: string
  /**
   * The Id of the tenant where the session should be found.
   *
   * If missing, then data for the user's tenant is returned.
   * @format int32
   */
  TenantId?: number | null
  /**
   * Parameter for defining whether to include deleted sessions or not.
   * @default false
   */
  IncludeDeleted: boolean
}

export interface ContentByDescriptionResponse {
  /**
   * Unique id of the session within the system.
   * @format int32
   */
  Id: number
  /**
   * The name of the session.
   * @minLength 1
   */
  Description: string
  /**
   * Exact day and time (in UTC) when a particular session was created.
   * @format date-time
   */
  CreatedOn: string
  /** Defines whether the session is deleted or not. */
  IsDeleted: boolean
}

export interface ContentCreateRequest {
  /**
   * The name of created session.
   * @maxLength 4000
   */
  Description?: string | null
  /**
   * The id of the session folder.
   * @format int32
   */
  FolderId?: number | null
  Documents?: DocumentCreateRequest[] | null
  /** @format int32 */
  ProgramId?: number | null
  /** Array of objects, required for displaying session name in json format in reports (if session name created using naming convention). */
  ContentNameParts?: ContentNamePartRequest[] | null
  /**
   * Storage that will be used to store all the content of the session. If not provided the default storage of the tenant will be used.
   * @format int32
   */
  StorageGroupId?: number | null
}

export interface ContentCreatedResponse {
  /** @format int32 */
  ContentId: number
  /** @format int32 */
  Id: number
  Description?: string | null
  /** @format int32 */
  PrimaryUserId: number
  OwnerGenericId?: string | null
  /** @format int32 */
  PresenterId?: number | null
  /** @format int32 */
  TenantId: number
  /** @format int32 */
  FolderId?: number | null
  Metadata?: string | null
  /** @format date-time */
  CreatedOn?: string | null
  /** @format date-time */
  LastActivity?: string | null
  /** @format int32 */
  Grade: number
  /** @format int32 */
  ProgramId?: number | null
  /** @format int32 */
  SessionMode: number
  /** @format int32 */
  ContentStatus: number
  /** @format int32 */
  UsersCount: number
  /** @format int32 */
  Slides: number
  /** @format int32 */
  UserId: number
  /**
   *
   *
   * 0 = User
   *
   * 1 = Owner
   *
   * 2 = AIUser
   *
   * 3 = Reviewer
   *
   * 4 = Viewer
   *
   * 5 = Labeler
   *
   * 6 = Approver
   *
   * 7 = Guest
   */
  Role: ContentUserRole
  Owner?: UserInfoResponse
  IsActive: boolean
  IsDeleted: boolean
  HasReview: boolean
  HasUnreadMessages: boolean
  /** @format int32 */
  ExpiresInDays: number
  /** @format int32 */
  ActivatedNumberTimes: number
  ThumbnailUrl?: string | null
  IsPublished: boolean
  /** @format int32 */
  ContentSharingId?: number | null
  /** @format int32 */
  PublishedSessionContentSharingId?: number | null
  /** @format int32 */
  SessionStatus?: number | null
  /** @format int32 */
  ReviewStatus?: number | null
  /** @format int32 */
  TotalCount: number
  Permissions?: SessionPermission[] | null
}

export interface ContentFolderRequest {
  /** @format int32 */
  ContentId: number
  /** @format int32 */
  ToFolderId?: number | null
  /** @format int32 */
  FromFolderId?: number | null
}

export interface ContentFormIdResponse {
  /** @format int32 */
  ContentFormId: number
}

export interface ContentFormListResponse {
  /** @format int32 */
  Id: number
  /** @format int32 */
  ContentId: number
  /** @format int32 */
  FormId: number
  Name?: string | null
  /**
   *
   *
   * 0 = Pending
   *
   * 1 = Pass
   *
   * 2 = Fail
   *
   * 3 = Empty
   *
   * 4 = ApprovedByAI
   *
   * 5 = RejectedByAI
   *
   * 6 = ApprovedByReviewer
   *
   * 7 = RejectedByReviewer
   */
  FormStatus: FormAnswerStatus
  FormAnswerStatuses?: ContentFormStatusResponse[] | null
}

export interface ContentFormRecordRequest {
  /**
   * A recorded form answers owner id.
   * @format int32
   */
  UserId: number
  /**
   * A recorded contentForm id.
   * @format int32
   */
  ContentFormId: number
  /**
   *
   *
   * 0 = Manual
   *
   * 1 = UserSignature
   */
  Type: ContentFormRecordType
}

export interface ContentFormRecordResponse {
  /** @format int32 */
  Id: number
  /** @format int32 */
  UserId: number
  /** @format int32 */
  ContentFormId: number
  /** @format date-time */
  CreatedOn: string
  /**
   *
   *
   * 0 = Manual
   *
   * 1 = UserSignature
   */
  Type: ContentFormRecordType
  Signature?: string | null
}

/**
 *
 *
 * 0 = Manual
 *
 * 1 = UserSignature
 * @format int32
 */
export enum ContentFormRecordType {
  Manual = 0,
  UserSignature = 1,
}

export interface ContentFormResponse {
  /** @format int32 */
  ContentId: number
  /** @format int32 */
  FormId: number
}

export interface ContentFormStatusResponse {
  /**
   *
   *
   * 0 = Pending
   *
   * 1 = Pass
   *
   * 2 = Fail
   *
   * 3 = Empty
   *
   * 4 = ApprovedByAI
   *
   * 5 = RejectedByAI
   *
   * 6 = ApprovedByReviewer
   *
   * 7 = RejectedByReviewer
   */
  FormAnswerStatus: FormAnswerStatus
  /** @format int32 */
  Count: number
}

export interface ContentFormWithAnswerStatusesRequest {
  /** @format int32 */
  ContentFormId: number
  AnswerStatuses?: FormAnswerStatus[] | null
}

export interface ContentFormsByUserResponse {
  /** @format int32 */
  TotalCount: number
  ContentForms?: UserContentFormResponse[] | null
}

export interface ContentFormsIdsResponse {
  ContentFormsIds?: number[] | null
}

export type ContentFormsListWithoutStatusesResponseIAsyncEnumerable = object

export interface ContentIdResponse {
  /**
   * Unique id of the content within the system
   * @format int32
   */
  ContentId: number
}

export interface ContentLinkRequest {
  /** @format int32 */
  ContentId: number
  /** @format int32 */
  LinkedContentId: number
}

export interface ContentLinkResponse {
  /** @format int32 */
  Id: number
  /** @format int32 */
  ContentId: number
  Description?: string | null
  TenantName?: string | null
  OwnerName?: string | null
  /**
   *
   *
   * 0 = Pending
   *
   * 1 = Active
   *
   * 2 = MergingInProgress
   *
   * 3 = Rejected
   */
  Status: LinkedContentStatus
}

export interface ContentNamePartRequest {
  /** @minLength 1 */
  Question: string
  /** @minLength 1 */
  Answer: string
  /**
   * @format int32
   * @min 0
   * @max 2147483647
   */
  Order: number
}

export interface ContentResponse {
  /**
   * @minLength 1
   * @maxLength 4000
   */
  Description: string
  /** @format int32 */
  PresenterId?: number | null
  /**
   *
   *
   * 0 = Presentation
   *
   * 1 = Webinar
   *
   * 2 = ClassRoom
   */
  SessionMode: SessionMode
  /** @format int32 */
  ProgramId?: number | null
  /** @format int32 */
  FolderId?: number | null
  IsOwner: boolean
  IsActive: boolean
  Owner?: UserInfoResponse
  /** @format int32 */
  Grade: number
  /** @format date-time */
  CreatedOn: string
  Users?: ContentUserWithQualificationsResponse[] | null
  Document?: DocumentResponse
  ChatMessages?: ChatMessageResponse[] | null
  /**
   *
   *
   * 0 = Created
   *
   * 1 = Pending
   *
   * 2 = Rejected
   */
  ContentStatus: ContentStatus
  VideoBridgeRegion?: string | null
  DescriptionCreatedUsingConvention: boolean
  /**
   *
   *
   * 0 = NotCreated
   *
   * 1 = ModelCreating
   *
   * 2 = ModelCreated
   */
  PointCloudModelStatus: PointCloudModelStatus
  /**
   *
   *
   * 0 = NotCreated
   *
   * 1 = Creating
   *
   * 2 = Created
   */
  StructureModelStatus: StructureModelStatus
  /** @format int32 */
  CopyOfId?: number | null
  /** @format int32 */
  TenantId: number
  LastVideoCallInfo?: VideoCallResponse
  /** @format int32 */
  Id: number
}

export interface ContentReviewRequest {
  /** @format int32 */
  Id: number
  /** @format int32 */
  ContentId: number
  ContentName?: string | null
  PagesIds?: number[] | null
  ContentFormsIds?: number[] | null
  /** @format int32 */
  ReviewerId: number
  ReviewerName?: string | null
  /** @format int32 */
  ReviewerTenantId: number
  ReviewerTenantName?: string | null
  ReviewersIds?: number[] | null
  Reviewers?: string[] | null
  /**
   *
   *
   * 0 = Pending
   *
   * 1 = Active
   *
   * 2 = ReviewFeedbackSent
   *
   * 3 = Completed
   */
  ReviewStatus: ContentReviewStatus
  EditedFormsAnswers?: ReviewedFormAnswerRequest[] | null
  UploadedPagesIds?: number[] | null
  /** @format date-time */
  CreatedOn: string
  /** @format int32 */
  OriginalTenantId: number
  /** @format int32 */
  TargetContentId?: number | null
  TargetContentName?: string | null
  FormsIds?: number[] | null
  FormAnswers?: FormAnswerInReviewRequest[] | null
  /**
   *
   *
   * 0 = Shared
   *
   * 1 = Published
   *
   * 2 = ForReview
   *
   * 3 = ContentsMerging
   *
   * 4 = LinkedContentsMerging
   *
   * 5 = MergeForReview
   *
   * 6 = MergeReviewedData
   */
  Type: ContentSharingType
  UseModelProcessors: boolean
  /** @format int32 */
  TenantId: number
}

/**
 *
 *
 * 0 = Pending
 *
 * 1 = Active
 *
 * 2 = ReviewFeedbackSent
 *
 * 3 = Completed
 * @format int32
 */
export enum ContentReviewStatus {
  Pending = 0,
  Active = 1,
  ReviewFeedbackSent = 2,
  Completed = 3,
}

export interface ContentReviewStatusRequest {
  ContentIds?: number[] | null
  /**
   *
   *
   * 0 = NotStarted
   *
   * 1 = ReadyForReview
   *
   * 2 = InReview
   *
   * 3 = SessionFeedbackSent
   *
   * 4 = Complete
   */
  Status: ReviewStatus
}

export interface ContentSharedLinkIdRequest {
  /** @minLength 1 */
  ContentSharedLinkId: string
}

export interface ContentSharedLinkResponse {
  Token?: string | null
}

export interface ContentSharingFormsRequest {
  ContentForms?: ContentFormWithAnswerStatusesRequest[] | null
}

/**
 *
 *
 * 0 = SharedByOwner
 *
 * 1 = SharedByAdmin
 *
 * 2 = ForReview
 *
 * 3 = ContentsMerging
 *
 * 4 = LinkedContentsMerging
 *
 * 5 = MergeForReview
 * @format int32
 */
export enum ContentSharingModelType {
  SharedByOwner = 0,
  SharedByAdmin = 1,
  ForReview = 2,
  ContentsMerging = 3,
  LinkedContentsMerging = 4,
  MergeForReview = 5,
}

export interface ContentSharingRequest {
  /**
   * The Id of shared content.
   * @format int32
   */
  ContentId: number
  ShouldCopyCheckIns: boolean
  /**
   * The Id of a user the content is shared with.
   * Optional in case of contents merging. In this case UserId will be calculated by the content with TargetContentId (it must be the owner of this target content).
   * In other cases is required.
   * If content is shared to copy (Type = SharedByOwner or SharedByAdmin) the user will become an owner of copy of the shared content.
   * If content is shared to review the user will become a participant of the shared content with the role Reviewer.
   * @format int32
   */
  UserId?: number | null
  /**
   * The Id a tenant the content is shared with.
   * @format int32
   */
  TenantId?: number | null
  /**
   * The list of Ids of the shared gallery pages.
   * If 'DataType' is not provided (by default 'AllData' option is set) or 'AllData' option is selected then all content pages are shared.
   * If 'DataType' = 'SelectedData' then:
   * 'PagesIds' list is filtered to remove invalid items (all Ids must belong to the shared content)
   * If filtered 'PagesIds' list is empty there is an option to find out the valid pages by 'ContentForms' list:
   * If filtered 'ContentForms' list is empty then in case 'Type' is 'ForReview' the request model is invalid.
   * If 'Type' is not 'ForReview' then the first gallery page of the shared content is selected as a fallback.
   */
  PagesIds?: number[] | null
  /**
   * The list of Ids of the shared content forms with the list of selected form answer statuses for each form.
   * The list of the latest form answers will be calculated for each form taking into account provided form answers statuses.
   * If 'DataType' is not provided (by default 'AllData' option is set) or 'AllData' option is selected then all content forms with all available statuses are shared.
   * If 'DataType' = 'SelectedData' then:
   * 'ContentForms' list is filtered to remove invalid items (all Ids must belong to the shared content)
   * If filtered 'ContentForms' list is empty then in case 'Type' is 'ForReview' the request model is invalid.
   * In case if only the Ids of the content forms are provided (without answers statuses) then all available statuses are selected by default for each form.
   */
  ContentForms?: ContentFormWithAnswerStatusesRequest[] | null
  /**
   *
   *
   * 0 = SharedByOwner
   *
   * 1 = SharedByAdmin
   *
   * 2 = ForReview
   *
   * 3 = ContentsMerging
   *
   * 4 = LinkedContentsMerging
   *
   * 5 = MergeForReview
   */
  Type: ContentSharingModelType
  /**
   *
   *
   * 0 = AllData
   *
   * 1 = SelectedData
   */
  DataType: SharedContentDataType
  /**
   * The Id of the target content.
   * Required in case of 'Type' = 'ContentsMerging'.
   * It's an existing content the shared data from the original content is copied to.
   * @format int32
   */
  TargetContentId?: number | null
}

/**
 *
 *
 * 0 = Shared
 *
 * 1 = Published
 *
 * 2 = ForReview
 *
 * 3 = ContentsMerging
 *
 * 4 = LinkedContentsMerging
 *
 * 5 = MergeForReview
 *
 * 6 = MergeReviewedData
 * @format int32
 */
export enum ContentSharingType {
  Shared = 0,
  Published = 1,
  ForReview = 2,
  ContentsMerging = 3,
  LinkedContentsMerging = 4,
  MergeForReview = 5,
  MergeReviewedData = 6,
}

/**
 *
 *
 * 0 = Created
 *
 * 1 = Pending
 *
 * 2 = Rejected
 * @format int32
 */
export enum ContentStatus {
  Created = 0,
  Pending = 1,
  Rejected = 2,
}

/**
 *
 *
 * 0 = Unknown
 *
 * 1 = Video
 *
 * 2 = Text
 *
 * 3 = Pdf
 *
 * 4 = VideoByUrl
 *
 * 5 = CloudFile
 *
 * 6 = RecordedVideo
 *
 * 7 = Audio
 *
 * 8 = DrawingBoard
 *
 * 9 = Snapshot
 *
 * 10 = Image
 *
 * 11 = ConcatenatedVideo
 *
 * 12 = WebPage
 *
 * 13 = SpatialModel
 *
 * 14 = DocDocumentPage
 *
 * 15 = PptDocumentPage
 *
 * 16 = ExcelDocumentPage
 *
 * 17 = File
 *
 * 18 = StructureModel
 *
 * 19 = StructureModelPdf
 *
 * 20 = TwoDLineDrawing
 *
 * 21 = TwoDLineDrawingPdf
 *
 * 22 = AutodeskFile
 *
 * 23 = PointCloud
 *
 * 24 = BentleyAnalyticsReportPdf
 *
 * 101 = UnencodedVideo
 *
 * 102 = UnencodedRecordedVideo
 *
 * 103 = UnencodedConcatenatedVideo
 *
 * 104 = RecordedCloudFileVideo
 *
 * 105 = StreamVideo
 * @format int32
 */
export enum ContentType {
  Unknown = 0,
  Video = 1,
  Text = 2,
  Pdf = 3,
  VideoByUrl = 4,
  CloudFile = 5,
  RecordedVideo = 6,
  Audio = 7,
  DrawingBoard = 8,
  Snapshot = 9,
  Image = 10,
  ConcatenatedVideo = 11,
  WebPage = 12,
  SpatialModel = 13,
  DocDocumentPage = 14,
  PptDocumentPage = 15,
  ExcelDocumentPage = 16,
  File = 17,
  StructureModel = 18,
  StructureModelPdf = 19,
  TwoDLineDrawing = 20,
  TwoDLineDrawingPdf = 21,
  AutodeskFile = 22,
  PointCloud = 23,
  BentleyAnalyticsReportPdf = 24,
  UnencodedVideo = 101,
  UnencodedRecordedVideo = 102,
  UnencodedConcatenatedVideo = 103,
  RecordedCloudFileVideo = 104,
  StreamVideo = 105,
}

export interface ContentUpdateRequest {
  /** @format int32 */
  UserId: number
  FolderId?: string | null
  IsDeleted: boolean
  IsDeletedPermanently: boolean
  /** @format int32 */
  Id: number
}

/**
 *
 *
 * 0 = User
 *
 * 1 = Owner
 *
 * 2 = AIUser
 *
 * 3 = Reviewer
 *
 * 4 = Viewer
 *
 * 5 = Labeler
 *
 * 6 = Approver
 *
 * 7 = Guest
 * @format int32
 */
export enum ContentUserRole {
  User = 0,
  Owner = 1,
  AIUser = 2,
  Reviewer = 3,
  Viewer = 4,
  Labeler = 5,
  Approver = 6,
  Guest = 7,
}

export interface ContentUserWithQualificationsResponse {
  RequiredQualificationIds?: number[] | null
  /** @format uuid */
  IdentityGuid: string
  /**
   *
   *
   * 0 = Unknown
   *
   * 1 = WebBrowser
   *
   * 2 = AndroidDevice
   *
   * 3 = AppleDevice
   *
   * 4 = AndroidBrowser
   *
   * 5 = IosBrowser
   */
  DeviceType: DeviceTypes
  IsGuest: boolean
  IsOwner: boolean
  IsDeleted: boolean
  /**
   *
   *
   * 0 = User
   *
   * 1 = Owner
   *
   * 2 = AIUser
   *
   * 3 = Reviewer
   *
   * 4 = Viewer
   *
   * 5 = Labeler
   *
   * 6 = Approver
   *
   * 7 = Guest
   */
  Role: ContentUserRole
  ChatNotificationsMuted: boolean
  /** @format int32 */
  Id: number
  Name?: string | null
  UserName?: string | null
  FirstName?: string | null
  LastName?: string | null
  Email?: string | null
  AvatarUrl?: string | null
  IsAccountDeleted: boolean
}

export interface ControlInfoRequest {
  /**
   *
   *
   * 0 = Unknown
   *
   * 1 = Video
   *
   * 10 = Image
   *
   * 101 = UnencodedVideo
   */
  Type: FormControlInfoContentType
  Url?: string | null
  UnencodedUrl?: string | null
  /** @format int32 */
  Id: number
}

export interface ControlInfoResponse {
  Description?: string | null
  ControlLabel?: string | null
  /**
   *
   *
   * 0 = Unknown
   *
   * 1 = Video
   *
   * 10 = Image
   *
   * 101 = UnencodedVideo
   */
  Type: FormControlInfoContentType
  Url?: string | null
  FileName?: string | null
  ThumbnailUrl?: string | null
  EncodedUrl?: string | null
}

export interface ControlOptionsResponse {
  /** @format int32 */
  Id: number
  Value?: string | null
  /** @format int32 */
  Order: number
  Conditions?: ConditionsResponse[] | null
  /** @format int32 */
  AIExpressionId?: number | null
  IsHidden: boolean
  HasAnswers: boolean
}

/**
 *
 *
 * 1 = Text
 *
 * 2 = Textarea
 *
 * 3 = Checkboxlist
 *
 * 4 = Radiobuttonlist
 *
 * 5 = Selectlist
 *
 * 6 = Tabs
 *
 * 7 = Counter
 *
 * 8 = Date
 *
 * 9 = DateTime
 * @format int32
 */
export enum ControlType {
  Text = 1,
  Textarea = 2,
  Checkboxlist = 3,
  Radiobuttonlist = 4,
  Selectlist = 5,
  Tabs = 6,
  Counter = 7,
  Date = 8,
  DateTime = 9,
}

export interface Coordinates {
  Start: Point
  End: Point
}

export interface CoordinatesFromStructureModelCreateRequest {
  Start: PointFromStructureModelCreateRequest
  End: PointFromStructureModelCreateRequest
}

export interface CopyContentRequest {
  /** @format int32 */
  ContentSharingId: number
  ContentName?: string | null
  IsCopyFormAnswers: boolean
  ContentNameParts?: ContentNamePartRequest[] | null
}

export interface CreateAutodeskPageRequest {
  /**
   * Url to file
   *
   * Only links to collaborate blob storage are supported (can be received via api/uploads)
   * @minLength 1
   */
  Url: string
  /**
   * Unique id of the session within the system
   * @format int32
   */
  ContentId: number
  /**
   * Name of page
   * @maxLength 256
   */
  Name?: string | null
  /**
   * Unique id of the session folder within the system
   * @format int32
   */
  FolderId?: number | null
  /** @format int32 */
  TimeZoneOffset: number
  /**
   *
   *
   * 0 = Creating
   *
   * 1 = Created
   *
   * 2 = Failed
   */
  Status: PageStatus
}

export interface CreateBatchUserRequest {
  FirstName?: string | null
  LastName?: string | null
  Email?: string | null
  Role?: string | null
  GenericId?: string | null
  /** @format int32 */
  TenantId?: number | null
}

export interface CreateBentleyAnalyticsReportRequest {
  /** @format int32 */
  PageId: number
}

export interface CreateBentleyPointCloudModelRequest {
  /** @format int32 */
  ContentId: number
  /** @minItems 10 */
  PageIds: number[]
  Settings: BentleySettingsModel
  SendEmailNotifications: boolean
}

export interface CreateChatMessageRequest {
  /**
   * Text of message
   * @minLength 1
   * @maxLength 4000
   */
  Message: string
  /**
   * Unique id of the session within the system
   * @format int32
   */
  ContentId: number
  /**
   * User id of the recipient of the private message
   * @format int32
   */
  ReceiverId?: number | null
  /**
   * Topic Id (Content Id or Form answer id or Page id) of the selected Topic Type
   * @format int32
   */
  TopicId: number
  /**
   *
   *
   * 1 = Session
   *
   * 2 = Page
   *
   * 3 = FormAnswer
   */
  TopicType: TopicType
}

export interface CreateChatMessageWithAssetRequest {
  /**
   *
   *
   * 0 = Unknown
   *
   * 1 = Audio
   */
  Type: ChatMessageAssetType
  /**
   * Url to file
   *
   * Only links to collaborate blob storage are supported (can be received via api/uploads)
   * @format uri
   * @minLength 1
   */
  Url: string
  /**
   * Duration on a media file
   * @format int32
   * @min 0
   * @max 2147483647
   * @default 0
   */
  Duration: number
  /**
   * Unique id of the session within the system
   * @format int32
   */
  ContentId: number
  /**
   * User id of the recipient of the private message
   * @format int32
   */
  ReceiverId?: number | null
  /**
   * Topic Id (Content Id or Form answer id or Page id) of the selected Topic Type
   * @format int32
   */
  TopicId: number
  /**
   *
   *
   * 1 = Session
   *
   * 2 = Page
   *
   * 3 = FormAnswer
   */
  TopicType: TopicType
}

export interface CreateContentSharedLinkRequest {
  /** @format int32 */
  ContentId: number
  /** @format int32 */
  TenantId: number
}

export interface CreateDrawingBoardPageRequest {
  /**
   * Unique id of the session within the system
   * @format int32
   */
  ContentId: number
  /**
   * Name of page
   * @maxLength 256
   */
  Name?: string | null
  /**
   * Unique id of the session folder within the system
   * @format int32
   */
  FolderId?: number | null
  /** @format int32 */
  TimeZoneOffset: number
  /**
   *
   *
   * 0 = Creating
   *
   * 1 = Created
   *
   * 2 = Failed
   */
  Status: PageStatus
}

export interface CreateExcelPageRequest {
  /**
   * Url to document
   *
   * Only links to collaborate blob storage are supported (can be received via api/uploads)
   * @minLength 1
   */
  Url: string
  /**
   * Unique id of the session within the system
   * @format int32
   */
  ContentId: number
  /**
   * Name of page
   * @maxLength 256
   */
  Name?: string | null
  /**
   * Unique id of the session folder within the system
   * @format int32
   */
  FolderId?: number | null
  /** @format int32 */
  TimeZoneOffset: number
  /**
   *
   *
   * 0 = Creating
   *
   * 1 = Created
   *
   * 2 = Failed
   */
  Status: PageStatus
}

export interface CreateFilePageRequest {
  /**
   * Url to file
   *
   * Only links to collaborate blob storage are supported (can be received via api/uploads)
   * @minLength 1
   */
  Url: string
  /**
   * Unique id of the session within the system
   * @format int32
   */
  ContentId: number
  /**
   * Name of page
   * @maxLength 256
   */
  Name?: string | null
  /**
   * Unique id of the session folder within the system
   * @format int32
   */
  FolderId?: number | null
  /** @format int32 */
  TimeZoneOffset: number
  /**
   *
   *
   * 0 = Creating
   *
   * 1 = Created
   *
   * 2 = Failed
   */
  Status: PageStatus
}

export interface CreateFolderRequest {
  /**
   * Folder name
   * @minLength 1
   * @maxLength 400
   */
  Name: string
}

export interface CreateFormAnswerRequest {
  /** @format int32 */
  UserId?: number | null
  /** @format int32 */
  ContentId: number
  /** @format int32 */
  ContentFormId: number
  /** @format int32 */
  FormControlId: number
  /** @format int32 */
  PageId: number
  /** A created form answer value (must not be empty if form control has no any options). */
  Value?: string | null
  /**
   * A specific moment in video when form answer is given (for video pages and recordings).
   * @format double
   */
  Timestamp?: number | null
  /**
   * A list of selected options of form control
   * (may be more than one in case of checkbox control, empty if control has no any options).
   */
  OptionsIds?: number[] | null
  /** A list of selected form tabs of content form (empty if form has no any tab panels). */
  FormTabsIds?: number[] | null
  /** @format date-time */
  CreatedOn?: string | null
  TimeZone?: string | null
}

export interface CreateFormFolderRequest {
  /**
   * Folder name
   * @minLength 1
   * @maxLength 400
   */
  Name: string
}

export interface CreateImagePageRequest {
  /**
   * Url to file
   *
   * Only links to collaborate blob storage are supported (can be received via api/uploads)
   * @minLength 1
   */
  Url: string
  /** @format double */
  Latitude?: number | null
  /** @format double */
  Longitude?: number | null
  /**
   * Unique id of the session within the system
   * @format int32
   */
  ContentId: number
  /**
   * Name of page
   * @maxLength 256
   */
  Name?: string | null
  /**
   * Unique id of the session folder within the system
   * @format int32
   */
  FolderId?: number | null
  /** @format int32 */
  TimeZoneOffset: number
  /**
   *
   *
   * 0 = Creating
   *
   * 1 = Created
   *
   * 2 = Failed
   */
  Status: PageStatus
}

export interface CreatePageFolderRequest {
  /**
   * Unique id of the session within the system
   * @format int32
   */
  ContentId: number
  /**
   * The name of created folder
   * @minLength 1
   * @maxLength 400
   */
  Name: string
  /**
   * Unique id of parent session folder within the system
   * @format int32
   */
  ParentId?: number | null
}

export interface CreatePdfPageRequest {
  /**
   * Url to pdf
   *
   * Only links to collaborate blob storage are supported (can be received via api/uploads)
   * @minLength 1
   */
  Url: string
  /**
   * Unique id of the session within the system
   * @format int32
   */
  ContentId: number
  /**
   * Name of page
   * @maxLength 256
   */
  Name?: string | null
  /**
   * Unique id of the session folder within the system
   * @format int32
   */
  FolderId?: number | null
  /** @format int32 */
  TimeZoneOffset: number
  /**
   *
   *
   * 0 = Creating
   *
   * 1 = Created
   *
   * 2 = Failed
   */
  Status: PageStatus
}

export interface CreatePointCloudPageModel {
  /**
   * Url to files
   *
   * Only links to collaborate blob storage are supported (can be received via api/uploads)
   * @minItems 1
   */
  Urls: string[]
  /**
   * Url to the orientations file
   *
   * Only links to collaborate blob storage are supported (can be received via api/uploads)<remarks>The property must be hidden from public API due to being for internal use only</remarks>
   */
  OrientationsUrl?: string | null
  /** @format double */
  Latitude?: number | null
  /** @format double */
  Longitude?: number | null
  /**
   * Unique id of the session within the system
   * @format int32
   */
  ContentId: number
  /**
   * Name of page
   * @maxLength 256
   */
  Name?: string | null
  /**
   * Unique id of the session folder within the system
   * @format int32
   */
  FolderId?: number | null
  /** @format int32 */
  TimeZoneOffset: number
  /**
   *
   *
   * 0 = Creating
   *
   * 1 = Created
   *
   * 2 = Failed
   */
  Status: PageStatus
}

export interface CreatePowerPointPageRequest {
  /**
   * Url to document
   *
   * Only links to collaborate blob storage are supported (can be received via api/uploads)
   * @minLength 1
   */
  Url: string
  /**
   * Unique id of the session within the system
   * @format int32
   */
  ContentId: number
  /**
   * Name of page
   * @maxLength 256
   */
  Name?: string | null
  /**
   * Unique id of the session folder within the system
   * @format int32
   */
  FolderId?: number | null
  /** @format int32 */
  TimeZoneOffset: number
  /**
   *
   *
   * 0 = Creating
   *
   * 1 = Created
   *
   * 2 = Failed
   */
  Status: PageStatus
}

export interface CreateProfileRequest {
  /**
   * The first name of user.
   * @minLength 1
   * @maxLength 35
   */
  FirstName: string
  /**
   * The last name of user.
   * @minLength 1
   * @maxLength 35
   */
  LastName: string
}

export interface CreateSplatModelRequest {
  PageIds?: number[] | null
  PageName?: string | null
  /** @format int32 */
  FolderId?: number | null
  AutoGenerateBoundingBox: boolean
  RemoveBackground: boolean
}

export interface CreateTrackingBatchRequest {
  /**
   *
   *
   * 0 = CheckIn
   *
   * 1 = CheckOut
   *
   * 2 = Manual
   */
  EventType: TrackingEventType
  /**
   *
   *
   * 0 = Point
   *
   * 1 = Rectangle
   *
   * 2 = Circle
   */
  AnnotationType: TrackingAnnotationType
  Coordinates: TrackingPoint[]
  /** @format date-time */
  CreatedOn?: string | null
  UserIds?: number[] | null
}

export interface CreateTrackingRequest {
  /**
   *
   *
   * 0 = CheckIn
   *
   * 1 = CheckOut
   *
   * 2 = Manual
   */
  EventType: TrackingEventType
  /**
   *
   *
   * 0 = Point
   *
   * 1 = Rectangle
   *
   * 2 = Circle
   */
  AnnotationType: TrackingAnnotationType
  /** @format int32 */
  ContentId: number
  /** @format int32 */
  UserId: number
  Coordinates: TrackingPoint[]
  /** @format date-time */
  CreatedOn?: string | null
}

export interface CreateUserErrorModel {
  InputLine?: string | null
  Message?: string | null
}

export interface CreateUserListRequest {
  AddedToDatabase: boolean
  CreatedUserList?: CreateUserRequest[] | null
  ErroredUserList?: CreateUserErrorModel[] | null
}

export interface CreateUserRequest {
  /**
   * @minLength 1
   * @maxLength 35
   */
  FirstName: string
  /**
   * @minLength 1
   * @maxLength 35
   */
  LastName: string
  /**
   * @maxLength 128
   * @pattern ^[a-zA-Z0-9_-]+$
   */
  EmployeeId?: string | null
  /**
   * @minLength 1
   * @maxLength 120
   */
  Email: string
  /** @minLength 1 */
  Role: string
  Institution?: string | null
  /** @format date-time */
  DateOfBirth?: string | null
  /** @maxLength 15 */
  PhoneNumber?: string | null
  Address?: UserAddressRequest
  /** @format int32 */
  TenantId?: number | null
}

export interface CreateVideoPageRequest {
  /**
   * Url to file
   *
   * Only links to collaborate blob storage are supported (can be received via api/uploads)
   * @minLength 1
   */
  Url: string
  /** @format double */
  Latitude?: number | null
  /** @format double */
  Longitude?: number | null
  /**
   * Unique id of the session within the system
   * @format int32
   */
  ContentId: number
  /**
   * Name of page
   * @maxLength 256
   */
  Name?: string | null
  /**
   * Unique id of the session folder within the system
   * @format int32
   */
  FolderId?: number | null
  /** @format int32 */
  TimeZoneOffset: number
  /**
   *
   *
   * 0 = Creating
   *
   * 1 = Created
   *
   * 2 = Failed
   */
  Status: PageStatus
}

export interface CreateWebPageRequest {
  /**
   * Url to web page
   * @format uri
   * @minLength 1
   */
  Url: string
  /**
   * Unique id of the session within the system
   * @format int32
   */
  ContentId: number
  /**
   * Name of page
   * @maxLength 256
   */
  Name?: string | null
  /**
   * Unique id of the session folder within the system
   * @format int32
   */
  FolderId?: number | null
  /** @format int32 */
  TimeZoneOffset: number
  /**
   *
   *
   * 0 = Creating
   *
   * 1 = Created
   *
   * 2 = Failed
   */
  Status: PageStatus
}

export interface CreateWordPageRequest {
  /**
   * Url to document
   *
   * Only links to collaborate blob storage are supported (can be received via api/uploads)
   * @minLength 1
   */
  Url: string
  /**
   * Unique id of the session within the system
   * @format int32
   */
  ContentId: number
  /**
   * Name of page
   * @maxLength 256
   */
  Name?: string | null
  /**
   * Unique id of the session folder within the system
   * @format int32
   */
  FolderId?: number | null
  /** @format int32 */
  TimeZoneOffset: number
  /**
   *
   *
   * 0 = Creating
   *
   * 1 = Created
   *
   * 2 = Failed
   */
  Status: PageStatus
}

export interface CreatedFormQuestionResponse {
  /**
   * A created form question Id.
   * @format int32
   */
  Id: number
  /** A created form question name. */
  Label?: string | null
}

export interface CreatedFormResponse {
  /**
   * A created form Id.
   * @format int32
   */
  FormId: number
  /** A created form name. */
  Name?: string | null
  /** A list of form questions. */
  Questions?: CreatedFormQuestionResponse[] | null
}

export interface DetectionFromStructureModelCreateRequest {
  /** @format int32 */
  PageId: number
  /** @format double */
  Probability: number
  TagName: string
  BoundingBox?: BoundingBoxFromStructureModelCreateRequest
  Polygon?: CoordinatesFromStructureModelCreateRequest[] | null
}

export interface DeviceInfoRequest {
  browser?: string | null
  browser_version?: string | null
  device?: string | null
  isDesktop: boolean
  isMobile: boolean
  isTablet: boolean
  os?: string | null
  os_version?: string | null
}

/**
 *
 *
 * 0 = Unknown
 *
 * 1 = WebBrowser
 *
 * 2 = AndroidDevice
 *
 * 3 = AppleDevice
 *
 * 4 = AndroidBrowser
 *
 * 5 = IosBrowser
 * @format int32
 */
export enum DeviceTypes {
  Unknown = 0,
  WebBrowser = 1,
  AndroidDevice = 2,
  AppleDevice = 3,
  AndroidBrowser = 4,
  IosBrowser = 5,
}

export interface DocumentCreateRequest {
  Pages?: PageCreateRequest[] | null
}

export interface DocumentExportRequest {
  PageExportModels?: PageExportRequest[] | null
  Recipients?: string | null
  /** @format int32 */
  ContentId: number
}

export interface DocumentResponse {
  /** @format int32 */
  ContentId: number
  /** @format int32 */
  UserId: number
  IsComplete: boolean
  /** @format int32 */
  Grade: number
  Owner?: UserInfoResponse
  Pages?: PageBaseRequest[] | null
  Folders?: PageFolderResponse[] | null
  /** @format int32 */
  Id: number
}

export interface DronePageRequest {
  /** @format int32 */
  ContentId: number
  /** @format int32 */
  DocumentId: number
  /** @format int32 */
  UserId: number
  Name?: string | null
  DroneKey?: string | null
  IsUsed: boolean
  /** @format int32 */
  RecordId?: number | null
  /** @format int32 */
  PageId?: number | null
  /** @format date-time */
  CreatedOn?: string | null
  /** @format int32 */
  Id: number
}

export interface DroneRequest {
  /** @format int32 */
  UserId: number
  Name?: string | null
  DroneKey?: string | null
  IsUsed: boolean
  /** @format int32 */
  RecordId?: number | null
  /** @format int32 */
  PageId?: number | null
  /** @format date-time */
  CreatedOn?: string | null
  /** @format int32 */
  Id: number
}

export interface EditFolderUsersRequest {
  /** @format int32 */
  FolderId: number
  User: FolderUserResponse
}

export interface Error {
  /** @format int32 */
  Code: number
  /** @minLength 1 */
  Message: string
  Details?: string | null
}

export interface EulerRotation {
  /** @format double */
  X: number
  /** @format double */
  Y: number
  /** @format double */
  Z: number
}

/**
 *
 *
 * 0 = PagesInGallery
 *
 * 1 = FormQuestions
 * @format int32
 */
export enum ExportAsPdfOptions {
  PagesInGallery = 0,
  FormQuestions = 1,
}

export interface ExportContentFormsResponse {
  /** Name of the session assigned by the system automatically or changed by the user manually */
  SessionName?: string | null
  /** Exact day and time (in UTC) when a form was exported */
  TimeOfExport?: string | null
  Forms?: ExportFormResponse[] | null
}

export interface ExportFormAnswerResponse {
  TabsIds?: number[] | null
  TabsNames?: string[] | null
  TabsNumbers?: number[] | null
  /**
   * Unique id of the session within the system
   * @format int32
   */
  ContentId: number
  Title?: string | null
  /**
   * Order of the current question in a form
   * @format int32
   */
  QuestionNumber: number
  /**
   * Unique id of the form within the system
   * @format int32
   */
  FormId: number
  /** Name of the form assigned by the system automatically or changed by the user manually */
  FormName?: string | null
  /**
   * Unique id of the question within the system
   * @format int32
   */
  QuestionId?: number | null
  /** Text of the question in a form */
  Question?: string | null
  /** Email of the user who changed the status of a particular answer to a particular form question */
  StatusChanger?: string | null
  /**
   * Exact day and time (in UTC) when the status of a particular answer to a particular form question was changed
   * @format date-time
   */
  StatusChangeTime?: string | null
  /** Email of the user who gave a particular answer to a particular form question */
  Answerer?: string | null
  /**
   * Exact day and time (in UTC) when a particular answer to a particular form question was given
   * @format date-time
   */
  AnswerTime?: string | null
  /**
   *
   *
   * 0 = Pending
   *
   * 1 = Pass
   *
   * 2 = Fail
   *
   * 3 = Empty
   *
   * 4 = ApprovedByAI
   *
   * 5 = RejectedByAI
   *
   * 6 = ApprovedByReviewer
   *
   * 7 = RejectedByReviewer
   */
  Status?: FormAnswerStatus
  /**
   * Unique ids of the answers within the system
   * @format int32
   */
  AnswerId?: number | null
  /** Text of the answer to particular form question */
  Answer?: string | null
  /** Text of additional comments left for a form answer */
  Comments?: FormAnswerCommentModel[] | null
  /** URL to the page on which a particular answer to a particular form question was given */
  PhotoLink?: string | null
}

export interface ExportFormResponse {
  /** Name of the form assigned by the system automatically or changed by the user manually */
  FormName?: string | null
  FormAnswers?: ExportFormAnswerResponse[] | null
}

/**
 *
 *
 * 0 = All
 *
 * 1 = CurrentGalleryView
 * @format int32
 */
export enum ExportGalleryOptions {
  All = 0,
  CurrentGalleryView = 1,
}

export interface Filtering {
  Name?: string | null
  Email?: string | null
  Role?: string | null
}

export interface FolderBaseResponse {
  /** @format int32 */
  Id: number
  Name?: string | null
  /** @format int32 */
  UserId: number
  OwnerName?: string | null
  OwnerEmail?: string | null
  OwnerAvatarUrl?: string | null
  FolderUsersPermissions?: FolderPermission[] | null
  IsFolderShared: boolean
  /**
   *
   *
   * 0 = User
   *
   * 1 = Owner
   *
   * 2 = Viewer
   *
   * 3 = Guest
   */
  Role: FolderUserRole
  IsDeleted: boolean
  HasUnreadMessages: boolean
}

/**
 *
 *
 * 1 = CreateContent
 *
 * 2 = AddUsers
 *
 * 3 = EditUsers
 *
 * 4 = MoveContent
 *
 * 5 = LeaveFolder
 *
 * 6 = DeleteFolder
 * @format int32
 */
export enum FolderPermission {
  CreateContent = 1,
  AddUsers = 2,
  EditUsers = 3,
  MoveContent = 4,
  LeaveFolder = 5,
  DeleteFolder = 6,
}

export interface FolderPermissionPermissionsResponse {
  /**
   *
   *
   * 1 = CreateContent
   *
   * 2 = AddUsers
   *
   * 3 = EditUsers
   *
   * 4 = MoveContent
   *
   * 5 = LeaveFolder
   *
   * 6 = DeleteFolder
   */
  Permissions: FolderPermission
}

export interface FolderResponse {
  /** @format int32 */
  UserId: number
  Name?: string | null
  IsDeleted: boolean
  IsDeletedPermanently: boolean
  /** @format date-time */
  CreatedOn?: string | null
  /** @format int32 */
  Id: number
}

export interface FolderUserResponse {
  /** @format int32 */
  Id: number
  Email?: string | null
  Name?: string | null
  AvatarUrl?: string | null
  IsDeleted: boolean
  IsAccountDeleted: boolean
  /**
   *
   *
   * 0 = User
   *
   * 1 = Owner
   *
   * 2 = Viewer
   *
   * 3 = Guest
   */
  Role: FolderUserRole
}

/**
 *
 *
 * 0 = User
 *
 * 1 = Owner
 *
 * 2 = Viewer
 *
 * 3 = Guest
 * @format int32
 */
export enum FolderUserRole {
  User = 0,
  Owner = 1,
  Viewer = 2,
  Guest = 3,
}

export interface FormActionCreateOrUpdateRequest {
  /**
   * Unique identifier of the action within the system
   * @format int32
   */
  Id?: number | null
  /**
   * A workflow id.
   * @minLength 1
   * @maxLength 450
   */
  WorkflowId: string
  /**
   * An action name.
   * @minLength 1
   * @maxLength 256
   */
  Label: string
  /**
   * An order of the current action in the form.
   * @format int32
   */
  Order: number
  /**
   * An informational text displayed when hovering over the action.
   * @maxLength 512
   */
  Tooltip?: string | null
}

export interface FormActionResponse {
  /** @format int32 */
  Id: number
  /** @format int32 */
  FormId: number
  Label?: string | null
  /** @format int32 */
  Order: number
  Tooltip?: string | null
  WorkflowId?: string | null
}

export interface FormAnswerBaseResponse {
  /** @format int32 */
  FormId: number
  /** @format int32 */
  UserId: number
  /** @format int32 */
  ContentFormId: number
  /** @format int32 */
  PageId?: number | null
  /** @format int32 */
  FormOwnerId: number
  /** @format int32 */
  ContentId: number
  /** @format double */
  Timestamp: number
  Answers?: FormControlAnswerResponse[] | null
  /** @format int32 */
  ApproverId?: number | null
  ApproverName?: string | null
  /** @format date-time */
  CreatedOn?: string | null
}

export interface FormAnswerCommentModel {
  Email?: string | null
  Reply?: string | null
}

export interface FormAnswerInReviewRequest {
  /** @format int32 */
  Id: number
  /** @format int32 */
  ContentFormId: number
  /** @format int32 */
  FormControlId: number
  FormTabsIds?: number[] | null
}

export interface FormAnswerSelectedOptionResponse {
  /** @format int32 */
  Id: number
  Value?: string | null
  /** @format int32 */
  AIExpressionId?: number | null
}

/**
 *
 *
 * 0 = Pending
 *
 * 1 = Pass
 *
 * 2 = Fail
 *
 * 3 = Empty
 *
 * 4 = ApprovedByAI
 *
 * 5 = RejectedByAI
 *
 * 6 = ApprovedByReviewer
 *
 * 7 = RejectedByReviewer
 * @format int32
 */
export enum FormAnswerStatus {
  Pending = 0,
  Pass = 1,
  Fail = 2,
  Empty = 3,
  ApprovedByAI = 4,
  RejectedByAI = 5,
  ApprovedByReviewer = 6,
  RejectedByReviewer = 7,
}

export interface FormAnswersJsonExportRequest {
  /**
   * Unique id of the session within the system
   * @format int32
   */
  ContentId: number
  /** Ids of attached forms */
  FormsIds?: number[] | null
  /**
   * Unique id of the user within the system
   * @format int32
   */
  UserId?: number | null
  /**
   * The id of the page with form answers
   * @format int32
   */
  PageId?: number | null
}

export interface FormAnswersTimelineItemResponse {
  /**
   * Unique id of the form answer within the system
   * @format int32
   */
  Id: number
  /**
   * A specific moment in video when form answer is given (for video pages and recordings)
   * @format double
   */
  Timestamp: number
}

export interface FormConditionCreateOrUpdateRequest {
  /**
   * Unique identifier of the form condition within the system
   * @format int32
   */
  Id?: number | null
  /**
   *
   *
   * 0 = Unknown
   *
   * 1 = AttachForm
   *
   * 2 = SendEmail
   *
   * 3 = AddVideoByUrl
   *
   * 4 = ShowInfoMessage
   *
   * 5 = RunWorkflow
   */
  Type: ConditionType
  /**
   * A main information used by triggered condition action.
   * For AttachForm condition - FormId, SendEmail - additional text in email, AddVideoByUrl - Video Url, ShowInfoMessage - info message.
   * Optional for SendEmail condition.
   * @maxLength 4000
   */
  Solution?: string | null
  /**
   * An answer value that trigger condition action (For textbox and textarea).
   * @maxLength 128
   */
  TriggerValue?: string | null
  /**
   *
   *
   * 0 = AnyEntry
   *
   * 1 = Equals
   *
   * 2 = GreaterThan
   *
   * 3 = LessThan
   *
   * 4 = UnansweredQuestions
   */
  TriggerType: ConditionTriggerType
  ConditionsRecipient?: ConditionsRecipientRequest[] | null
}

export interface FormControlAnswerResponse {
  /** @format int32 */
  Id: number
  Value?: string | null
  /** @format int32 */
  AnswerOrder: number
  /** @format int32 */
  UserId: number
  /** @format int32 */
  ContentFormId: number
  SelectedOptions?: FormAnswerSelectedOptionResponse[] | null
  /** @format int32 */
  FormControlId: number
  /** @format int32 */
  PageId: number
  Label?: string | null
  FormName?: string | null
  /** @format int32 */
  FormId: number
  /** @format date-time */
  CreatedOn?: string | null
  FormTabAnswers?: FormTabAnswerResponse[] | null
  /**
   *
   *
   * 0 = Pending
   *
   * 1 = Pass
   *
   * 2 = Fail
   *
   * 3 = Empty
   *
   * 4 = ApprovedByAI
   *
   * 5 = RejectedByAI
   *
   * 6 = ApprovedByReviewer
   *
   * 7 = RejectedByReviewer
   */
  FormAnswerStatus: FormAnswerStatus
  /** @format date-time */
  FormAnswerStatusCreatedOn?: string | null
  /** @format int32 */
  ApproverId?: number | null
  ApproverName?: string | null
  /** @format double */
  Timestamp?: number | null
}

export interface FormControlAttributeCreateOrUpdateRequest {
  /**
   * Unique identifier of the form control attribute within the system
   * @format int32
   */
  Id?: number | null
  /**
   * Attribute name
   * @minLength 1
   * @maxLength 150
   */
  Name: string
  /**
   * Attribute value
   * @minLength 1
   * @maxLength 150
   */
  Value: string
}

export interface FormControlAttributeResponse {
  /** @format int32 */
  Id: number
  /** @format int32 */
  FormControlId: number
  Name?: string | null
  Value?: string | null
}

export interface FormControlCreateOrUpdateRequest {
  /**
   * Unique identifier of the form control within the system
   * @format int32
   */
  Id?: number | null
  /**
   * A unique identifier of the form control, used to identify the control in the form
   * @maxLength 40
   */
  Uuid?: string | null
  /**
   * A question text.
   * @minLength 1
   * @maxLength 4000
   */
  Label: string
  /**
   * An order of the current question in the form
   * @format int32
   * @min 0
   * @max 2147483647
   */
  Order: number
  Name?: string | null
  /**
   * An informational text displayed when hovering over the control
   * @maxLength 512
   */
  Tooltip?: string | null
  /**
   * A hint text for possible content in control field
   * @maxLength 256
   */
  Placeholder?: string | null
  /**
   * A default answer for current question (For textbox and textarea only)
   * @maxLength 512
   */
  InitialValue?: string | null
  /** Determines whether the question is required to be answered */
  IsRequired: boolean
  ValidationMessage?: string | null
  /** A list of control options (For dropdown, checkbox and radiobutton) */
  Options?: FormControlOptionCreateOrUpdateRequest[] | null
  Info?: FormControlInfoRequest
  /**
   *
   *
   * 0 = Basic
   *
   * 1 = BodyTemperature
   *
   * 2 = PhoneNumber
   *
   * 3 = Email
   *
   * 4 = BarcodeAndQRCode
   */
  Type: FormControlType
  /**
   * Determines whether the form control should be processed by VQA model. By default - false
   * @default false
   */
  ProcessByVQAModel: boolean
  Attributes?: FormControlAttributeCreateOrUpdateRequest[] | null
  /** A list of actions that can be triggered by answering current question (for Textbox or Textarea control) */
  Conditions?: FormConditionCreateOrUpdateRequest[] | null
  /** A list of dependencies for the current control */
  Dependencies?: FormControlDependencyCreateOrUpdateRequest[] | null
  /** A list of validations for the current control */
  Validations?: FormControlValidationCreateOrUpdateRequest[] | null
  /** A flag indicating whether the control is hidden */
  IsHidden: boolean
  /**
   *
   *
   * 1 = Text
   *
   * 2 = Textarea
   *
   * 3 = Checkboxlist
   *
   * 4 = Radiobuttonlist
   *
   * 5 = Selectlist
   *
   * 6 = Tabs
   *
   * 7 = Counter
   *
   * 8 = Date
   *
   * 9 = DateTime
   */
  ControlType: ControlType
  /**
   * An external information related to current control (Id or any other information)
   * @maxLength 4000
   */
  ExternalData?: string | null
}

export interface FormControlDependencyCreateOrUpdateRequest {
  /** @format int32 */
  Id?: number | null
  /**
   * @minLength 1
   * @maxLength 40
   */
  ParentControlUuid: string
  /**
   *
   *
   * 1 = Show
   *
   * 2 = Enable
   *
   * 3 = Require
   *
   * 4 = FilterValue
   *
   * 5 = Value
   */
  Type: FormControlDependencyType
  /** @maxLength 125 */
  ParentControlValue?: string | null
}

export interface FormControlDependencyResponse {
  /** @format int32 */
  Id: number
  /** @format int32 */
  ParentFormControlId: number
  /**
   *
   *
   * 1 = Show
   *
   * 2 = Enable
   *
   * 3 = Require
   *
   * 4 = FilterValue
   *
   * 5 = Value
   */
  Type: FormControlDependencyType
  ParentControlTriggerValue: string | null
}

/**
 *
 *
 * 1 = Show
 *
 * 2 = Enable
 *
 * 3 = Require
 *
 * 4 = FilterValue
 *
 * 5 = Value
 * @format int32
 */
export enum FormControlDependencyType {
  Show = 1,
  Enable = 2,
  Require = 3,
  FilterValue = 4,
  Value = 5,
}

/**
 *
 *
 * 0 = Unknown
 *
 * 1 = Video
 *
 * 10 = Image
 *
 * 101 = UnencodedVideo
 * @format int32
 */
export enum FormControlInfoContentType {
  Unknown = 0,
  Video = 1,
  Image = 10,
  UnencodedVideo = 101,
}

export interface FormControlInfoRequest {
  Description?: string | null
  /**
   * A question text.
   * @maxLength 4000
   */
  ControlLabel?: string | null
  /**
   *
   *
   * 0 = Unknown
   *
   * 1 = Video
   *
   * 10 = Image
   *
   * 101 = UnencodedVideo
   */
  Type: FormControlInfoContentType
  /**
   * An additional information content url.
   * @maxLength 4000
   */
  Url?: string | null
  /**
   * An additional information content file name.
   * @maxLength 256
   */
  FileName?: string | null
  /**
   * An additional information content thumnail url (For video files only).
   * @maxLength 4000
   */
  ThumbnailUrl?: string | null
  /**
   * An additional information content encoded url (For video files only).
   * @maxLength 4000
   */
  EncodedUrl?: string | null
}

export interface FormControlOptionCreateOrUpdateRequest {
  /**
   * Unique identifier of the form control option within the system
   * @format int32
   */
  Id?: number | null
  /**
   * A name of the option
   * @minLength 1
   * @maxLength 128
   */
  Value: string
  /**
   * An order of the option in current control
   * @format int32
   */
  Order: number
  /** A flag indicating whether the option is hidden or not */
  IsHidden: boolean
  /**
   * Unique identifier of the AI Expression associated with the option
   * @format int32
   */
  AIExpressionId?: number | null
  /** A list of actions that can be triggered by selecting current option (for Dropdown, Checkbox or Radiobutton control) */
  Conditions?: FormConditionCreateOrUpdateRequest[] | null
}

export interface FormControlProcessingUpdateRequest {
  /**
   * Unique id of the FormControl within the system
   * @format int32
   */
  FormControlId: number
  /**
   * Determines whether the form control should be processed by VQA model. By default - false.
   * @default false
   */
  ProcessByVQAModel: boolean
}

export interface FormControlResponse {
  /** @format int32 */
  Id: number
  /**
   *
   *
   * 1 = Text
   *
   * 2 = Textarea
   *
   * 3 = Checkboxlist
   *
   * 4 = Radiobuttonlist
   *
   * 5 = Selectlist
   *
   * 6 = Tabs
   *
   * 7 = Counter
   *
   * 8 = Date
   *
   * 9 = DateTime
   */
  ControlType: ControlType
  Name?: string | null
  Tooltip?: string | null
  Placeholder?: string | null
  InitialValue?: string | null
  IsRequired: boolean
  ValidationMessage?: string | null
  Options?: ControlOptionsResponse[] | null
  Info?: ControlInfoResponse
  /**
   *
   *
   * 0 = Basic
   *
   * 1 = BodyTemperature
   *
   * 2 = PhoneNumber
   *
   * 3 = Email
   *
   * 4 = BarcodeAndQRCode
   */
  Type: FormControlType
  ProcessByVQAModel: boolean
  Attributes?: FormControlAttributeResponse[] | null
  Dependencies?: FormControlDependencyResponse[] | null
  Validations?: FormControlValidationResponse[] | null
  IsHidden: boolean
  HasAnswers: boolean
  /** @format int32 */
  FormId: number
  Label?: string | null
  /** @format int32 */
  Order: number
  /** @format int32 */
  IncrementValue?: number | null
  /** @format int32 */
  IncrementPeriod?: number | null
  Conditions?: ConditionsResponse[] | null
}

/**
 *
 *
 * 0 = Basic
 *
 * 1 = BodyTemperature
 *
 * 2 = PhoneNumber
 *
 * 3 = Email
 *
 * 4 = BarcodeAndQRCode
 * @format int32
 */
export enum FormControlType {
  Basic = 0,
  BodyTemperature = 1,
  PhoneNumber = 2,
  Email = 3,
  BarcodeAndQRCode = 4,
}

export interface FormControlValidationCreateOrUpdateRequest {
  /** @format int32 */
  Id?: number | null
  DependsOnControlsUuids: string[]
  /**
   *
   *
   * 1 = EqualsToSum
   *
   * 2 = GreaterThan
   */
  Type: FormControlValidationType
}

export interface FormControlValidationResponse {
  /** @format int32 */
  Id: number
  /**
   *
   *
   * 1 = EqualsToSum
   *
   * 2 = GreaterThan
   */
  Type: FormControlValidationType
  ControlIds: number[] | null
}

/**
 *
 *
 * 1 = EqualsToSum
 *
 * 2 = GreaterThan
 * @format int32
 */
export enum FormControlValidationType {
  EqualsToSum = 1,
  GreaterThan = 2,
}

export interface FormCounterCreateOrUpdateRequest {
  /**
   * Unique identifier of the counter within the system
   * @format int32
   */
  Id?: number | null
  /**
   * A counter limit. Can be used to trigger counter conditions when exceeded. If null - unlimited.
   * @format int32
   */
  CounterLimit?: number | null
  /**
   * CV class Id.
   * @format int32
   */
  AIObjectId: number
  /** Indicates whether the counter should count CV class unique objects or not. */
  CountAIObjects: boolean
  /**
   * A counter name.
   * @minLength 1
   * @maxLength 256
   */
  Label: string
  /**
   * An order of the current counter in the form.
   * @format int32
   */
  Order: number
  /** @format int32 */
  IncrementValue?: number | null
  /** @format int32 */
  IncrementPeriod?: number | null
  /** A list of actions that can be triggered by exceeding counter limit. */
  Conditions?: FormConditionCreateOrUpdateRequest[] | null
}

export interface FormCreateOrUpdateRequest {
  /**
   * Unique identifier of the form within the system
   * @format int32
   */
  Id?: number | null
  /**
   * A form name
   * @minLength 1
   * @maxLength 256
   */
  Name: string
  /**
   * A form thumbnail.
   * @format uri
   */
  IconUrl?: string | null
  /**
   *
   *
   * 0 = Default
   *
   * 1 = List
   */
  FormViewMode: FormViewMode
  /**
   * NLP model Id
   * @format int32
   */
  NLPModelId?: number | null
  /**
   * Id of the folder where the form was created
   * @format int32
   */
  FolderId?: number | null
  /** The possibility of signing a form by the user */
  IsSignatureEnabled: boolean
  /**
   * An external information related to current form (Id or any other information)
   * @maxLength 4000
   */
  ExternalData?: string | null
  /** A list of tabs panels. Each tab panel contains at least one tab */
  TabsPanels: FormTabsPanelCreateOrUpdateRequest[]
  /** A list of form questions. Required if Actions and Counters lists are empty */
  Controls: FormControlCreateOrUpdateRequest[]
  /** A list of AI counters. Required if Controls and Actions lists are empty */
  Counters: FormCounterCreateOrUpdateRequest[]
  /** A list of form actions. Required if Controls and Counters lists are empty */
  Actions: FormActionCreateOrUpdateRequest[]
  /** List of permissions granted to content roles for a form */
  GrantedPermissions?: FormPermissionsByContentRoleDto[] | null
}

export interface FormFolderRequest {
  /**
   * Unique id of a form within the system.
   * @format int32
   */
  FormId: number
  /**
   * Unique id of a form folder within the system.
   * If provided, defines the folder to move a form to.
   * Otherwise, the form will be moved outside the folder.
   * @format int32
   */
  ToFolderId?: number | null
  /**
   * Unique id of a form folder within the system.
   * If provided, defines the folder to move a form from.
   * Otherwise, the form is not expected to initially belong to any folder.
   * @format int32
   */
  FromFolderId?: number | null
}

export interface FormFolderResponse {
  /** @format int32 */
  FolderId: number
  Name?: string | null
  /** @format int32 */
  UserId: number
  CanBeDeleted: boolean
  /** @format int32 */
  TenantId?: number | null
  TenantName?: string | null
  PublishedFolderTenants?: TenantResponse[] | null
}

export interface FormIdResponse {
  /** @format int32 */
  FormId: number
}

export interface FormPdfExportRequest {
  /**
   * A unique identifier for the content form associated with the export.
   * @format int32
   */
  ContentFormId: number
  /** A list of selected form tab IDs to be included in the export. Optional. */
  FormTabs?: number[] | null
  /**
   * The ID of the user whose form answers should be retrieved for the export.
   * If provided, only answers from this user will be included.
   * If not provided, the latest answers from all users will be retrieved. Optional.
   * @format int32
   */
  UserId?: number | null
  /**
   * The ID of the specific page within the content for which answers should be retrieved.
   * If provided, only answers from this page will be included in the export. Optional.
   * @format int32
   */
  PageId?: number | null
  /**
   * The ID of the page folder within the content where the generated PDF file should be stored. Optional.
   * @format int32
   */
  FolderId?: number | null
  /**
   * The time zone offset (in minutes) used for formatting time-related data in the export. Optional.
   * @format int32
   */
  TimeZoneOffset?: number | null
}

/**
 *
 *
 * 0 = Nothing
 *
 * 1 = ViewAndAnswerForm
 *
 * 2 = ViewOtherUsersAnswers
 * @format int32
 */
export enum FormPermissions {
  Nothing = 0,
  ViewAndAnswerForm = 1,
  ViewOtherUsersAnswers = 2,
}

export interface FormPermissionsByContentRoleDto {
  /**
   *
   *
   * 0 = User
   *
   * 1 = Owner
   *
   * 2 = AIUser
   *
   * 3 = Reviewer
   *
   * 4 = Viewer
   *
   * 5 = Labeler
   *
   * 6 = Approver
   *
   * 7 = Guest
   */
  ContentRoleId: ContentUserRole
  FormPermissionsIds: FormPermissions[]
}

export interface FormPermissionsByContentRolesSectionDto {
  IsSyncWithBaseLevelEnabled: boolean
  Base?: FormPermissionsByContentRoleDto[] | null
  Override?: FormPermissionsByContentRoleDto[] | null
  EditableContentRoles?: ContentUserRole[] | null
}

export interface FormPermissionsSectionDto {
  ByContentRoles?: FormPermissionsByContentRolesSectionDto
}

export interface FormResponse {
  /**
   * A form id.
   * @format int32
   */
  FormId: number
  /**
   * A form creator user id.
   * @format int32
   */
  UserId: number
  User?: FormViewUserResponse
  /** A form name. */
  Name?: string | null
  /**
   * A form creation date.
   * @format date-time
   */
  CreatedOn?: string | null
  /** A form thumbnail. */
  IconUrl?: string | null
  /**
   * A number of form questions.
   * @format int32
   */
  ControlsNumber: number
  /**
   * A number of sessions where current form is attached.
   * @format int32
   */
  SessionsNumber: number
  /**
   * A total number of answers given in current form in all sessions.
   * @format int32
   */
  AnswersNumber: number
  /** @format int32 */
  TenantId?: number | null
  TenantName?: string | null
  /**
   * Indicates that form is not created by current user, but published by tenant admin.
   * Published forms are available for every user of this tenant.
   */
  PublishedFormTenants?: TenantResponse[] | null
}

export interface FormTabAnswerResponse {
  /** @format int32 */
  FormTabId: number
  FormTabName?: string | null
}

export interface FormTabsCreateOrUpdateRequest {
  /**
   * Unique identifier of the tab within the system
   * @format int32
   */
  Id?: number | null
  /**
   * A name of the tab
   * @minLength 1
   * @maxLength 256
   */
  Value: string
  /**
   * An order of the tab in current tab panel
   * @format int32
   * @min 0
   * @max 2147483647
   */
  Order: number
}

export interface FormTabsPanelCreateOrUpdateRequest {
  /**
   * Unique identifier of the tab panel within the system
   * @format int32
   */
  Id?: number | null
  /**
   * A tab panel name
   * @minLength 1
   * @maxLength 256
   */
  Name: string
  /**
   * An order of the tab panel in the form
   * @format int32
   * @min 0
   * @max 2147483647
   */
  Order: number
  /**
   * A list of tabs in current panel
   * @minItems 1
   */
  Tabs: FormTabsCreateOrUpdateRequest[]
}

export interface FormTabsPanelResponse {
  /** @format int32 */
  Id: number
  /** @format int32 */
  FormId: number
  /** @format int32 */
  Order: number
  Name?: string | null
  Tabs?: FormTabsResponse[] | null
}

export interface FormTabsResponse {
  /** @format int32 */
  Id: number
  Value?: string | null
  /** @format int32 */
  Order: number
  /** @format int32 */
  FormTabPanelId: number
}

export interface FormUpdateResponse {
  /** @format int32 */
  Id: number
  /** @format int32 */
  FormId: number
  /** @format int32 */
  UserId: number
  Name?: string | null
  IconUrl?: string | null
  /** @format int32 */
  ContentFormId: number
  Tabspanels?: FormTabsPanelResponse[] | null
  Controls?: FormControlResponse[] | null
  Counters?: AICounterResponse[] | null
  Actions?: FormActionResponse[] | null
  Records?: ContentFormRecordResponse[] | null
  IsDeleted: boolean
  /** @format int32 */
  ReattachedNumberOfTimes: number
  /**
   *
   *
   * 0 = Default
   *
   * 1 = List
   */
  FormViewMode: FormViewMode
  /** @format int32 */
  NLPModelId?: number | null
  /** @format int32 */
  TenantId: number
  IsAnotherTenant: boolean
  IsSignatureEnabled: boolean
  HasAnswers: boolean
}

/**
 *
 *
 * 0 = Default
 *
 * 1 = List
 * @format int32
 */
export enum FormViewMode {
  Default = 0,
  List = 1,
}

export interface FormViewUserResponse {
  /** A form creator user email. */
  Email?: string | null
  /** A form creator user first name. */
  FirstName?: string | null
  /** A form creator user last name. */
  LastName?: string | null
  /** @format int32 */
  Id: number
}

/**
 *
 *
 * 1 = Male
 *
 * 2 = Female
 *
 * 3 = Other
 * @format int32
 */
export enum GenderTypes {
  Male = 1,
  Female = 2,
  Other = 3,
}

export interface GetBentleyGigapixelsRequest {
  PageIds: number[]
}

export interface GetBentleyGigapixelsResponse {
  /** @format double */
  UsedGigapixels: number
  /** @format double */
  UpcomingGigapixels: number
}

export interface GetContentSharedLinkResponse {
  Token?: string | null
  IsDeleted: boolean
}

export interface GetContentsByUserResponse {
  IsCallActive: boolean
  QualificationsRequired?: number[] | null
  MissingQualifications?: number[] | null
  /** @format int32 */
  Id: number
  Description?: string | null
  /** @format int32 */
  PrimaryUserId: number
  OwnerGenericId?: string | null
  /** @format int32 */
  PresenterId?: number | null
  /** @format int32 */
  TenantId: number
  /** @format int32 */
  FolderId?: number | null
  Metadata?: string | null
  /** @format date-time */
  CreatedOn?: string | null
  /** @format date-time */
  LastActivity?: string | null
  /** @format int32 */
  Grade: number
  /** @format int32 */
  ProgramId?: number | null
  /** @format int32 */
  SessionMode: number
  /** @format int32 */
  ContentStatus: number
  /** @format int32 */
  UsersCount: number
  /** @format int32 */
  Slides: number
  /** @format int32 */
  UserId: number
  /**
   *
   *
   * 0 = User
   *
   * 1 = Owner
   *
   * 2 = AIUser
   *
   * 3 = Reviewer
   *
   * 4 = Viewer
   *
   * 5 = Labeler
   *
   * 6 = Approver
   *
   * 7 = Guest
   */
  Role: ContentUserRole
  Owner?: UserInfoResponse
  IsActive: boolean
  IsDeleted: boolean
  HasReview: boolean
  HasUnreadMessages: boolean
  /** @format int32 */
  ExpiresInDays: number
  /** @format int32 */
  ActivatedNumberTimes: number
  ThumbnailUrl?: string | null
  IsPublished: boolean
  /** @format int32 */
  ContentSharingId?: number | null
  /** @format int32 */
  PublishedSessionContentSharingId?: number | null
  /** @format int32 */
  SessionStatus?: number | null
  /** @format int32 */
  ReviewStatus?: number | null
  /** @format int32 */
  TotalCount: number
  Permissions?: SessionPermission[] | null
}

export interface GetCounterInfoRequest {
  /** @format int32 */
  ContentId: number
  /** @format int32 */
  FormRecordId?: number | null
}

export interface GetFormPermissionsByNewFormResponse {
  Permissions?: FormPermissionsSectionDto
}

export interface GetFormResponse {
  /** @format int32 */
  Id: number
  /** @format int32 */
  FormId: number
  /** @format int32 */
  UserId: number
  Name?: string | null
  IconUrl?: string | null
  /** @format int32 */
  ContentFormId: number
  Tabspanels?: FormTabsPanelResponse[] | null
  Controls?: FormControlResponse[] | null
  Counters?: AICounterResponse[] | null
  Actions?: FormActionResponse[] | null
  Records?: ContentFormRecordResponse[] | null
  IsDeleted: boolean
  /** @format int32 */
  ReattachedNumberOfTimes: number
  /**
   *
   *
   * 0 = Default
   *
   * 1 = List
   */
  FormViewMode: FormViewMode
  /** @format int32 */
  NLPModelId?: number | null
  /** @format int32 */
  TenantId: number
  IsAnotherTenant: boolean
  IsSignatureEnabled: boolean
  HasAnswers: boolean
  ExternalData?: string | null
}

/** Represents a response model for retrieving forms. */
export interface GetFormsResponse {
  /**
   * Items count
   * @format int32
   */
  TotalCount: number
  /** Items */
  Items: FormResponse[]
}

export interface GetReadonlyContentFormsResponse {
  ContentForm?: ReadonlyContentForm
  LatestFormAnswers?: ReadonlyFormAnswerResponse[] | null
}

export interface GetReadonlyContentResponse {
  Content?: ReadonlyContentResponse
  Pages?: ReadonlyPageResponse[] | null
  PageFolders?: ReadonlyPageFolderResponse[] | null
  ContentForms?: ReadonlyContentFormsListResponse[] | null
}

export interface GetSearchTermRequest {
  SearchTerm?: string | null
}

export interface GetTrackingSnapshotFiltersRequest {
  Name?: string | null
  QualificationName?: string | null
  CertificateTypeName?: string | null
  /**
   *
   *
   * 1 = Pending
   *
   * 2 = Active
   *
   * 3 = Revoked
   *
   * 4 = CertificateExpired
   *
   * 5 = VersionExpired
   *
   * 6 = CertificateTypeDeleted
   *
   * 7 = QualificationDeleted
   */
  QualificationStatus?: UserAssignedQualificationStatusType
  /**
   *
   *
   * 1 = PendingReview
   *
   * 2 = Approved
   *
   * 3 = Rejected
   *
   * 4 = Expired
   *
   * 5 = Draft
   *
   * 6 = Obsolete
   *
   * 7 = Processed
   */
  CertificateStatus?: CertificateStatusType
}

export interface GetTrackingSnapshotRequest {
  /** @format date-time */
  StartDate: string
  /** @format date-time */
  EndDate: string
  /**
   * @format int32
   * @min 0
   * @max 2147483647
   */
  Skip: number
  /**
   * @format int32
   * @min 1
   * @max 100
   */
  Take: number
  OnReview: boolean
  Filters: GetTrackingSnapshotFiltersRequest
}

export interface GetUploadSasRequestBackwardCompatibility {
  /** @minLength 1 */
  FileName: string
  /** @format int32 */
  ContentId?: number | null
}

export type IActionResult = object

export interface InviteQuickLinkPasswordUpdateRequest {
  /**
   * Quick access link password
   * @minLength 6
   */
  Password: string
}

export interface InviteResponse {
  /** @format int32 */
  Id: number
  /** @format int32 */
  UserId?: number | null
  User?: UserInfoResponse
  /** @format int32 */
  RecipientId?: number | null
  /** @format uuid */
  Token?: string | null
  Recipient?: UserInfoResponse
  RecipientEmail?: string | null
  Accepted: boolean
  Ignored: boolean
  /** @format int32 */
  ContentId: number
  /**
   *
   *
   * 0 = User
   *
   * 1 = Owner
   *
   * 2 = AIUser
   *
   * 3 = Reviewer
   *
   * 4 = Viewer
   *
   * 5 = Labeler
   *
   * 6 = Approver
   *
   * 7 = Guest
   */
  Role: ContentUserRole
  ContentDescription?: string | null
  /** @format date-time */
  StartDate?: string | null
  /** @format date-time */
  EndDate?: string | null
  /** @format date-time */
  CreatedOn: string
  LinkAccess: boolean
  IdentityProtected: boolean
  /** @format uuid */
  RecipientIdentityGuid: string
}

export interface InviteRoleUpdateRequest {
  /**
   *
   *
   * 0 = User
   *
   * 1 = Owner
   *
   * 2 = AIUser
   *
   * 3 = Reviewer
   *
   * 4 = Viewer
   *
   * 5 = Labeler
   *
   * 6 = Approver
   *
   * 7 = Guest
   */
  Role: ContentUserRole
}

export interface InviteTimeUpdateRequest {
  /** @format date-time */
  StartDate?: string | null
  /** @format date-time */
  EndDate?: string | null
}

export interface InviteWithQualificationsResponse {
  RequiredQualificationIds?: number[] | null
  /** @format int32 */
  Id: number
  /** @format int32 */
  UserId?: number | null
  User?: UserInfoResponse
  /** @format int32 */
  RecipientId?: number | null
  /** @format uuid */
  Token?: string | null
  Recipient?: UserInfoResponse
  RecipientEmail?: string | null
  Accepted: boolean
  Ignored: boolean
  /** @format int32 */
  ContentId: number
  /**
   *
   *
   * 0 = User
   *
   * 1 = Owner
   *
   * 2 = AIUser
   *
   * 3 = Reviewer
   *
   * 4 = Viewer
   *
   * 5 = Labeler
   *
   * 6 = Approver
   *
   * 7 = Guest
   */
  Role: ContentUserRole
  ContentDescription?: string | null
  /** @format date-time */
  StartDate?: string | null
  /** @format date-time */
  EndDate?: string | null
  /** @format date-time */
  CreatedOn: string
  LinkAccess: boolean
  IdentityProtected: boolean
  /** @format uuid */
  RecipientIdentityGuid: string
}

export interface InvitesCreateRequest {
  /** @format int32 */
  ContentId: number
  /** @minItems 1 */
  Emails: string[]
  /** @format date-time */
  StartDate?: string | null
  /** @format date-time */
  EndDate?: string | null
  /**
   *
   *
   * 0 = User
   *
   * 1 = Owner
   *
   * 2 = AIUser
   *
   * 3 = Reviewer
   *
   * 4 = Viewer
   *
   * 5 = Labeler
   *
   * 6 = Approver
   *
   * 7 = Guest
   */
  Role: ContentUserRole
  Password?: string | null
  QualificationIds?: number[] | null
}

export interface JoinContentReviewRequest {
  /** @format int32 */
  ContentId: number
  /** @format int32 */
  ContentSharingId: number
}

export interface JwtTokenResponse {
  /**
   * Access token for the application
   * @minLength 1
   * @maxLength 1024
   */
  access_token: string
  /**
   * Token lifetime in seconds
   * @format int64
   */
  expires_in: number
  /**
   * Type of created token
   * @minLength 1
   * @maxLength 24
   */
  token_type: string
  /**
   * Session id, if token created for concrete session
   * @format int32
   */
  content_id?: number | null
}

export interface LeaveContentRequest {
  /** @format int32 */
  ContentId: number
  /** @format int32 */
  UserId: number
}

export interface LeaveFolderRequest {
  /** @format int32 */
  FolderId: number
  /** @format int32 */
  UserId: number
}

/**
 *
 *
 * 0 = Pending
 *
 * 1 = Active
 *
 * 2 = MergingInProgress
 *
 * 3 = Rejected
 * @format int32
 */
export enum LinkedContentStatus {
  Pending = 0,
  Active = 1,
  MergingInProgress = 2,
  Rejected = 3,
}

export interface LoadPageByAnswerStatusRequest {
  /** @format int32 */
  ContentId: number
  /** @format int32 */
  FolderId?: number | null
  /**
   *
   *
   * 0 = Pending
   *
   * 1 = Pass
   *
   * 2 = Fail
   *
   * 3 = Empty
   *
   * 4 = ApprovedByAI
   *
   * 5 = RejectedByAI
   *
   * 6 = ApprovedByReviewer
   *
   * 7 = RejectedByReviewer
   */
  AnswerStatus: FormAnswerStatus
}

export interface LocalRecordingRequest {
  /** @format int32 */
  ContentId: number
  /** @format int32 */
  PageId: number
  /** @format date-time */
  StartDate: string
  /** @format date-time */
  EndDate: string
}

export interface LocationResponse {
  /** @format double */
  Latitude: number
  /** @format double */
  Longitude: number
}

export interface LoginViaInviteRequest {
  /**
   * Invite token
   * @minLength 1
   */
  Token: string
}

export interface MarkChatMessageAsReadRequest {
  /**
   * Unique id of the session within the system
   * @format int32
   */
  MessageId: number
}

export interface MetadataResponse {
  /** @format double */
  FieldOfView?: number | null
  /** @format double */
  Altitude?: number | null
  /** @format double */
  Azimuth?: number | null
  /** @format double */
  GimbalPitch?: number | null
  ZoomRatio?: string | null
  /** @format int32 */
  Id: number
}

export interface NotificationResponse {
  /** @format int32 */
  Id: number
  /**
   *
   *
   * 100 = InviteToContent
   *
   * 200 = ContentActivity
   *
   * 300 = ChatMessage
   *
   * 400 = StartCall
   *
   * 500 = YouNewOwner
   *
   * 600 = YouOldOwner
   *
   * 700 = ApprovalResult
   *
   * 800 = ShareContent
   *
   * 810 = MergeContent
   *
   * 900 = AlertOwner
   *
   * 1000 = ReviewContent
   *
   * 1010 = ContentReviewResumed
   *
   * 1020 = InContentReview
   *
   * 1100 = YouNewReviewer
   *
   * 1200 = YouOldReviewer
   *
   * 1300 = ReviewCompleted
   *
   * 1310 = ReviewFeedback
   *
   * 1320 = AnswerApproved
   *
   * 1330 = AnswerRejected
   *
   * 1400 = AddUserToContent
   *
   * 1500 = AnswerQuestionReminder
   *
   * 1600 = AddUsersToFolder
   *
   * 1800 = LinkContentsApprovalResult
   *
   * 1900 = UnreadTrainingMaterialReminder
   *
   * 1910 = TrainingMaterialAssigned
   *
   * 2000 = MyCertificateExpiration
   *
   * 2005 = UserCertificateExpiration
   *
   * 2010 = QualificationExpiration
   *
   * 2020 = MyUserQualificationExpiration
   *
   * 2025 = UserQualificationExpiration
   *
   * 2030 = ContractExpiration
   *
   * 2035 = WebCallRingNotification
   */
  Type: NotificationTypeEnum
  HasBeenViewed: boolean
  /** @maxLength 4000 */
  Message?: string | null
  Data?: Record<string, string | null>
}

/**
 *
 *
 * 100 = InviteToContent
 *
 * 200 = ContentActivity
 *
 * 300 = ChatMessage
 *
 * 400 = StartCall
 *
 * 500 = YouNewOwner
 *
 * 600 = YouOldOwner
 *
 * 700 = ApprovalResult
 *
 * 800 = ShareContent
 *
 * 810 = MergeContent
 *
 * 900 = AlertOwner
 *
 * 1000 = ReviewContent
 *
 * 1010 = ContentReviewResumed
 *
 * 1020 = InContentReview
 *
 * 1100 = YouNewReviewer
 *
 * 1200 = YouOldReviewer
 *
 * 1300 = ReviewCompleted
 *
 * 1310 = ReviewFeedback
 *
 * 1320 = AnswerApproved
 *
 * 1330 = AnswerRejected
 *
 * 1400 = AddUserToContent
 *
 * 1500 = AnswerQuestionReminder
 *
 * 1600 = AddUsersToFolder
 *
 * 1800 = LinkContentsApprovalResult
 *
 * 1900 = UnreadTrainingMaterialReminder
 *
 * 1910 = TrainingMaterialAssigned
 *
 * 2000 = MyCertificateExpiration
 *
 * 2005 = UserCertificateExpiration
 *
 * 2010 = QualificationExpiration
 *
 * 2020 = MyUserQualificationExpiration
 *
 * 2025 = UserQualificationExpiration
 *
 * 2030 = ContractExpiration
 *
 * 2035 = WebCallRingNotification
 * @format int32
 */
export enum NotificationTypeEnum {
  InviteToContent = 100,
  ContentActivity = 200,
  ChatMessage = 300,
  StartCall = 400,
  YouNewOwner = 500,
  YouOldOwner = 600,
  ApprovalResult = 700,
  ShareContent = 800,
  MergeContent = 810,
  AlertOwner = 900,
  ReviewContent = 1000,
  ContentReviewResumed = 1010,
  InContentReview = 1020,
  YouNewReviewer = 1100,
  YouOldReviewer = 1200,
  ReviewCompleted = 1300,
  ReviewFeedback = 1310,
  AnswerApproved = 1320,
  AnswerRejected = 1330,
  AddUserToContent = 1400,
  AnswerQuestionReminder = 1500,
  AddUsersToFolder = 1600,
  LinkContentsApprovalResult = 1800,
  UnreadTrainingMaterialReminder = 1900,
  TrainingMaterialAssigned = 1910,
  MyCertificateExpiration = 2000,
  UserCertificateExpiration = 2005,
  QualificationExpiration = 2010,
  MyUserQualificationExpiration = 2020,
  UserQualificationExpiration = 2025,
  ContractExpiration = 2030,
  WebCallRingNotification = 2035,
}

export interface NotifyFileReadyRequest {
  /**
   * Unique id of the session within the system.
   * @format int32
   */
  ContentId: number
  /**
   * Url to a file
   *
   * Only links to collaborate blob storage are supported (can be received via api/uploads)
   * @format uri
   * @minLength 1
   */
  Url: string
  /**
   *
   *
   * 0 = Pdf
   *
   * 1 = Excel
   */
  FileType: ReportFileType
}

export interface NotifyPageUpdatedRequest {
  /** @format int32 */
  UserId: number
  /** @format int32 */
  PageId: number
  /** @format int32 */
  ContentId: number
  ThumbnailUrl?: string | null
}

export interface ObjectTranslationModel {
  Urn?: string | null
  IsReady: boolean
  /** @format int32 */
  ProgressPercentage?: number | null
  Token?: ObjectTranslationToken
}

export interface ObjectTranslationToken {
  AccessToken: string
  /** @format int32 */
  ExpiresIn: number
}

export interface PageBaseRequest {
  /** @maxLength 256 */
  Name?: string | null
  /** @maxLength 4000 */
  Description?: string | null
  /**
   *
   *
   * 0 = Standard
   *
   * 1 = Text
   *
   * 2 = EncodingPending
   */
  Type: PageType
  /**
   *
   *
   * 0 = Unknown
   *
   * 1 = Video
   *
   * 2 = Text
   *
   * 3 = Pdf
   *
   * 4 = VideoByUrl
   *
   * 5 = CloudFile
   *
   * 6 = RecordedVideo
   *
   * 7 = Audio
   *
   * 8 = DrawingBoard
   *
   * 9 = Snapshot
   *
   * 10 = Image
   *
   * 11 = ConcatenatedVideo
   *
   * 12 = WebPage
   *
   * 13 = SpatialModel
   *
   * 14 = DocDocumentPage
   *
   * 15 = PptDocumentPage
   *
   * 16 = ExcelDocumentPage
   *
   * 17 = File
   *
   * 18 = StructureModel
   *
   * 19 = StructureModelPdf
   *
   * 20 = TwoDLineDrawing
   *
   * 21 = TwoDLineDrawingPdf
   *
   * 22 = AutodeskFile
   *
   * 23 = PointCloud
   *
   * 24 = BentleyAnalyticsReportPdf
   *
   * 101 = UnencodedVideo
   *
   * 102 = UnencodedRecordedVideo
   *
   * 103 = UnencodedConcatenatedVideo
   *
   * 104 = RecordedCloudFileVideo
   *
   * 105 = StreamVideo
   */
  ContentType: ContentType
  /** @format int32 */
  Order?: number | null
  Assets?: AssetRequest[] | null
  Annotations?: AnnotationResponse[] | null
  Owner?: BaseUserInfoWithoutAvatarResponse
  /** @format int32 */
  DocumentId: number
  /** @format int32 */
  ContentId: number
  Content?: string | null
  /** @format date-time */
  CreatedOn: string
  /** @format int32 */
  TimeZoneOffset: number
  /** @format int64 */
  DateTimeOffset: number
  PdfURL?: string | null
  /** @format int32 */
  PdfPageIndex?: number | null
  /** @format int32 */
  Width?: number | null
  /** @format int32 */
  Height?: number | null
  IsRecorded: boolean
  ThumbnailUrl?: string | null
  /** @format int32 */
  FolderId?: number | null
  /** @format int32 */
  CopyOfId?: number | null
  PageVideoRestoreRequested: boolean
  /**
   *
   *
   * 0 = Creating
   *
   * 1 = Created
   *
   * 2 = Failed
   */
  Status: PageStatus
  /** @format int32 */
  Id: number
}

export interface PageByFormControlAnswer {
  /** @format int32 */
  PageId: number
  HasOwnAnswer: boolean
}

export interface PageCreateRequest {
  /** @maxLength 256 */
  Name?: string | null
  /** @maxLength 4000 */
  Description?: string | null
  /**
   *
   *
   * 0 = Standard
   *
   * 1 = Text
   *
   * 2 = EncodingPending
   */
  Type: PageType
  /**
   *
   *
   * 0 = Unknown
   *
   * 1 = Video
   *
   * 2 = Text
   *
   * 3 = Pdf
   *
   * 4 = VideoByUrl
   *
   * 5 = CloudFile
   *
   * 6 = RecordedVideo
   *
   * 7 = Audio
   *
   * 8 = DrawingBoard
   *
   * 9 = Snapshot
   *
   * 10 = Image
   *
   * 11 = ConcatenatedVideo
   *
   * 12 = WebPage
   *
   * 13 = SpatialModel
   *
   * 14 = DocDocumentPage
   *
   * 15 = PptDocumentPage
   *
   * 16 = ExcelDocumentPage
   *
   * 17 = File
   *
   * 18 = StructureModel
   *
   * 19 = StructureModelPdf
   *
   * 20 = TwoDLineDrawing
   *
   * 21 = TwoDLineDrawingPdf
   *
   * 22 = AutodeskFile
   *
   * 23 = PointCloud
   *
   * 24 = BentleyAnalyticsReportPdf
   *
   * 101 = UnencodedVideo
   *
   * 102 = UnencodedRecordedVideo
   *
   * 103 = UnencodedConcatenatedVideo
   *
   * 104 = RecordedCloudFileVideo
   *
   * 105 = StreamVideo
   */
  ContentType: ContentType
  /** @format int32 */
  Order?: number | null
  /** @format int32 */
  Width?: number | null
  /** @format int32 */
  Height?: number | null
}

export interface PageExportRequest {
  /** @format int32 */
  ContentId: number
  /** @format int32 */
  PageId: number
  /** @format int32 */
  AudioAnnotationId?: number | null
  IsTitle: boolean
}

/**
 *
 *
 * 1 = FullAccess
 * @format int32
 */
export enum PageFolderPermission {
  FullAccess = 1,
}

export interface PageFolderPermissionModel {
  /** @format int32 */
  UserId: number
  /** @format int32 */
  FolderId: number
  Permissions?: PageFolderPermission[] | null
}

export interface PageFolderResponse {
  /** @format int32 */
  UserId: number
  Name?: string | null
  /** @format int32 */
  ParentId?: number | null
  /** @format int32 */
  Order: number
  /** @format int32 */
  DocumentId: number
  IsPrivate: boolean
  /** @format int32 */
  Id: number
}

export interface PageIdRequest {
  /**
   * Unique id of the entity within the system
   * @format int32
   */
  Id: number
}

export interface PageInfoResponse {
  /** @format int32 */
  Id: number
  /** @format int32 */
  UserId: number
  /** @format int32 */
  TenantId: number
  /** @format int32 */
  DocumentId?: number | null
  /** @format int32 */
  CopyOfId?: number | null
  /** @format int32 */
  FolderId?: number | null
  FolderName?: string | null
  PdfURL?: string | null
  /** @format int32 */
  PdfPageIndex?: number | null
  Name?: string | null
  Description?: string | null
  /**
   *
   *
   * 0 = Standard
   *
   * 1 = Text
   *
   * 2 = EncodingPending
   */
  Type: PageType
  /** @format int32 */
  Order: number
  IsDeleted: boolean
  /** @format date-time */
  CreatedOn?: string | null
  /** @format int32 */
  Width?: number | null
  /** @format int32 */
  Height?: number | null
  /** @format date-time */
  ThumbnailUpdated?: string | null
  /** @format int32 */
  TimeZoneOffset: number
  /**
   *
   *
   * 0 = Unknown
   *
   * 1 = Video
   *
   * 2 = Text
   *
   * 3 = Pdf
   *
   * 4 = VideoByUrl
   *
   * 5 = CloudFile
   *
   * 6 = RecordedVideo
   *
   * 7 = Audio
   *
   * 8 = DrawingBoard
   *
   * 9 = Snapshot
   *
   * 10 = Image
   *
   * 11 = ConcatenatedVideo
   *
   * 12 = WebPage
   *
   * 13 = SpatialModel
   *
   * 14 = DocDocumentPage
   *
   * 15 = PptDocumentPage
   *
   * 16 = ExcelDocumentPage
   *
   * 17 = File
   *
   * 18 = StructureModel
   *
   * 19 = StructureModelPdf
   *
   * 20 = TwoDLineDrawing
   *
   * 21 = TwoDLineDrawingPdf
   *
   * 22 = AutodeskFile
   *
   * 23 = PointCloud
   *
   * 24 = BentleyAnalyticsReportPdf
   *
   * 101 = UnencodedVideo
   *
   * 102 = UnencodedRecordedVideo
   *
   * 103 = UnencodedConcatenatedVideo
   *
   * 104 = RecordedCloudFileVideo
   *
   * 105 = StreamVideo
   */
  ContentType: ContentType
  ThumbnailURL?: string | null
  /** @format date-time */
  UpdatedOn?: string | null
  AssetModels?: AssetResponse[] | null
  AnnotationsModels?: AnnotationInfoResponse[] | null
}

export interface PageMeasurementSettingsResponse {
  /** @format double */
  Dpi: number
  /** @format int32 */
  PageId: number
}

export interface PageMeasurementSettingsUpdateRequest {
  /** @format double */
  Dpi: number
}

/**
 *
 *
 * 0 = Creating
 *
 * 1 = Created
 *
 * 2 = Failed
 * @format int32
 */
export enum PageStatus {
  Creating = 0,
  Created = 1,
  Failed = 2,
}

/**
 *
 *
 * 0 = Standard
 *
 * 1 = Text
 *
 * 2 = EncodingPending
 * @format int32
 */
export enum PageType {
  Standard = 0,
  Text = 1,
  EncodingPending = 2,
}

export interface PagesWithFormControlAnswersGetRequest {
  /** @format int32 */
  ContentFormId: number
  /** @format int32 */
  UserId: number
  FormTabsIds?: number[] | null
}

export interface PhotoResponse {
  Url?: string | null
  /** @format int32 */
  Width: number
  /** @format int32 */
  Height: number
}

export interface PlaceResponse {
  Id?: string | null
  Address?: string | null
  Name?: string | null
  Geolocation?: LocationResponse
  Photos?: PhotoResponse[] | null
}

export interface PlacesPagedResponse {
  Items?: PlaceResponse[] | null
  NextPageToken?: string | null
}

export interface Point {
  /** @format double */
  X: number
  /** @format double */
  Y: number
  /** @format double */
  Z?: number | null
}

export interface PointCloudCreatedModel {
  ModelUrl?: string | null
  /** @format int32 */
  PageId: number
  /** @format int32 */
  ContentId: number
  /** @format int32 */
  UserId: number
  Assets?: PreparePointCloudAsset[] | null
  FolderNames?: string[] | null
  CallbackUrl?: string | null
  Subdomain?: string | null
}

/**
 *
 *
 * 0 = NotCreated
 *
 * 1 = ModelCreating
 *
 * 2 = ModelCreated
 * @format int32
 */
export enum PointCloudModelStatus {
  NotCreated = 0,
  ModelCreating = 1,
  ModelCreated = 2,
}

export interface PointCloudPageLocationResponse {
  /** @format int32 */
  Id: number
  Name?: string | null
  /** @format int32 */
  FolderId?: number | null
  FolderName?: string | null
  /** @format double */
  Latitude?: number | null
  /** @format double */
  Longitude?: number | null
  Position?: Point
}

export interface PointCloudPageSasTokenResponse {
  SasRead?: string | null
}

export interface PointCloudPageSettingsResponse {
  /** @format int32 */
  PageId: number
  /** @format double */
  MeasurementsScaleFactor: number
  Position?: Point
}

export interface PointCloudPageSettingsUpdateRequest {
  /**
   * @format double
   * @min 0
   */
  MeasurementsScaleFactor: number
  Position?: Point
}

export interface PointCloudPageSourcePageAssetResponse {
  /** @format int32 */
  PageId: number
  PageName?: string | null
  Url?: string | null
  ThumbnailUrl?: string | null
  /** @format double */
  Latitude?: number | null
  /** @format double */
  Longitude?: number | null
  /** @format double */
  FieldOfView?: number | null
  /** @format double */
  Altitude?: number | null
  /** @format double */
  Azimuth?: number | null
  /** @format double */
  GimbalPitch?: number | null
  ZoomRatio?: string | null
}

export interface PointFromStructureModelCreateRequest {
  /** @format double */
  X: number
  /** @format double */
  Y: number
  /** @format double */
  Z?: number | null
}

export interface PolicyRequest {
  /** @format int32 */
  TenantId?: number | null
  Subdomain?: string | null
  Name?: string | null
  /**
   *
   *
   * 0 = TermsOfUse
   *
   * 1 = PrivacyPolicy
   *
   * 2 = TenantTerms
   */
  PolicyType: PolicyType
  Text?: string | null
  /** @format int32 */
  Id: number
}

/**
 *
 *
 * 0 = TermsOfUse
 *
 * 1 = PrivacyPolicy
 *
 * 2 = TenantTerms
 * @format int32
 */
export enum PolicyType {
  TermsOfUse = 0,
  PrivacyPolicy = 1,
  TenantTerms = 2,
}

export interface PreparePointCloudAsset {
  /** @format int32 */
  Id: number
  /** @minLength 1 */
  Url: string
}

export interface PreparePointCloudModelRequest {
  /** @format int32 */
  ContentId: number
  /** @minItems 10 */
  PageIds: number[]
  FolderNames?: string[] | null
}

export interface PrepareSplatModelResponse {
  PageIds?: number[] | null
  PageName?: string | null
  /** @format int32 */
  FolderId?: number | null
}

export interface PublishFormFolderRequest {
  /**
   * A published folder Id.
   * @format int32
   */
  FolderId: number
  /**
   * A list of the tenants Ids where the folder is published.
   * @minItems 1
   */
  TenantsIds: number[]
}

export interface PublishFormRequest {
  /**
   * A published form Id.
   * @format int32
   */
  FormId: number
  /**
   * A list of the tenants Ids where the form is published.
   * @minItems 1
   */
  TenantsIds: number[]
}

export interface ReadonlyAnnotationResponse {
  /** @format int32 */
  PageId: number
  /**
   *
   *
   * 0 = StrokeDraw
   *
   * 1 = StrokeErase
   *
   * 2 = Laser
   *
   * 3 = Text
   *
   * 4 = Audio
   *
   * 5 = Text_Callout
   *
   * 6 = HotSpot
   *
   * 7 = LinkedPage
   *
   * 8 = AI
   *
   * 9 = AIHotspot
   *
   * 10 = Box
   *
   * 11 = Distance
   *
   * 12 = Model
   *
   * 13 = Height
   *
   * 14 = Area
   *
   * 15 = Cylinder
   *
   * 16 = Polyline
   *
   * 100 = StrokeDraw_Shape_Line
   *
   * 101 = StrokeDraw_Shape_Rectangle
   *
   * 102 = StrokeDraw_Shape_Ellipse
   *
   * 103 = StrokeDraw_Shape_Rectangle_Filled
   *
   * 104 = StrokeDraw_Shape_Ellipse_Filled
   *
   * 105 = StrokeDraw_Shape_Line_ArrowEnd
   *
   * 106 = StrokeDraw_Shape_Line_ArrowBoth
   *
   * 107 = Polygon
   */
  Type: AnnotationType
  /** @format date-time */
  CreatedOn: string
  Color?: string | null
  /** @format double */
  Elevation: number
  /** @format int32 */
  Width: number
  Coordinates?: Coordinates[] | null
  /** @format int32 */
  FontSize: number
  TopLeft?: Point
  /** @format double */
  Azimuth: number
  Anchor?: Point
  Name?: string | null
  /** @format double */
  Tilt: number
  /** @format float */
  Timestamp: number
  /** @format float */
  TargetTimestamp: number
  Url?: string | null
  /** @format int32 */
  ParentAnnotationId?: number | null
  Points?: Point[] | null
  Rotation?: EulerRotation
  Scale?: Scale
  /** @format int32 */
  LinkedPageId?: number | null
  /** @format float */
  Duration: number
  /** @format int64 */
  Size: number
  /** @format int32 */
  Id: number
}

export interface ReadonlyAsset {
  /** @maxLength 256 */
  Name?: string | null
  /**
   *
   *
   * 0 = Unknown
   *
   * 1 = Image
   *
   * 2 = Video
   *
   * 3 = Preview
   *
   * 4 = Audio
   *
   * 5 = CloudFile
   *
   * 6 = RecordedVideo
   *
   * 7 = Thumbnail
   *
   * 10 = Snapshot
   *
   * 11 = ConcatenatedVideo
   *
   * 12 = WebPage
   *
   * 13 = SpatialModelImage
   *
   * 14 = DocDocument
   *
   * 15 = PptDocument
   *
   * 16 = ExcelDocument
   *
   * 17 = File
   *
   * 18 = StructureModel
   *
   * 20 = TwoDLineDrawing
   *
   * 22 = AutodeskFile
   *
   * 23 = PointCloud
   *
   * 24 = PotreePointCloud
   *
   * 101 = UnencodedVideo
   *
   * 102 = UnencodedRecordedVideo
   *
   * 103 = UnencodedConcatenatedVideo
   *
   * 104 = RecordedCloudFileVideo
   *
   * 105 = StreamVideo
   */
  Type: AssetType
  /** @maxLength 4000 */
  Url?: string | null
  CompressedMediaUrls?: ReadonlyCompressedMediaUrlResponse[] | null
  Metadata?: MetadataResponse
  /** @format double */
  Latitude?: number | null
  /** @format double */
  Longitude?: number | null
  /** @format int64 */
  Size?: number | null
  /** @format int32 */
  Duration?: number | null
  /** @format int32 */
  Order: number
  /** @format date-time */
  OriginalCreatedOn?: string | null
  /** @format int32 */
  Id: number
}

export interface ReadonlyCompressedMediaUrlResponse {
  /** @format int32 */
  AssetId: number
  /**
   *
   *
   * 0 = Unscaled
   *
   * 1 = Scaled
   *
   * 2 = Lowest
   */
  CompressionType: CompressionType
  Url?: string | null
  /** @format int32 */
  Id: number
}

export interface ReadonlyContentForm {
  /** @format int32 */
  Id: number
  /** @format int32 */
  FormId: number
  Name?: string | null
  IconUrl?: string | null
  /** @format int32 */
  ContentFormId: number
  Tabspanels?: FormTabsPanelResponse[] | null
  Controls?: FormControlResponse[] | null
  Counters?: AICounterResponse[] | null
  Actions?: FormActionResponse[] | null
  IsDeleted: boolean
  /** @format int32 */
  ReattachedNumberOfTimes: number
  /**
   *
   *
   * 0 = Default
   *
   * 1 = List
   */
  FormViewMode: FormViewMode
  /** @format int32 */
  NLPModelId?: number | null
  /** @format int32 */
  TenantId: number
  IsAnotherTenant: boolean
  IsSignatureEnabled: boolean
}

export interface ReadonlyContentFormsListResponse {
  /** @format int32 */
  Id: number
  /** @format int32 */
  ContentId: number
  /** @format int32 */
  FormId: number
  Name?: string | null
  /** @format int32 */
  ReattachedNumberOfTimes: number
  HideOtherUsers: boolean
}

export interface ReadonlyContentResponse {
  /** @format int32 */
  Id: number
  /** @format date-time */
  CreatedOn: string
  Description?: string | null
  /** @format int32 */
  TenantId: number
  Document?: ReadonlyDocumentResponse
}

export interface ReadonlyDocumentResponse {
  /** @format int32 */
  Id: number
}

export interface ReadonlyFormAnswerResponse {
  /** @format int32 */
  Id: number
  /** @format int32 */
  FormControlId: number
  Value?: string | null
  /**
   *
   *
   * 0 = Pending
   *
   * 1 = Pass
   *
   * 2 = Fail
   *
   * 3 = Empty
   *
   * 4 = ApprovedByAI
   *
   * 5 = RejectedByAI
   *
   * 6 = ApprovedByReviewer
   *
   * 7 = RejectedByReviewer
   */
  FormAnswerStatus: FormAnswerStatus
  /** @format int32 */
  PageId: number
  /** @format double */
  Timestamp?: number | null
  SelectedOptions?: FormAnswerSelectedOptionResponse[] | null
}

export interface ReadonlyPageFolderResponse {
  /** @format int32 */
  Id: number
  Name?: string | null
  /** @format int32 */
  ParentId?: number | null
  /** @format int32 */
  Order: number
  /** @format int32 */
  DocumentId: number
  IsPrivate: boolean
}

export interface ReadonlyPageResponse {
  Name?: string | null
  Description?: string | null
  /**
   *
   *
   * 0 = Standard
   *
   * 1 = Text
   *
   * 2 = EncodingPending
   */
  Type: PageType
  /**
   *
   *
   * 0 = Unknown
   *
   * 1 = Video
   *
   * 2 = Text
   *
   * 3 = Pdf
   *
   * 4 = VideoByUrl
   *
   * 5 = CloudFile
   *
   * 6 = RecordedVideo
   *
   * 7 = Audio
   *
   * 8 = DrawingBoard
   *
   * 9 = Snapshot
   *
   * 10 = Image
   *
   * 11 = ConcatenatedVideo
   *
   * 12 = WebPage
   *
   * 13 = SpatialModel
   *
   * 14 = DocDocumentPage
   *
   * 15 = PptDocumentPage
   *
   * 16 = ExcelDocumentPage
   *
   * 17 = File
   *
   * 18 = StructureModel
   *
   * 19 = StructureModelPdf
   *
   * 20 = TwoDLineDrawing
   *
   * 21 = TwoDLineDrawingPdf
   *
   * 22 = AutodeskFile
   *
   * 23 = PointCloud
   *
   * 24 = BentleyAnalyticsReportPdf
   *
   * 101 = UnencodedVideo
   *
   * 102 = UnencodedRecordedVideo
   *
   * 103 = UnencodedConcatenatedVideo
   *
   * 104 = RecordedCloudFileVideo
   *
   * 105 = StreamVideo
   */
  ContentType: ContentType
  /** @format int32 */
  Order?: number | null
  Assets?: ReadonlyAsset[] | null
  Annotations?: ReadonlyAnnotationResponse[] | null
  /** @format int32 */
  DocumentId: number
  /** @format int32 */
  ContentId: number
  Content?: string | null
  /** @format date-time */
  CreatedOn: string
  /** @format int32 */
  TimeZoneOffset: number
  /** @format int64 */
  DateTimeOffset: number
  PdfURL?: string | null
  /** @format int32 */
  PdfPageIndex?: number | null
  /** @format int32 */
  Width?: number | null
  /** @format int32 */
  Height?: number | null
  IsRecorded: boolean
  ThumbnailUrl?: string | null
  /** @format int32 */
  FolderId?: number | null
  /** @format int32 */
  CopyOfId?: number | null
  PageVideoRestoreRequested: boolean
  /**
   *
   *
   * 0 = Creating
   *
   * 1 = Created
   *
   * 2 = Failed
   */
  Status: PageStatus
  PointCloudPageSettings?: PointCloudPageSettingsResponse
  PotreeSasToken?: string | null
  TranslationModel?: ObjectTranslationModel
  /** @format int32 */
  Id: number
}

export interface RecipientRequest {
  /** @format int32 */
  Id: number
}

export interface RecipientResponse {
  /** @format int32 */
  Id: number
  Name?: string | null
  UserName?: string | null
  Email?: string | null
  AvatarUrl?: string | null
  PhoneNumber?: string | null
  IsFindByPhone: boolean
}

export interface RecordStatusResponse {
  /** @format int32 */
  Id: number
  State?: string | null
  Error?: string | null
  /**
   *
   *
   * 0 = None
   *
   * 1 = WrongParamenters
   *
   * 2 = SessionIsAlreadyRecording
   *
   * 3 = NoFreeDisplays
   *
   * 4 = SessionWasNotPrepared
   *
   * 5 = SessionIsNotRecording
   *
   * 6 = SessionWasNotStarted
   *
   * 7 = CanNotStartFfmpeg
   *
   * 8 = FfmpegDied
   *
   * 9 = PingTimeout
   *
   * 10 = MoreThen90Min
   *
   * 11 = ErrorIsUndefined
   *
   * 12 = SessionDoesNotExist
   */
  ErrorCode: RecordingErrorCode
  /** @format int64 */
  StartDate?: number | null
  /** @format int64 */
  StopDate?: number | null
  /** @format int64 */
  CheckDate?: number | null
  Session?: string | null
  /** @format int32 */
  SelectedUser?: number | null
  CeleryTask?: string | null
  /** @format int32 */
  Display?: number | null
  Server?: string | null
  FfmpegPid?: string | null
  ChromePid?: string | null
  Url?: string | null
  ThumbnailUrl?: string | null
  /** @format int64 */
  Size?: number | null
  /**
   *
   *
   * 1 = Local
   *
   * 2 = Cloud
   */
  RecordingType: RecordingType
}

/**
 *
 *
 * 0 = None
 *
 * 1 = WrongParamenters
 *
 * 2 = SessionIsAlreadyRecording
 *
 * 3 = NoFreeDisplays
 *
 * 4 = SessionWasNotPrepared
 *
 * 5 = SessionIsNotRecording
 *
 * 6 = SessionWasNotStarted
 *
 * 7 = CanNotStartFfmpeg
 *
 * 8 = FfmpegDied
 *
 * 9 = PingTimeout
 *
 * 10 = MoreThen90Min
 *
 * 11 = ErrorIsUndefined
 *
 * 12 = SessionDoesNotExist
 * @format int32
 */
export enum RecordingErrorCode {
  None = 0,
  WrongParamenters = 1,
  SessionIsAlreadyRecording = 2,
  NoFreeDisplays = 3,
  SessionWasNotPrepared = 4,
  SessionIsNotRecording = 5,
  SessionWasNotStarted = 6,
  CanNotStartFfmpeg = 7,
  FfmpegDied = 8,
  PingTimeout = 9,
  MoreThen90Min = 10,
  ErrorIsUndefined = 11,
  SessionDoesNotExist = 12,
}

export interface RecordingRequest {
  /** @format int32 */
  ContentId: number
  ServerName?: string | null
  /** @format int32 */
  RecordId: number
  /** @format int32 */
  SelectedUserId: number
}

/**
 *
 *
 * 1 = Local
 *
 * 2 = Cloud
 * @format int32
 */
export enum RecordingType {
  Local = 1,
  Cloud = 2,
}

export interface RegenerateAnalyticsReportRequest {
  /**
   * Unique id of a page within the system.
   * @format int32
   */
  PageId: number
}

/**
 *
 *
 * 0 = Never
 *
 * 1 = Date
 *
 * 2 = Occurrences
 * @format int32
 */
export enum ReminderCustomRepeatEndOnType {
  Never = 0,
  Date = 1,
  Occurrences = 2,
}

/**
 *
 *
 * 0 = Minute
 *
 * 1 = Hour
 *
 * 2 = Day
 *
 * 3 = Week
 *
 * 4 = Month
 *
 * 5 = Year
 * @format int32
 */
export enum ReminderCustomRepeatMode {
  Minute = 0,
  Hour = 1,
  Day = 2,
  Week = 3,
  Month = 4,
  Year = 5,
}

export interface ReminderCustomRepeatSettingsRequest {
  /**
   *
   *
   * 0 = Minute
   *
   * 1 = Hour
   *
   * 2 = Day
   *
   * 3 = Week
   *
   * 4 = Month
   *
   * 5 = Year
   */
  Mode: ReminderCustomRepeatMode
  /** @format int32 */
  Interval: number
  /** @format int32 */
  SelectedDaysOfWeek: number
  /**
   *
   *
   * 0 = Never
   *
   * 1 = Date
   *
   * 2 = Occurrences
   */
  EndType: ReminderCustomRepeatEndOnType
  /** @format date-time */
  EndDate: string
  /** @format int32 */
  EndOccurrences: number
}

/**
 *
 *
 * 0 = NoRepeat
 *
 * 1 = Daily
 *
 * 2 = Weekly
 *
 * 3 = Monthly
 *
 * 4 = Annually
 *
 * 5 = EveryWeekday
 *
 * 6 = Custom
 * @format int32
 */
export enum ReminderRepeatMode {
  NoRepeat = 0,
  Daily = 1,
  Weekly = 2,
  Monthly = 3,
  Annually = 4,
  EveryWeekday = 5,
  Custom = 6,
}

export interface ReminderRequest {
  Users: number[]
  /**
   *
   *
   * 0 = AnswerFormQuestion
   *
   * 2 = UnreadTrainingMaterial
   */
  Type: ReminderType
  /** @format date-time */
  StartDate: string
  /**
   *
   *
   * 0 = NoRepeat
   *
   * 1 = Daily
   *
   * 2 = Weekly
   *
   * 3 = Monthly
   *
   * 4 = Annually
   *
   * 5 = EveryWeekday
   *
   * 6 = Custom
   */
  RepeatMode: ReminderRepeatMode
  CustomRepeatSettings?: ReminderCustomRepeatSettingsRequest
  /** @format int32 */
  ContentId?: number | null
  /** @format int32 */
  ContentFormId?: number | null
  /** @format int32 */
  FormControlId?: number | null
  FormTabsIds?: number[] | null
  Payload?: string | null
}

export interface ReminderResponse {
  /** @format int32 */
  Id: number
  /** @format date-time */
  CreatedOn: string
  /** @format date-time */
  PreviousTriggerDate?: string | null
  /** @format date-time */
  TriggerDate: string
  /** @format int32 */
  Occurrences: number
  IsDeleted: boolean
  Users: number[]
  /**
   *
   *
   * 0 = AnswerFormQuestion
   *
   * 2 = UnreadTrainingMaterial
   */
  Type: ReminderType
  /** @format date-time */
  StartDate: string
  /**
   *
   *
   * 0 = NoRepeat
   *
   * 1 = Daily
   *
   * 2 = Weekly
   *
   * 3 = Monthly
   *
   * 4 = Annually
   *
   * 5 = EveryWeekday
   *
   * 6 = Custom
   */
  RepeatMode: ReminderRepeatMode
  CustomRepeatSettings?: ReminderCustomRepeatSettingsRequest
  /** @format int32 */
  ContentId?: number | null
  /** @format int32 */
  ContentFormId?: number | null
  /** @format int32 */
  FormControlId?: number | null
  FormTabsIds?: number[] | null
  Payload?: string | null
}

/**
 *
 *
 * 0 = AnswerFormQuestion
 *
 * 2 = UnreadTrainingMaterial
 * @format int32
 */
export enum ReminderType {
  AnswerFormQuestion = 0,
  UnreadTrainingMaterial = 2,
}

export interface RemoveUserContentRequest {
  /**
   * The id of particular session.
   * @format int32
   */
  ContentId: number
  /**
   * The id of the user to be removed from the session.
   * @format int32
   */
  UserId: number
}

export interface RenameContentFolderRequest {
  /**
   * Unique id of the folder within the system
   * @format int32
   */
  Id: number
  /**
   * New folder name
   * @minLength 1
   * @maxLength 400
   */
  Name: string
}

export interface RenameFormFolderRequest {
  /**
   * Folder Id
   * @format int32
   */
  FolderId: number
  /**
   * Folder's new name
   * @minLength 1
   * @maxLength 400
   */
  Name: string
}

export interface RenamePageFolderResponse {
  /**
   * Unique id of the session folder within the system
   * @format int32
   */
  Id: number
  /**
   * New name of session folder
   * @minLength 1
   * @maxLength 400
   */
  Name: string
}

export interface RenamePageRequest {
  /**
   * Unique if of the page within the system
   * @format int32
   */
  Id: number
  /**
   * New name of the page
   * @minLength 1
   * @maxLength 256
   */
  Name: string
}

/**
 *
 *
 * 0 = Pdf
 *
 * 1 = Excel
 * @format int32
 */
export enum ReportFileType {
  Pdf = 0,
  Excel = 1,
}

export interface ReviewResultRequest {
  ContentReviewData?: ContentReviewRequest
  IsCopyRequired: boolean
}

/**
 *
 *
 * 0 = NotStarted
 *
 * 1 = ReadyForReview
 *
 * 2 = InReview
 *
 * 3 = SessionFeedbackSent
 *
 * 4 = Complete
 * @format int32
 */
export enum ReviewStatus {
  NotStarted = 0,
  ReadyForReview = 1,
  InReview = 2,
  SessionFeedbackSent = 3,
  Complete = 4,
}

export interface ReviewedFormAnswerRequest {
  /** @format int32 */
  Id: number
  /** @format int32 */
  ContentSharingId: number
  /** @format int32 */
  FormAnswerId: number
  /**
   *
   *
   * 0 = Pending
   *
   * 1 = Pass
   *
   * 2 = Fail
   *
   * 3 = Empty
   *
   * 4 = ApprovedByAI
   *
   * 5 = RejectedByAI
   *
   * 6 = ApprovedByReviewer
   *
   * 7 = RejectedByReviewer
   */
  FormAnswerStatus: FormAnswerStatus
  /** @format int32 */
  ApproverId: number
  ApproverName?: string | null
  IsDeleted: boolean
}

export interface RotatePageRequest {
  /** @format int32 */
  PageId: number
  /**
   *
   *
   * 0 = Rotate90Clockwise
   *
   * 1 = Rotate90Anticlockwise
   *
   * 2 = FlipHorizontal
   *
   * 3 = FlipVertical
   */
  RotateType: RotateType
}

/**
 *
 *
 * 0 = Rotate90Clockwise
 *
 * 1 = Rotate90Anticlockwise
 *
 * 2 = FlipHorizontal
 *
 * 3 = FlipVertical
 * @format int32
 */
export enum RotateType {
  Rotate90Clockwise = 0,
  Rotate90Anticlockwise = 1,
  FlipHorizontal = 2,
  FlipVertical = 3,
}

export interface Scale {
  /** @format double */
  X: number
  /** @format double */
  Y: number
  /** @format double */
  Z: number
}

/**
 *
 *
 * 1 = Tenant
 *
 * 2 = Corporation
 * @format int32
 */
export enum Scope {
  Tenant = 1,
  Corporation = 2,
}

export interface SearchTargetContentRequest {
  /**
   * The search query by which the content description is matched.
   * @minLength 1
   * @maxLength 4000
   */
  SearchQuery: string
  /**
   * The id of a content owner.
   * @format int32
   */
  ContentOwnerId?: number | null
  /**
   * The id of a tenant.
   * @format int32
   */
  TenantId: number
}

/**
 *
 *
 * 1 = AllParticipant
 *
 * 2 = SessionOwner
 *
 * 3 = SpecificUsers
 * @format int32
 */
export enum SendEmailConditionType {
  AllParticipant = 1,
  SessionOwner = 2,
  SpecificUsers = 3,
}

/**
 *
 *
 * 0 = Presentation
 *
 * 1 = Webinar
 *
 * 2 = ClassRoom
 * @format int32
 */
export enum SessionMode {
  Presentation = 0,
  Webinar = 1,
  ClassRoom = 2,
}

/**
 *
 *
 * 0 = AddGalleryContent
 *
 * 1 = ExportGalleryContent
 *
 * 2 = AnswerQuestions
 *
 * 3 = RejectApprove
 *
 * 4 = AddForms
 *
 * 5 = StartCalls
 *
 * 6 = InviteUsers
 *
 * 7 = CompleteReview
 *
 * 8 = SendReviewFeedback
 *
 * 9 = DeleteAllFormAnswers
 *
 * 10 = ExportSession
 *
 * 11 = ExportFormAsCsv
 *
 * 12 = ExportFormAsPdf
 *
 * 13 = DeleteRenameAllGalleryContent
 *
 * 14 = RemoveUsers
 *
 * 15 = ChangeUserRole
 *
 * 16 = SetVideobridge
 *
 * 17 = RenameSession
 *
 * 18 = SendChatMessages
 *
 * 19 = AddAiAnnotations
 *
 * 20 = AddAnnotations
 *
 * 21 = MainScreenToolbarTracking
 *
 * 22 = RotateImages
 *
 * 23 = AlertHost
 *
 * 24 = DeleteRenameOwnGalleryContent
 *
 * 25 = PublishSessions
 *
 * 26 = JoinCall
 *
 * 27 = AddDeleteReminder
 *
 * 28 = ReadSpreadsheets
 *
 * 29 = HealthDataView
 *
 * 30 = SendForInContentReview
 *
 * 31 = CompleteOrFeedbackInContentReview
 *
 * 32 = ManagePageFolderPermissions
 *
 * 33 = ManageTrainingMaterials
 *
 * 34 = ManageContentReviews
 * @format int32
 */
export enum SessionPermission {
  AddGalleryContent = 0,
  ExportGalleryContent = 1,
  AnswerQuestions = 2,
  RejectApprove = 3,
  AddForms = 4,
  StartCalls = 5,
  InviteUsers = 6,
  CompleteReview = 7,
  SendReviewFeedback = 8,
  DeleteAllFormAnswers = 9,
  ExportSession = 10,
  ExportFormAsCsv = 11,
  ExportFormAsPdf = 12,
  DeleteRenameAllGalleryContent = 13,
  RemoveUsers = 14,
  ChangeUserRole = 15,
  SetVideobridge = 16,
  RenameSession = 17,
  SendChatMessages = 18,
  AddAiAnnotations = 19,
  AddAnnotations = 20,
  MainScreenToolbarTracking = 21,
  RotateImages = 22,
  AlertHost = 23,
  DeleteRenameOwnGalleryContent = 24,
  PublishSessions = 25,
  JoinCall = 26,
  AddDeleteReminder = 27,
  ReadSpreadsheets = 28,
  HealthDataView = 29,
  SendForInContentReview = 30,
  CompleteOrFeedbackInContentReview = 31,
  ManagePageFolderPermissions = 32,
  ManageTrainingMaterials = 33,
  ManageContentReviews = 34,
}

export interface SessionPermissionIEnumerablePermissionsResponse {
  Permissions?: SessionPermission[] | null
}

export interface SessionStorageSwitchRequest {
  /** @format int32 */
  StorageId: number
}

/**
 *
 *
 * 10 = UserSessions
 *
 * 20 = AllSessions
 *
 * 30 = PublishedSessions
 * @format int32
 */
export enum SessionsDisplayType {
  UserSessions = 10,
  AllSessions = 20,
  PublishedSessions = 30,
}

export interface SetFormAnswerStatusRequest {
  /** @format int32 */
  FormAnswerId: number
  /**
   *
   *
   * 0 = Pending
   *
   * 1 = Pass
   *
   * 2 = Fail
   *
   * 3 = Empty
   *
   * 4 = ApprovedByAI
   *
   * 5 = RejectedByAI
   *
   * 6 = ApprovedByReviewer
   *
   * 7 = RejectedByReviewer
   */
  FormAnswerStatus: FormAnswerStatus
  /** @format int32 */
  ContentId: number
}

export interface SetFormAnswerStatusResponse {
  /** @format int32 */
  FormAnswerId: number
  /**
   *
   *
   * 0 = Pending
   *
   * 1 = Pass
   *
   * 2 = Fail
   *
   * 3 = Empty
   *
   * 4 = ApprovedByAI
   *
   * 5 = RejectedByAI
   *
   * 6 = ApprovedByReviewer
   *
   * 7 = RejectedByReviewer
   */
  FormAnswerStatus: FormAnswerStatus
  /** @format int32 */
  ContentId: number
  /** @format int32 */
  ContentFormId: number
  /** @format int32 */
  FormControlId: number
  FormTabIds?: number[] | null
  /** @format int32 */
  ApproverId?: number | null
  ApproverName?: string | null
  /** @format date-time */
  FormAnswerStatusCreatedOn: string
}

export interface SetPermissionsRequest {
  /** @format int32 */
  UserId: number
  Permissions?: PageFolderPermission[] | null
}

export interface SetPresenterRequest {
  /** @format int32 */
  ContentId: number
  /** @format int32 */
  PresenterId?: number | null
}

export interface SetVideoBridgeRequest {
  /** @format int32 */
  ContentId: number
  VideobridgeUrl?: string | null
}

export interface ShapeAnnotationExternalCreateRequest {
  /**
   *
   *
   * 0 = StrokeDraw
   *
   * 1 = StrokeErase
   *
   * 2 = Laser
   *
   * 3 = Text
   *
   * 4 = Audio
   *
   * 5 = Text_Callout
   *
   * 6 = HotSpot
   *
   * 7 = LinkedPage
   *
   * 8 = AI
   *
   * 9 = AIHotspot
   *
   * 10 = Box
   *
   * 11 = Distance
   *
   * 12 = Model
   *
   * 13 = Height
   *
   * 14 = Area
   *
   * 15 = Cylinder
   *
   * 16 = Polyline
   *
   * 100 = StrokeDraw_Shape_Line
   *
   * 101 = StrokeDraw_Shape_Rectangle
   *
   * 102 = StrokeDraw_Shape_Ellipse
   *
   * 103 = StrokeDraw_Shape_Rectangle_Filled
   *
   * 104 = StrokeDraw_Shape_Ellipse_Filled
   *
   * 105 = StrokeDraw_Shape_Line_ArrowEnd
   *
   * 106 = StrokeDraw_Shape_Line_ArrowBoth
   *
   * 107 = Polygon
   */
  Type: AnnotationType
  /**
   * Coordinates of the annotation. Required for annotations with types:
   * <list type="bullet"><item>Tabeeb.Shared.Common.Enums.AnnotationType.StrokeDraw_Shape_Line</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.StrokeDraw_Shape_Rectangle</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.StrokeDraw_Shape_Ellipse</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.StrokeDraw_Shape_Rectangle_Filled</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.StrokeDraw_Shape_Ellipse_Filled</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.StrokeDraw_Shape_Line_ArrowEnd</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.StrokeDraw_Shape_Line_ArrowBoth</item><item>Tabeeb.Shared.Common.Enums.AnnotationType.Polygon</item></list>
   */
  Coordinates: Coordinates[]
  /** Annotation name */
  Name?: string | null
  /**
   * Unique id of the page within the system
   * @format int32
   */
  PageId: number
  /**
   * The time on video/audio when an annotation has been created. Optional
   * @format float
   * @default -1
   */
  Timestamp: number
  /**
   * The color of the annotation. Optional
   * @default "#FB000E"
   */
  Color?: string | null
  /**
   * The width of the annotation lines/font. Optional
   * @format int32
   * @default 3
   */
  Width: number
  /**
   * Unique id of the parent annotation within the system. Optional
   * @format int32
   */
  ParentAnnotationId?: number | null
}

/**
 *
 *
 * 0 = AllData
 *
 * 1 = SelectedData
 * @format int32
 */
export enum SharedContentDataType {
  AllData = 0,
  SelectedData = 1,
}

export interface Sorting {
  /**
   *
   *
   * 1 = Name
   *
   * 2 = Email
   *
   * 3 = Role
   *
   * 4 = Tenant
   *
   * 5 = IsDisabled
   *
   * 6 = IsCreatedByAdmin
   */
  Column: AdminUsersSortingColumnEnum
  /**
   *
   *
   * 1 = asc
   *
   * 2 = desc
   */
  Order: SortingOrder
}

/**
 *
 *
 * 1 = asc
 *
 * 2 = desc
 * @format int32
 */
export enum SortingOrder {
  Asc = 1,
  Desc = 2,
}

export interface SpatialViewPageCreateRequest {
  /**
   * List of pages ids, from which 360 view will be created
   * @minItems 1
   */
  PageIds: number[]
  /**
   * Unique id of the session within the system
   * @format int32
   */
  ContentId: number
  /**
   * Name of page
   * @maxLength 256
   */
  Name?: string | null
  /**
   * Unique id of the session folder within the system
   * @format int32
   */
  FolderId?: number | null
  /** @format int32 */
  TimeZoneOffset: number
  /**
   *
   *
   * 0 = Creating
   *
   * 1 = Created
   *
   * 2 = Failed
   */
  Status: PageStatus
}

export interface StartExportImagesRequest {
  /** @format int32 */
  ContentId: number
  /** @format int32 */
  FolderId?: number | null
  IsWithAnnotations: boolean
  /**
   *
   *
   * 0 = All
   *
   * 1 = CurrentGalleryView
   */
  GalleryOption: ExportGalleryOptions
  /** @minItems 1 */
  Emails: string[]
}

export interface StartExportPdfRequest {
  /** @format int32 */
  ContentId: number
  /** @format int32 */
  FolderId?: number | null
  /**
   *
   *
   * 0 = PagesInGallery
   *
   * 1 = FormQuestions
   */
  Option: ExportAsPdfOptions
  /**
   *
   *
   * 0 = All
   *
   * 1 = CurrentGalleryView
   */
  GalleryOption: ExportGalleryOptions
  /** @minItems 1 */
  Emails: string[]
}

export interface StructureModelCreated {
  /** @format int32 */
  ContentId: number
  /** @format int32 */
  UserId: number
}

/**
 *
 *
 * 1 = CentroidsPlot
 *
 * 2 = StructureModel
 *
 * 3 = AnalyticsReport
 *
 * 4 = PdfAnalyticsReport
 *
 * 5 = TPAReport
 * @format int32
 */
export enum StructureModelFileType {
  CentroidsPlot = 1,
  StructureModel = 2,
  AnalyticsReport = 3,
  PdfAnalyticsReport = 4,
  TPAReport = 5,
}

/**
 *
 *
 * 0 = NotCreated
 *
 * 1 = Creating
 *
 * 2 = Created
 * @format int32
 */
export enum StructureModelStatus {
  NotCreated = 0,
  Creating = 1,
  Created = 2,
}

export interface SwitchOwnerRequest {
  /**
   * The id of particular session.
   * @format int32
   */
  ContentId: number
  /**
   * The id of user, for whom session is switched.
   * @format int32
   */
  NewOwnerId: number
  IgnoreSessionStatus: boolean
}

export interface SwitchReviewerRequest {
  /** @format int32 */
  ContentId: number
  /** @format int32 */
  NewReviewerId: number
}

export interface SwitchUserRoleRequest {
  /**
   * The id of the particular session.
   * @format int32
   */
  ContentId: number
  /**
   * The id of the user whose role should change.
   * @format int32
   */
  UserId: number
  /**
   *
   *
   * 0 = User
   *
   * 1 = Owner
   *
   * 2 = AIUser
   *
   * 3 = Reviewer
   *
   * 4 = Viewer
   *
   * 5 = Labeler
   *
   * 6 = Approver
   *
   * 7 = Guest
   */
  Role: ContentUserRole
}

/**
 *
 *
 * 0 = Metric
 *
 * 1 = Imperial
 *
 * 2 = OutOfSystem
 * @format int32
 */
export enum SystemOfMeasureTypes {
  Metric = 0,
  Imperial = 1,
  OutOfSystem = 2,
}

export interface TargetContentForMergingResponse {
  /** @format int32 */
  Id: number
  /** @format int32 */
  OwnerId: number
  OwnerName?: string | null
  /** @format date-time */
  CreatedOn: string
  Description?: string | null
  ThumbnailUrl?: string | null
  IsActive: boolean
  HasActiveReview: boolean
}

export interface TenantFormResponse {
  /** @format int32 */
  Id: number
  /** @format int32 */
  TenantId: number
  /** @format int32 */
  FormId: number
  Name?: string | null
}

/**
 *
 *
 * 1 = CreateSessions
 *
 * 2 = ShareContents
 *
 * 3 = CreateForms
 *
 * 4 = TenantSettings
 *
 * 5 = BillingSettings
 *
 * 6 = AISettings
 *
 * 7 = AllSessionsAccess
 *
 * 8 = StoragesAccess
 *
 * 9 = AllFormsView
 *
 * 10 = ReviewRejectInAnySession
 *
 * 11 = AllTenantsAccess
 *
 * 12 = AllUsersView
 *
 * 13 = Devices
 *
 * 14 = Analytics
 *
 * 15 = EditPolicies
 *
 * 16 = BulkCopy
 *
 * 17 = Reports
 *
 * 18 = SessionApprovalSettings
 *
 * 19 = CreateFolders
 *
 * 20 = PublishForms
 *
 * 21 = GeosearchSettings
 *
 * 22 = SessionNamingConventionSettings
 *
 * 23 = OverlaySettings
 *
 * 24 = PredictionSettings
 *
 * 25 = DetectionSettings
 *
 * 26 = SessionSharingSettings
 *
 * 27 = ReviewingSettings
 *
 * 28 = FtpSettings
 *
 * 29 = FtpExportSettings
 *
 * 30 = AppearanceSettings
 *
 * 31 = TrackingSettings
 *
 * 32 = VideoBridgeSettings
 *
 * 33 = PremiumFeaturesSettings
 *
 * 34 = FormBuilderSettings
 *
 * 35 = SsoSettings
 *
 * 36 = MobileAppSettings
 *
 * 37 = ExportReceiversSettings
 *
 * 38 = UploadUsers
 *
 * 39 = AIStateManagment
 *
 * 40 = SwitchContentOwner
 *
 * 41 = AddContentUsers
 *
 * 42 = SwitchContentReviewer
 *
 * 43 = UpdateSessionStorage
 *
 * 44 = JoinContentReview
 *
 * 45 = ReminderSettings
 *
 * 46 = ThreeDimensionalModelSettings
 *
 * 47 = PublishFormsSettings
 *
 * 48 = CreateReports
 *
 * 49 = CalendarSettings
 *
 * 50 = WriteSpreadsheets
 *
 * 51 = AllSpreadsheetsAccess
 *
 * 52 = CreatePublishFormWhenRestricted
 *
 * 53 = RolesSettings
 *
 * 54 = HealthKitSettings
 *
 * 55 = AccountManagementSettings
 *
 * 56 = PublishFormFolders
 *
 * 57 = AllCalendarEventsAccess
 *
 * 58 = ShowAddVQAButton
 *
 * 59 = ThreeDimensionalModelsManagement
 *
 * 60 = SendApproveOrRejectNotificationSettings
 *
 * 61 = AnalyticsReports
 *
 * 62 = CertificatesSettings
 *
 * 63 = ChangeExpirationCertificateReminder
 *
 * 64 = ModelTraining
 *
 * 65 = ChangeInContentReviewStatus
 *
 * 66 = CustomIframeSettings
 *
 * 67 = ManageSystemAnnouncements
 *
 * 68 = ManageTenantAnnouncements
 *
 * 69 = InventoryAnalysis
 *
 * 70 = PublishInventoryAnalysis
 *
 * 71 = PublishInventoryAnalysisSettings
 *
 * 72 = InventoryAnalysisSettings
 *
 * 73 = ManageTenantGeneratedReports
 *
 * 74 = ManageTenantScheduledGeneratedReports
 *
 * 75 = ManageTenantGeneratedReportsReceivers
 *
 * 76 = CertificatesTenantScope
 *
 * 77 = CertificatesGlobalScope
 *
 * 78 = ContractsManagement
 *
 * 79 = ManageQualifications
 *
 * 80 = ManageWorkflows
 *
 * 81 = ManageTrainingMaterials
 *
 * 82 = ContentApproval
 *
 * 83 = BulkImport
 *
 * 84 = ManageCreateContentRestriction
 *
 * 85 = CreateContentUnderRestriction
 *
 * 86 = ViewSalesforceIntegrationNodes
 *
 * 87 = ManageChatBots
 *
 * 88 = ContentApprovalUnderRestriction
 *
 * 89 = ManageCorporations
 *
 * 90 = ManageCorporationCertificatesAndQualifications
 *
 * 91 = ManageCorporationUsers
 *
 * 92 = ManageCorporationTenantSettings
 *
 * 93 = ManageCorporationBillingSettings
 *
 * 94 = ManageCorporationAnnouncements
 * @format int32
 */
export enum TenantPermission {
  CreateSessions = 1,
  ShareContents = 2,
  CreateForms = 3,
  TenantSettings = 4,
  BillingSettings = 5,
  AISettings = 6,
  AllSessionsAccess = 7,
  StoragesAccess = 8,
  AllFormsView = 9,
  ReviewRejectInAnySession = 10,
  AllTenantsAccess = 11,
  AllUsersView = 12,
  Devices = 13,
  Analytics = 14,
  EditPolicies = 15,
  BulkCopy = 16,
  Reports = 17,
  SessionApprovalSettings = 18,
  CreateFolders = 19,
  PublishForms = 20,
  GeosearchSettings = 21,
  SessionNamingConventionSettings = 22,
  OverlaySettings = 23,
  PredictionSettings = 24,
  DetectionSettings = 25,
  SessionSharingSettings = 26,
  ReviewingSettings = 27,
  FtpSettings = 28,
  FtpExportSettings = 29,
  AppearanceSettings = 30,
  TrackingSettings = 31,
  VideoBridgeSettings = 32,
  PremiumFeaturesSettings = 33,
  FormBuilderSettings = 34,
  SsoSettings = 35,
  MobileAppSettings = 36,
  ExportReceiversSettings = 37,
  UploadUsers = 38,
  AIStateManagment = 39,
  SwitchContentOwner = 40,
  AddContentUsers = 41,
  SwitchContentReviewer = 42,
  UpdateSessionStorage = 43,
  JoinContentReview = 44,
  ReminderSettings = 45,
  ThreeDimensionalModelSettings = 46,
  PublishFormsSettings = 47,
  CreateReports = 48,
  CalendarSettings = 49,
  WriteSpreadsheets = 50,
  AllSpreadsheetsAccess = 51,
  CreatePublishFormWhenRestricted = 52,
  RolesSettings = 53,
  HealthKitSettings = 54,
  AccountManagementSettings = 55,
  PublishFormFolders = 56,
  AllCalendarEventsAccess = 57,
  ShowAddVQAButton = 58,
  ThreeDimensionalModelsManagement = 59,
  SendApproveOrRejectNotificationSettings = 60,
  AnalyticsReports = 61,
  CertificatesSettings = 62,
  ChangeExpirationCertificateReminder = 63,
  ModelTraining = 64,
  ChangeInContentReviewStatus = 65,
  CustomIframeSettings = 66,
  ManageSystemAnnouncements = 67,
  ManageTenantAnnouncements = 68,
  InventoryAnalysis = 69,
  PublishInventoryAnalysis = 70,
  PublishInventoryAnalysisSettings = 71,
  InventoryAnalysisSettings = 72,
  ManageTenantGeneratedReports = 73,
  ManageTenantScheduledGeneratedReports = 74,
  ManageTenantGeneratedReportsReceivers = 75,
  CertificatesTenantScope = 76,
  CertificatesGlobalScope = 77,
  ContractsManagement = 78,
  ManageQualifications = 79,
  ManageWorkflows = 80,
  ManageTrainingMaterials = 81,
  ContentApproval = 82,
  BulkImport = 83,
  ManageCreateContentRestriction = 84,
  CreateContentUnderRestriction = 85,
  ViewSalesforceIntegrationNodes = 86,
  ManageChatBots = 87,
  ContentApprovalUnderRestriction = 88,
  ManageCorporations = 89,
  ManageCorporationCertificatesAndQualifications = 90,
  ManageCorporationUsers = 91,
  ManageCorporationTenantSettings = 92,
  ManageCorporationBillingSettings = 93,
  ManageCorporationAnnouncements = 94,
}

export interface TenantPermissionIEnumerablePermissionsResponse {
  Permissions?: TenantPermission[] | null
}

export interface TenantResponse {
  /** @format int32 */
  Id: number
  /** @minLength 1 */
  Name: string
}

export interface ThreeDimensionalModelCreateRequest {
  /**
   * @format binary
   * @minLength 1
   */
  Url: File
  /**
   * @minLength 1
   * @maxLength 128
   */
  Name: string
  Thumbnail?: string | null
  /** @format int32 */
  Id: number
}

export interface ThreeDimensionalModelResponse {
  Url?: string | null
  Name?: string | null
  Thumbnail?: string | null
  /** @format int32 */
  Id: number
}

/**
 *
 *
 * 1 = Session
 *
 * 2 = Page
 *
 * 3 = FormAnswer
 * @format int32
 */
export enum TopicType {
  Session = 1,
  Page = 2,
  FormAnswer = 3,
}

/**
 *
 *
 * 0 = Point
 *
 * 1 = Rectangle
 *
 * 2 = Circle
 * @format int32
 */
export enum TrackingAnnotationType {
  Point = 0,
  Rectangle = 1,
  Circle = 2,
}

/**
 *
 *
 * 0 = CheckIn
 *
 * 1 = CheckOut
 *
 * 2 = Manual
 * @format int32
 */
export enum TrackingEventType {
  CheckIn = 0,
  CheckOut = 1,
  Manual = 2,
}

export interface TrackingPoint {
  /** @format double */
  Latitude: number
  /** @format double */
  Longitude: number
}

export interface TrackingQualificationVersion {
  /** @format int32 */
  Id: number
  Name: string | null
  /**
   *
   *
   * 1 = Pending
   *
   * 2 = Active
   *
   * 3 = Revoked
   *
   * 4 = CertificateExpired
   *
   * 5 = VersionExpired
   *
   * 6 = CertificateTypeDeleted
   *
   * 7 = QualificationDeleted
   */
  Status: UserAssignedQualificationStatusType
  /** @format date-time */
  QualificationVersionCreatedOn: string
  /** @format date-time */
  QualificationVersionExpirationDate: string
  /** @format uuid */
  QualificationVersionAssignedBy: string
  Certificates: TrackingQualificationVersionCertificate[] | null
}

export interface TrackingQualificationVersionCertificate {
  /** @format int32 */
  Id: number
  Url: string | null
  /**
   *
   *
   * 1 = PendingReview
   *
   * 2 = Approved
   *
   * 3 = Rejected
   *
   * 4 = Expired
   *
   * 5 = Draft
   *
   * 6 = Obsolete
   *
   * 7 = Processed
   */
  Status: CertificateStatusType
  /** @format date-time */
  ValidFrom: string
  /** @format date-time */
  ValidTo: string
  /** @format int32 */
  TypeId: number
  TypeName: string | null
  /**
   *
   *
   * 1 = UserCertificate
   *
   * 2 = ProfileCertificate
   *
   * 3 = TenantCertificate
   */
  CertificateScope: CertificateScopeType
  CertificateCategory: string | null
}

export interface TrackingResponse {
  /**
   * Exact day and time (in UTC) when a tracking was created
   * @format date-time
   */
  CreatedOn: string
  /**
   *
   *
   * 0 = CheckIn
   *
   * 1 = CheckOut
   *
   * 2 = Manual
   */
  EventType: TrackingEventType
  /**
   *
   *
   * 0 = Point
   *
   * 1 = Rectangle
   *
   * 2 = Circle
   */
  AnnotationType: TrackingAnnotationType
  /**
   * Unique id of the session within the system
   * @format int32
   */
  ContentId: number
  /** Name of the session assigned by the system automatically or changed by the user manually */
  SessionName?: string | null
  /**
   * Unique id of the user within the system
   * @format int32
   */
  UserId: number
  User?: BaseUserInfoWithoutAvatarResponse
  /**
   * List of coordinates related to tracking (depends on value of AnnotationType field):
   * - Point - contains 1 point: exact coordinates of point on the map;
   * - Rectangle - contains 2 points: coordinates of top left and bottom right corners of rectangle on the map;
   * - Cirle - contains 2 points: coordinates of top left and bottom right points of rectangle into which the circle should fit on the map.
   */
  Coordinates?: TrackingPoint[] | null
  /** @format int32 */
  Id: number
}

export interface TrackingUser {
  /** @format int32 */
  Id: number
  UserName: string | null
  UserEmail: string | null
  /** @format date-time */
  CreatedOn: string
  Claims: TrackingUserClaim[] | null
  Qualifications: TrackingQualificationVersion[] | null
}

export interface TrackingUserClaim {
  Type: string | null
  Value: string | null
}

export interface TrackingsSnaphotResponse {
  Users: TrackingUser[] | null
  /** @format int32 */
  TotalCount: number
}

export interface TriggerFormActionRequest {
  /** @format int32 */
  FormActionId: number
  /** @format int32 */
  ContentId: number
  SelectedFormTabsIds?: number[] | null
}

export interface UnarchiveRequest {
  /** @format int32 */
  PageId: number
}

export interface UniqueAIObjectFromStructureModelCreateRequest {
  /** @minLength 1 */
  UniqueObjectName: string
  TagName: string
  Properties?: any
  Detections: DetectionFromStructureModelCreateRequest[]
}

export interface UpdateCalendarSubscriptionColorRequest {
  /**
   * The main color of the calendar in the hexadecimal format.
   * @minLength 1
   */
  Color: string
}

export interface UpdateCalendarSubscriptionDisplayRequest {
  /**
   *
   *
   * 0 = Hide
   *
   * 1 = Display
   *
   * 2 = DisplayThisOnly
   */
  Mode: CalendarSubscriptionDisplayMode
}

export interface UpdateContentDescriptionForTenantRequest {
  /**
   * A reviewed content Id.
   * @format int32
   */
  ContentId: number
  /**
   * A reviewer tenant Id. Either a tenant Id or a subdomain must be presented.
   * @format int32
   */
  TenantId?: number | null
  /**
   * A reviewer tenant subdomain. Either a tenant Id or a subdomain must be presented.
   * @maxLength 256
   */
  Subdomain?: string | null
  /**
   * A new name of a content.
   * @minLength 1
   * @maxLength 4000
   */
  Description: string
  /** Array of objects, required for displaying session name in json format in reports (if session name created using naming convention). */
  ContentNameParts?: ContentNamePartRequest[] | null
}

export interface UpdateContentNameRequest {
  /**
   * The name of the session.
   * @minLength 1
   * @maxLength 4000
   */
  Description: string
  /**
   * Unique id of the session within the system.
   * @format int32
   */
  ContentId: number
  /** Array of objects, required for displaying session name in json format in reports (if session name created using naming convention). */
  ContentNameParts?: ContentNamePartRequest[] | null
}

export interface UpdateContentUserQualificationsRequest {
  /** @format int32 */
  UserId: number
  /** @format int32 */
  ContentId: number
  QualificationIds: number[]
}

export interface UpdateFormPermissionsByFormRequest {
  GrantedPermissions?: FormPermissionsByContentRoleDto[] | null
}

export interface UpdateFormPermissionsByTenantRequest {
  GrantedPermissions: FormPermissionsByContentRoleDto[]
}

export interface UpdatePageNameRequest {
  /** @format int32 */
  PageId: number
  /** @format int32 */
  ContentId: number
}

export interface UpdatePagesFolderRequest {
  /** List of unique pages ids */
  PageIds: number[]
  /**
   * Id of the folder to which the pages are moved
   * @format int32
   */
  FolderId?: number | null
}

export interface UpdatePrivacyRequest {
  /** @format int32 */
  FolderId: number
  IsPrivate: boolean
}

export interface UpdateThumbnailRequest {
  /** @format int32 */
  PageId: number
  /** @format int32 */
  FormControlInfoId: number
  ThumbnailUrl?: string | null
  UpdatePage: boolean
}

export interface UploadAudioRequest {
  /**
   * Base64 encoded string of binary audio data.
   * @minLength 1
   */
  Data: string
  /**
   * Unique id of the session within the system.
   * @format int32
   */
  ContentId: number
}

/**
 *
 *
 * 1 = Page
 *
 * 2 = FormThumbnail
 *
 * 3 = SettingData
 *
 * 4 = AiExpressionImage
 *
 * 5 = ArticleDocument
 *
 * 6 = FormData
 *
 * 7 = AudioChatMessage
 *
 * 8 = AssistantDocument
 *
 * 9 = ThreeDimensionalModel
 *
 * 10 = ThreeDimensionalModelThumbnail
 * @format int32
 */
export enum UploadContentType {
  Page = 1,
  FormThumbnail = 2,
  SettingData = 3,
  AiExpressionImage = 4,
  ArticleDocument = 5,
  FormData = 6,
  AudioChatMessage = 7,
  AssistantDocument = 8,
  ThreeDimensionalModel = 9,
  ThreeDimensionalModelThumbnail = 10,
}

export interface UploadFileModel {
  /** @format int32 */
  ContentId: number
  /** @format int32 */
  UserId: number
  /** @minLength 1 */
  File: string
  /**
   *
   *
   * 1 = CentroidsPlot
   *
   * 2 = StructureModel
   *
   * 3 = AnalyticsReport
   *
   * 4 = PdfAnalyticsReport
   *
   * 5 = TPAReport
   */
  FileType: StructureModelFileType
}

export interface UploadedFileResponse {
  /** Url to the blob starage */
  Url?: string | null
  /**
   * File size
   * @format int64
   */
  Size: number
}

export interface UserAddressRequest {
  /** @maxLength 512 */
  Line1?: string | null
  /** @maxLength 512 */
  Line2?: string | null
  /** @maxLength 256 */
  City?: string | null
  /** @maxLength 256 */
  State?: string | null
  /** @maxLength 16 */
  PostalCode?: string | null
  /** @maxLength 256 */
  Country?: string | null
  /** @format int32 */
  Id: number
}

export interface UserAdminInfoResponse {
  /** @format int32 */
  Id: number
  Name?: string | null
  UserName?: string | null
  AvatarUrl?: string | null
  Email?: string | null
  FirstName?: string | null
  LastName?: string | null
  EmployeeId?: string | null
  PhoneNumber?: string | null
  IsDisabled: boolean
  Role?: string | null
  /** @format int32 */
  TenantId: number
  IsCreatedByAdmin: boolean
  Password?: string | null
  /** @format int32 */
  TotalCount: number
  ShowHealthData: boolean
  /** @format uuid */
  IdentityGuid: string
}

export interface UserAdminResponse {
  /** @format int32 */
  Id: number
  Name?: string | null
  UserName?: string | null
  AvatarUrl?: string | null
  Email?: string | null
  FirstName?: string | null
  LastName?: string | null
  EmployeeId?: string | null
  PhoneNumber?: string | null
  IsDisabled: boolean
  Role?: string | null
  /** @format int32 */
  TenantId: number
  TenantName?: string | null
  IsCreatedByAdmin: boolean
  /** @format int32 */
  TotalCount: number
  ShowHealthData: boolean
  /** @format uuid */
  IdentityGuid: string
}

export interface UserAdminUpdateInfoModel {
  /**
   * The username of the user (email, first name, last name, etc.)
   * @minLength 1
   * @maxLength 120
   */
  UserName: string
  /**
   * The email address associated with the account.
   * @format email
   * @minLength 1
   * @maxLength 120
   */
  Email: string
  /**
   * The first name of the user.
   * @maxLength 35
   */
  FirstName?: string | null
  /**
   * The last name of the user.
   * @maxLength 35
   */
  LastName?: string | null
  /**
   * The EmployeeId of the user.
   * @maxLength 128
   * @pattern ^[a-zA-Z0-9_-]+$
   */
  EmployeeId?: string | null
  /** The indicator of whether user was created by Admin or not. */
  IsCreatedByAdmin: boolean
  Address?: UserAddressRequest
}

/**
 *
 *
 * 1 = Pending
 *
 * 2 = Active
 *
 * 3 = Revoked
 *
 * 4 = CertificateExpired
 *
 * 5 = VersionExpired
 *
 * 6 = CertificateTypeDeleted
 *
 * 7 = QualificationDeleted
 * @format int32
 */
export enum UserAssignedQualificationStatusType {
  Pending = 1,
  Active = 2,
  Revoked = 3,
  CertificateExpired = 4,
  VersionExpired = 5,
  CertificateTypeDeleted = 6,
  QualificationDeleted = 7,
}

export interface UserAvatarRequest {
  Name?: string | null
  Data?: string | null
}

export interface UserChatsResponse {
  /** @format int32 */
  SessionId: number
  /** @format int32 */
  AgentId?: number | null
  AgentName?: string | null
  AgentEmail?: string | null
  AgentAvatarUrl?: string | null
  SessionName?: string | null
  /** @format int32 */
  LastMessageSenderId: number
  LastMessageSenderName?: string | null
  LastMessageSenderEmail?: string | null
  LastMessageSenderAvatarUrl?: string | null
  /** @format int32 */
  LastMessageId: number
  /** @format date-time */
  LastMessageCreatedOn?: string | null
  LastMessageText?: string | null
  /**
   *
   *
   * 0 = Unknown
   *
   * 1 = Audio
   */
  LastMessageAssetType?: ChatMessageAssetType
  /** @format int32 */
  CountUnread: number
}

export interface UserChatsSearchModelFiltering {
  SearchQuery?: string | null
}

export interface UserChatsSearchModelSorting {
  Column: UserChatsSortingColumnEnum
  /**
   *
   *
   * 1 = asc
   *
   * 2 = desc
   */
  Order: SortingOrder
}

export interface UserChatsSearchRequest {
  Sorting?: UserChatsSearchModelSorting
  Filtering?: UserChatsSearchModelFiltering
  /**
   * @format int32
   * @default 1
   */
  PageNumber: number
  /**
   * @format int32
   * @default 25
   */
  PageSize: number
}

/** @format int32 */
export type UserChatsSortingColumnEnum = number

export interface UserClaimResponse {
  Type: string
  Value?: string | null
}

export interface UserContentFormResponse {
  /** @format int32 */
  ContentFormId: number
  /** @format int32 */
  ContentId: number
  ContentDescription?: string | null
  /** @format int32 */
  FormId: number
  FormName?: string | null
  /** @format date-time */
  LastReminderCreatedOn?: string | null
}

/** @format int32 */
export type UserContentFormSortingColumnEnum = number

export interface UserContentFormsSearchModelFiltering {
  SearchQuery?: string | null
}

export interface UserContentFormsSearchModelSorting {
  Column: UserContentFormSortingColumnEnum
  /**
   *
   *
   * 1 = asc
   *
   * 2 = desc
   */
  Order: SortingOrder
}

export interface UserContentFormsSearchRequest {
  Sorting?: UserContentFormsSearchModelSorting
  Filtering?: UserContentFormsSearchModelFiltering
  /**
   * @format int32
   * @default 1
   */
  PageNumber: number
  /**
   * @format int32
   * @default 25
   */
  PageSize: number
}

export interface UserIdResponse {
  /** @format int32 */
  UserId: number
}

export interface UserInfoResponse {
  /** @format uuid */
  IdentityGuid: string
  /**
   *
   *
   * 0 = Unknown
   *
   * 1 = WebBrowser
   *
   * 2 = AndroidDevice
   *
   * 3 = AppleDevice
   *
   * 4 = AndroidBrowser
   *
   * 5 = IosBrowser
   */
  DeviceType: DeviceTypes
  IsGuest: boolean
  IsOwner: boolean
  IsDeleted: boolean
  /**
   *
   *
   * 0 = User
   *
   * 1 = Owner
   *
   * 2 = AIUser
   *
   * 3 = Reviewer
   *
   * 4 = Viewer
   *
   * 5 = Labeler
   *
   * 6 = Approver
   *
   * 7 = Guest
   */
  Role: ContentUserRole
  ChatNotificationsMuted: boolean
  /** @format int32 */
  Id: number
  Name?: string | null
  UserName?: string | null
  FirstName?: string | null
  LastName?: string | null
  Email?: string | null
  AvatarUrl?: string | null
  IsAccountDeleted: boolean
}

export interface UserResponse {
  /** @format int32 */
  Id: number
  /** @format uuid */
  IdentityGuid: string
  /** @minLength 1 */
  Email: string
  FirstName?: string | null
  LastName?: string | null
  EmployeeId?: string | null
  Name?: string | null
  Institution?: string | null
  PhoneNumber?: string | null
  PhoneNumberConfirmed: boolean
  DateOfBirth?: string | null
  IsCreatedByAdmin: boolean
  Address?: UserAddressRequest
  /**
   *
   *
   * 1 = Male
   *
   * 2 = Female
   *
   * 3 = Other
   */
  Gender?: GenderTypes
  /**
   *
   *
   * 0 = Metric
   *
   * 1 = Imperial
   *
   * 2 = OutOfSystem
   */
  SystemOfMeasure: SystemOfMeasureTypes
  AvatarUrl?: string | null
  TenantRole?: string | null
  RoleName?: string | null
  /** @format int32 */
  TenantId: number
  TwoFactorEnabled: boolean
  SsoOrMobileUser: boolean
  Signature?: UserSignatureResponse
  Claims?: UserClaimResponse[] | null
}

export interface UserSearchInfoResponse {
  /** @format int32 */
  Id: number
  /** @format uuid */
  IdentityGuid: string
  Name?: string | null
  UserName?: string | null
  AvatarUrl?: string | null
  Email?: string | null
  PhoneNumber?: string | null
  IsFindByPhone: boolean
}

export interface UserSignatureRequest {
  /** @minLength 1 */
  Value: string
  /**
   *
   *
   * 1 = Text
   *
   * 2 = Drawing
   */
  Type: UserSignatureType
}

export interface UserSignatureResponse {
  /** @format int32 */
  Id: number
  Value?: string | null
  /**
   *
   *
   * 1 = Text
   *
   * 2 = Drawing
   */
  Type: UserSignatureType
}

/**
 *
 *
 * 1 = Text
 *
 * 2 = Drawing
 * @format int32
 */
export enum UserSignatureType {
  Text = 1,
  Drawing = 2,
}

export interface UserUpdateRequest {
  /** @format int32 */
  Id: number
  Address?: UserAddressRequest
  /** @format date-time */
  DateOfBirth?: string | null
  /**
   *
   *
   * 1 = Male
   *
   * 2 = Female
   *
   * 3 = Other
   */
  Gender?: GenderTypes
}

export interface UsersByEmailsOrPhoneNumbersGetRequest {
  Emails?: string[] | null
  PhoneNumbers?: string[] | null
}

export interface UsersByIdsGetRequest {
  /** @minItems 1 */
  UserIds: number[]
}

export interface VideoCallResponse {
  /** @format int32 */
  UserId: number
  /** @format int32 */
  ContentId: number
  /** @format date-time */
  StartCallTime: string
  /** @format date-time */
  EndCallTime?: string | null
}

export type PostCreateUsersAsyncPayload = CreateBatchUserRequest[]

export enum GetMobileNotificationsAsyncParamsTypesEnum {
  Invitation = 'Invitation',
  SessionApproval = 'SessionApproval',
  ChangeOwner = 'ChangeOwner',
  ShareContent = 'ShareContent',
  Notification = 'Notification',
  Reminder = 'Reminder',
  CalendarEvent = 'CalendarEvent',
}

export type MarkNotificationsAsViewedAsyncPayload = ApprovalIdRequest[]

export type SetPermissionsAsyncPayload = SetPermissionsRequest[]

export type GetGeosearchPagesThumbnailsAsyncPayload = number[]

/** @minItems 1 */
export type BulkPagesRestoreAsyncPayload = PageIdRequest[]

/** @minItems 1 */
export type BulkPagesDeletePermanentlyAsyncPayload = PageIdRequest[]

export interface LoginViaUserNameAndPasswordAsyncPayload {
  /** Password of the user who wants to authorize to the system */
  Password: string
  /** Email of the user who wants to authorize to the system */
  UserName: string
  /** Subdomain of a tenant where the user wants to authorize to the system */
  Subdomain: string
}

export interface CreateAsyncPayload1 {
  /**
   * File to upload
   * @format binary
   */
  file?: File
}

import type { AxiosInstance, AxiosRequestConfig, HeadersDefaults, ResponseType } from 'axios'
import axios from 'axios'

export type QueryParamsType = Record<string | number, any>

export interface FullRequestParams extends Omit<AxiosRequestConfig, 'data' | 'params' | 'url' | 'responseType'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean
  /** request path */
  path: string
  /** content type of request body */
  type?: ContentType
  /** query params */
  query?: QueryParamsType
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType
  /** request body */
  body?: unknown
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, 'data' | 'cancelToken'> {
  securityWorker?: (
    securityData: SecurityDataType | null
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void
  secure?: boolean
  format?: ResponseType
}

export enum ContentType {
  Json = 'application/json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance
  private securityData: SecurityDataType | null = null
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker']
  private secure?: boolean
  private format?: ResponseType

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || 'https://api-dev.collaborate.center/staging/',
    })
    this.secure = secure
    this.format = format
    this.securityWorker = securityWorker
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data
  }

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method)

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    }
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === 'object' && formItem !== null) {
      return JSON.stringify(formItem)
    } else {
      return `${formItem}`
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key]
      const propertyContent: any[] = property instanceof Array ? property : [property]

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem))
      }

      return formData
    }, new FormData())
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<T> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {}
    const requestParams = this.mergeRequestParams(params, secureParams)
    const responseFormat = format || this.format || undefined

    if (type === ContentType.FormData && body && body !== null && typeof body === 'object') {
      body = this.createFormData(body as Record<string, unknown>)
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== 'string') {
      body = JSON.stringify(body)
    }

    return this.instance
      .request({
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type ? { 'Content-Type': type } : {}),
        },
        params: query,
        responseType: responseFormat,
        data: body,
        url: path,
      })
      .then((response) => response.data)
  }
}

/**
 * @title Tabeeb api dev
 * @version v1
 * @baseUrl https://api-dev.collaborate.center/staging/
 */
export class Api<SecurityDataType extends unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  account = {
    /**
     * No description
     *
     * @tags Account
     * @name TryActivateAsync
     * @summary Attempt to activate user profile
     * @request POST:/api/Account/tryActivate
     * @secure
     */
    tryActivateAsync: (params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/Account/tryActivate`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account
     * @name LoginViaInviteAsync
     * @summary Login Via Invite
     * @request POST:/api/Account/completeLoginViaInvite
     * @secure
     */
    loginViaInviteAsync: (data: LoginViaInviteRequest, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse | void>({
        path: `/api/Account/completeLoginViaInvite`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account
     * @name PutAsync
     * @summary Update information about current authenticated user.
     * @request PUT:/api/Account
     * @secure
     */
    putAsync: (data: UserResponse, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse | void>({
        path: `/api/Account`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account
     * @name SetAvatarAsync
     * @summary Upload image to be set as user's avatar.
     * @request POST:/api/Account/setavatar
     * @secure
     */
    setAvatarAsync: (data: UserAvatarRequest, params: RequestParams = {}) =>
      this.http.request<string, ApiErrorResponse | void>({
        path: `/api/Account/setavatar`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account
     * @name RemoveAvatarAsync
     * @summary Remove Avatar
     * @request GET:/api/Account/removeavatar
     * @secure
     */
    removeAvatarAsync: (params: RequestParams = {}) =>
      this.http.request<string, ApiErrorResponse>({
        path: `/api/Account/removeavatar`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Sample request: POST { "FirstName": "First name", "LastName": "Last name", "Email": "user@gmail.com", "Institution": "Institution", "DateOfBirth": Date, "PhoneNumber" : "1302....", "Address" : { "Line1": "", "Line2": "", "City": "", "State": "", "PostalCode":"", "Country":"" }, "InviteToken": "GLkjHal1aA2........" }
     *
     * @tags Account
     * @name RegisterAsync
     * @summary Creates profile .
     * @request POST:/api/Account/profile
     * @secure
     */
    registerAsync: (data: CreateProfileRequest, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse | void>({
        path: `/api/Account/profile`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account
     * @name GetMeAsync
     * @summary Get profile information about current authenticated user.
     * @request GET:/api/Account/me
     * @secure
     */
    getMeAsync: (params: RequestParams = {}) =>
      this.http.request<UserResponse, ApiErrorResponse>({
        path: `/api/Account/me`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account
     * @name DeleteAccountAsync
     * @summary Request is used to delete account
     * @request DELETE:/api/Account/delete
     * @secure
     */
    deleteAccountAsync: (params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse>({
        path: `/api/Account/delete`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),
  }
  admin = {
    /**
     * No description
     *
     * @tags Admin
     * @name UpdateThumbnailAsync
     * @summary Update Thumbnail
     * @request POST:/api/admin/updateThumbnail
     * @secure
     */
    updateThumbnailAsync: (data: UpdateThumbnailRequest, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse | void>({
        path: `/api/admin/updateThumbnail`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name GenerateThumbnailAsync
     * @summary Generate Thumbnail
     * @request POST:/api/admin/generateThumbnail
     * @secure
     */
    generateThumbnailAsync: (
      query?: {
        /** @format int32 */
        pageId?: number
      },
      params: RequestParams = {}
    ) =>
      this.http.request<void, ApiErrorResponse>({
        path: `/api/admin/generateThumbnail`,
        method: 'POST',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name RecoverVideoEncodingAsync
     * @summary Recover Video Encoding
     * @request POST:/api/admin/recovervideos/{contentId}
     * @secure
     */
    recoverVideoEncodingAsync: (contentId: number, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/admin/recovervideos/${contentId}`,
        method: 'POST',
        secure: true,
        ...params,
      }),
  }
  adminUsers = {
    /**
     * No description
     *
     * @tags AdminUsers
     * @name GetTenantUsersCountAsync
     * @summary Get Tenant Users Count
     * @request GET:/api/admin/tenantuserscount/{tenantId}
     * @secure
     */
    getTenantUsersCountAsync: (tenantId: number, params: RequestParams = {}) =>
      this.http.request<UserChatsSortingColumnEnum, ApiErrorResponse>({
        path: `/api/admin/tenantuserscount/${tenantId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminUsers
     * @name ResetUserPassword
     * @request PUT:/api/admin/adminusers/resetPassword/{id}
     * @secure
     */
    resetUserPassword: (id: number, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse>({
        path: `/api/admin/adminusers/resetPassword/${id}`,
        method: 'PUT',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminUsers
     * @name PostCreateUsersAsync
     * @summary Post Create Users
     * @request POST:/api/adminusers/createusers
     * @secure
     */
    postCreateUsersAsync: (data: PostCreateUsersAsyncPayload, params: RequestParams = {}) =>
      this.http.request<CreateUserListRequest, ApiErrorResponse | void>({
        path: `/api/adminusers/createusers`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminUsers
     * @name UpdateDisableUserByIdAsync
     * @summary Update Disable User By Id
     * @request PUT:/api/admin/adminusers/disable/{userId}
     * @secure
     */
    updateDisableUserByIdAsync: (userId: number, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse>({
        path: `/api/admin/adminusers/disable/${userId}`,
        method: 'PUT',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminUsers
     * @name UpdateEnableUserByIdAsync
     * @summary Update Enable User By Id
     * @request DELETE:/api/admin/adminusers/disable/{userId}
     * @secure
     */
    updateEnableUserByIdAsync: (userId: number, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse>({
        path: `/api/admin/adminusers/disable/${userId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminUsers
     * @name GetAsync
     * @summary Find all users in the system matching the supplied search query.
     * @request POST:/api/admin/adminusers
     * @secure
     */
    getAsync: (data: AdminUsersSearchRequest, params: RequestParams = {}) =>
      this.http.request<UserAdminResponse[], ApiErrorResponse | void>({
        path: `/api/admin/adminusers`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Sample request: PUT { "UserName": "user@gmail.com", "Email": "user@gmail.com", "FirstName": "Alex", "LastName": "Donson", "EmployeeId": "f29adk-adj23u......", "PhoneNumber" : "1302....", "IsDisabled" : false, "IsCreatedByAdmin": true, "Password": "Qwerty1!" }
     *
     * @tags AdminUsers
     * @name PutAsync
     * @summary Update info on supplied user.
     * @request PUT:/api/admin/adminusers/{id}
     * @secure
     */
    putAsync: (id: number, data: UserAdminUpdateInfoModel, params: RequestParams = {}) =>
      this.http.request<UserAdminInfoResponse, ApiErrorResponse | void>({
        path: `/api/admin/adminusers/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Sample response: { "UserId": 123 }
     *
     * @tags AdminUsers
     * @name PostCreateAsync
     * @summary Create new admin or user without password.
     * @request POST:/api/adminusers/create
     * @secure
     */
    postCreateAsync: (data: CreateUserRequest, params: RequestParams = {}) =>
      this.http.request<UserIdResponse, ApiErrorResponse | void>({
        path: `/api/adminusers/create`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  }
  aiCounters = {
    /**
     * No description
     *
     * @tags AICounters
     * @name GetAiCounterInfoByFormRecordAsync
     * @summary Get Ai Counter Info By Form Record
     * @request POST:/api/ai-counters/get-ai-counter-info-by-form-record
     * @secure
     */
    getAiCounterInfoByFormRecordAsync: (data: GetCounterInfoRequest, params: RequestParams = {}) =>
      this.http.request<AIObjectsInfoResponse[], ApiErrorResponse | void>({
        path: `/api/ai-counters/get-ai-counter-info-by-form-record`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags AICounters
     * @name GetAiCounterInfoAsync
     * @summary Get Ai Counter Info
     * @request POST:/api/ai-counters/get-ai-counter-info
     * @secure
     */
    getAiCounterInfoAsync: (data: GetCounterInfoRequest, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse | void>({
        path: `/api/ai-counters/get-ai-counter-info`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags AICounters
     * @name GetAiObjectsCountAsync
     * @summary Get Ai Objects Count
     * @request POST:/api/ai-counters/get-ai-objects-count
     * @secure
     */
    getAiObjectsCountAsync: (data: GetCounterInfoRequest, params: RequestParams = {}) =>
      this.http.request<AIObjectsCountResponse[], ApiErrorResponse | void>({
        path: `/api/ai-counters/get-ai-objects-count`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  }
  annotation = {
    /**
     * No description
     *
     * @tags Annotation
     * @name GetAnnotationsByContentIdAsync
     * @summary Get Annotations By Content Id
     * @request GET:/api/annotation/getAnnotationsByContentId
     * @secure
     */
    getAnnotationsByContentIdAsync: (
      query: {
        /** @format int32 */
        ContentId: number
        /** @format int32 */
        ActivitiesSkip?: number
        /** @format int32 */
        ActivitiesTake?: number
        /** @format int32 */
        PageId?: number
        /** @format int32 */
        UserId?: number
        /**
         *
         *
         * 0 = All
         *
         * 1 = AIFlag
         *
         * 2 = Flag
         *
         * 3 = Drawing
         *
         * 4 = Image
         *
         * 5 = Shape
         *
         * 6 = Text
         *
         * 7 = Audio
         */
        Type?: ActivitiesType
        SearchQuery?: string
      },
      params: RequestParams = {}
    ) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/annotation/getAnnotationsByContentId`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Annotation
     * @name AddAnnotationAsync
     * @summary Add Annotation
     * @request POST:/api/annotation/addAnnotation
     * @secure
     */
    addAnnotationAsync: (data: AnnotationCreateRequest, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse | void>({
        path: `/api/annotation/addAnnotation`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Annotation
     * @name DeleteAnnotationsAsync
     * @summary Request is used to delete annotations
     * @request DELETE:/api/annotation
     * @secure
     */
    deleteAnnotationsAsync: (data: AnnotationsDeleteRequest, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse | void>({
        path: `/api/annotation`,
        method: 'DELETE',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Annotation
     * @name UpdateAnnotationAsync
     * @summary Request is used to update annotation
     * @request PUT:/api/annotation
     * @secure
     */
    updateAnnotationAsync: (data: AnnotationUpdateRequest, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse | void>({
        path: `/api/annotation`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Annotation
     * @name RestoreAnnotationAsync
     * @summary Request is used to restore annotations
     * @request POST:/api/annotation/restore
     * @secure
     */
    restoreAnnotationAsync: (data: AnnotationsRestoreRequest, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse | void>({
        path: `/api/annotation/restore`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Annotation
     * @name GetAllAnnotationsByContentIdAsync
     * @request GET:/api/annotation/getAllAnnotationsByContentId/{contentId}
     * @secure
     */
    getAllAnnotationsByContentIdAsync: (
      contentId: number,
      query?: {
        typeList?: string
      },
      params: RequestParams = {}
    ) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/annotation/getAllAnnotationsByContentId/${contentId}`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Annotation
     * @name GetAnnotationsByPageIdAsync
     * @summary Get Annotations By Page Id
     * @request GET:/api/annotation/getAnnotationsByPageId/{pageId}
     * @secure
     */
    getAnnotationsByPageIdAsync: (pageId: number, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/annotation/getAnnotationsByPageId/${pageId}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Annotation
     * @name GetAiAnnotationsTextByCoordinatesAsync
     * @summary Get AI Annotations Text By Coordinates
     * @request GET:/api/annotation/getAnnotationsTextByCoordinates/{pageId}/{x}/{y}
     * @secure
     */
    getAiAnnotationsTextByCoordinatesAsync: (pageId: number, x: number, y: number, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/annotation/getAnnotationsTextByCoordinates/${pageId}/${x}/${y}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Annotation
     * @name CreateWithUniqueAiObjectsAsync
     * @summary Create Unique Objects
     * @request POST:/api/annotation/create-with-unique-ai-objects
     * @secure
     */
    createWithUniqueAiObjectsAsync: (data: AnnotationsFromStructureModelCreateRequest, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse | void>({
        path: `/api/annotation/create-with-unique-ai-objects`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Annotation
     * @name PostAiAsync
     * @summary Post AI
     * @request POST:/api/annotation/external/ai
     * @secure
     */
    postAiAsync: (data: AIAnnotationExternalCreateRequest, params: RequestParams = {}) =>
      this.http.request<AnnotationResponse[], ApiErrorResponse | void>({
        path: `/api/annotation/external/ai`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Annotation
     * @name PostShapeAsync
     * @summary Post Shape
     * @request POST:/api/annotation/external/shape
     * @secure
     */
    postShapeAsync: (data: ShapeAnnotationExternalCreateRequest, params: RequestParams = {}) =>
      this.http.request<AnnotationResponse[], ApiErrorResponse | void>({
        path: `/api/annotation/external/shape`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Annotation
     * @name AddClassificationAnnotationsAsync
     * @summary Add classification annotations to a page
     * @request POST:/api/annotation/classification
     * @secure
     */
    addClassificationAnnotationsAsync: (data: AddClassificationAnnotationsRequest, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse | void>({
        path: `/api/annotation/classification`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Annotation
     * @name CheckAiAnnotationsAsync
     * @summary Checks if Tabeeb.Business.Domain.Annotations of the Type Tabeeb.Shared.Common.Enums.AnnotationType.AI exist on the given Tabeeb.Business.Domain.Pages.
     * @request POST:/api/annotation/existing/ai
     * @secure
     */
    checkAiAnnotationsAsync: (data: CheckAIAnnotationsExistanceRequest, params: RequestParams = {}) =>
      this.http.request<CheckAIAnnotationsExistanceResponse[], ApiErrorResponse | void>({
        path: `/api/annotation/existing/ai`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  }
  approvalRequest = {
    /**
     * No description
     *
     * @tags ApprovalRequest
     * @name GetNotificationsAsync
     * @summary Get Notifications
     * @request GET:/api/approvalRequests/getNotifications/{batchNumber}/{batchSize}/{showAll}
     * @secure
     */
    getNotificationsAsync: (
      batchNumber: number,
      batchSize: number,
      showAll: string,
      query?: {
        /**
         * @format int32
         * @default 1
         */
        showAll?: number
      },
      params: RequestParams = {}
    ) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/approvalRequests/getNotifications/${batchNumber}/${batchSize}/${showAll}`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ApprovalRequest
     * @name GetMobileNotificationsAsync
     * @summary Get Notifications
     * @request GET:/api/approvalRequests/getMobileNotifications
     * @secure
     */
    getMobileNotificationsAsync: (
      query?: {
        /** @format int32 */
        batchNumber?: number
        /** @format int32 */
        batchSize?: number
        types?: GetMobileNotificationsAsyncParamsTypesEnum
        showAll?: boolean
      },
      params: RequestParams = {}
    ) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/approvalRequests/getMobileNotifications`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ApprovalRequest
     * @name GetRemindersNotificationsAsync
     * @summary Get Reminders Notifications
     * @request GET:/api/approvalRequests/getRemindersNotifications
     * @secure
     */
    getRemindersNotificationsAsync: (params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/approvalRequests/getRemindersNotifications`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ApprovalRequest
     * @name GetNotificationCountAsync
     * @summary Get Notification Count
     * @request GET:/api/approvalRequests/notificationCount
     * @secure
     */
    getNotificationCountAsync: (params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/approvalRequests/notificationCount`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ApprovalRequest
     * @name GetMobileNotificationCountAsync
     * @summary Get Notification Count
     * @request GET:/api/approvalRequests/mobileNotificationCount
     * @secure
     */
    getMobileNotificationCountAsync: (params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/approvalRequests/mobileNotificationCount`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ApprovalRequest
     * @name PutAcceptAsync
     * @summary Put Accept
     * @request PUT:/api/approvalRequests/accept
     * @secure
     */
    putAcceptAsync: (data: ApprovalRequest, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse | void>({
        path: `/api/approvalRequests/accept`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ApprovalRequest
     * @name PutRejectAsync
     * @summary Put Reject
     * @request PUT:/api/approvalRequests/reject
     * @secure
     */
    putRejectAsync: (data: ApprovalRequest, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse | void>({
        path: `/api/approvalRequests/reject`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ApprovalRequest
     * @name MarkNotificationsAsViewedAsync
     * @summary Mark Notifications As Viewed
     * @request POST:/api/approvalRequests/markAsViewed
     * @secure
     */
    markNotificationsAsViewedAsync: (data: MarkNotificationsAsViewedAsyncPayload, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse | void>({
        path: `/api/approvalRequests/markAsViewed`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  }
  bentley = {
    /**
     * No description
     *
     * @tags Bentley
     * @name CreateModelAsync
     * @summary Initializes creating a point cloud using Bentley's ContextCapture photogrammetry service
     * @request POST:/api/Bentley/model
     * @secure
     */
    createModelAsync: (data: CreateBentleyPointCloudModelRequest, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse | void>({
        path: `/api/Bentley/model`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bentley
     * @name CreateAnalyticsReportAsync
     * @summary Sends a request for creating an analytics report based on a bentley model
     * @request POST:/api/Bentley/analyticsReport
     * @secure
     */
    createAnalyticsReportAsync: (data: CreateBentleyAnalyticsReportRequest, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse | void>({
        path: `/api/Bentley/analyticsReport`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bentley
     * @name RegenerateAsync
     * @summary Request is used to regenerate an analytics report based on a bentley model.
     * @request POST:/api/Bentley/analyticsReport/regenerate
     * @secure
     */
    regenerateAsync: (data: RegenerateAnalyticsReportRequest, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse | void>({
        path: `/api/Bentley/analyticsReport/regenerate`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bentley
     * @name GetGigapixelsByContentAsync
     * @summary Gets info about content's remaining gigapixel capacity and current model's gigapixel count
     * @request POST:/api/Bentley/content/{contentId}/gigapixels
     * @secure
     */
    getGigapixelsByContentAsync: (contentId: number, data: GetBentleyGigapixelsRequest, params: RequestParams = {}) =>
      this.http.request<GetBentleyGigapixelsResponse, ApiErrorResponse | void>({
        path: `/api/Bentley/content/${contentId}/gigapixels`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  }
  blobs = {
    /**
     * No description
     *
     * @tags Blobs
     * @name PostReturnSasAsync
     * @summary Get Shared Access Signature for uploading directly to blob storage.
     * @request GET:/api/Blobs/upload-params
     * @secure
     */
    postReturnSasAsync: (
      query: {
        FileName: string
        /**
         *
         *
         * 1 = Page
         *
         * 2 = FormThumbnail
         *
         * 3 = SettingData
         *
         * 4 = AiExpressionImage
         *
         * 5 = ArticleDocument
         *
         * 6 = FormData
         *
         * 7 = AudioChatMessage
         *
         * 8 = AssistantDocument
         *
         * 9 = ThreeDimensionalModel
         *
         * 10 = ThreeDimensionalModelThumbnail
         */
        UploadContentType?: UploadContentType
        /**
         * The Id of the session to which file will be linked.
         * @format int32
         */
        ContentId?: number
      },
      params: RequestParams = {}
    ) =>
      this.http.request<string, ApiErrorResponse>({
        path: `/api/Blobs/upload-params`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Blobs
     * @name SasBackwardCompatibilityAsync
     * @request POST:/api/Blobs/sas
     * @deprecated
     * @secure
     */
    sasBackwardCompatibilityAsync: (data: GetUploadSasRequestBackwardCompatibility, params: RequestParams = {}) =>
      this.http.request<string, ApiErrorResponse | void>({
        path: `/api/Blobs/sas`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  }
  calendars = {
    /**
     * No description
     *
     * @tags Calendars
     * @name CreateEventAsync
     * @summary Request is used to create calendar event
     * @request POST:/api/calendars/{userId}/events
     * @secure
     */
    createEventAsync: (userId: number, data: CalendarEventCreateRequest, params: RequestParams = {}) =>
      this.http.request<CalendarEventResponse, ApiErrorResponse | void>({
        path: `/api/calendars/${userId}/events`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Calendars
     * @name GetEventsByUserAsync
     * @summary Request is used to get calendar events by user
     * @request GET:/api/calendars/{userId}/events
     * @secure
     */
    getEventsByUserAsync: (
      userId: number,
      query: {
        /**
         * Range start date
         * @format date-time
         */
        startDate: string
        /**
         * Range end date
         * @format date-time
         */
        endDate: string
        /**
         * Lower bound for an event's last modification time to filter by. When specified, entries deleted since this time will always be included in response
         * @format date-time
         */
        updatedOn?: string
        /**
         * Number of events to skip
         * @format int32
         * @min 0
         * @default 0
         */
        skip?: number
        /**
         * Number of events to take
         * @format int32
         * @min 1
         * @max 500
         * @default 500
         */
        take?: number
      },
      params: RequestParams = {}
    ) =>
      this.http.request<CalendarEventBaseResponse[], ApiErrorResponse>({
        path: `/api/calendars/${userId}/events`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Calendars
     * @name GetEventByIdAsync
     * @summary Request is used to get calendar event info
     * @request GET:/api/calendars/{userId}/events/{eventId}
     * @secure
     */
    getEventByIdAsync: (userId: number, eventId: number, params: RequestParams = {}) =>
      this.http.request<CalendarEventResponse, ApiErrorResponse>({
        path: `/api/calendars/${userId}/events/${eventId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Calendars
     * @name UpdateEventAsync
     * @summary Request is used to update calendar event
     * @request PUT:/api/calendars/{userId}/events/{eventId}
     * @secure
     */
    updateEventAsync: (userId: number, eventId: number, data: CalendarEventUpdateRequest, params: RequestParams = {}) =>
      this.http.request<CalendarEventResponse, ApiErrorResponse | void>({
        path: `/api/calendars/${userId}/events/${eventId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Calendars
     * @name DeleteEventAsync
     * @summary Request is used to delete calendar event
     * @request DELETE:/api/calendars/{userId}/events/{eventId}
     * @secure
     */
    deleteEventAsync: (userId: number, eventId: number, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse>({
        path: `/api/calendars/${userId}/events/${eventId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Calendars
     * @name UpdateEventAttachedSessionAsync
     * @summary Request is used to update calendar event attached session
     * @request PUT:/api/calendars/{userId}/events/{eventId}/content
     * @secure
     */
    updateEventAttachedSessionAsync: (
      userId: number,
      eventId: number,
      data: CalendarEventContentUpdateRequest,
      params: RequestParams = {}
    ) =>
      this.http.request<CalendarEventResponse, ApiErrorResponse | void>({
        path: `/api/calendars/${userId}/events/${eventId}/content`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Calendars
     * @name UpdateEventOwnerAsync
     * @summary Request is used to update calendar event owner
     * @request PUT:/api/calendars/{userId}/events/{eventId}/owner
     * @secure
     */
    updateEventOwnerAsync: (
      userId: number,
      eventId: number,
      data: CalendarEventOwnerUpdateRequest,
      params: RequestParams = {}
    ) =>
      this.http.request<CalendarEventResponse, ApiErrorResponse | void>({
        path: `/api/calendars/${userId}/events/${eventId}/owner`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Calendars
     * @name UpdateEventTimeAsync
     * @summary Request is used to update calendar event time
     * @request PUT:/api/calendars/{userId}/events/{eventId}/time
     * @secure
     */
    updateEventTimeAsync: (
      userId: number,
      eventId: number,
      data: CalendarEventDateUpdateRequest,
      params: RequestParams = {}
    ) =>
      this.http.request<CalendarEventResponse, ApiErrorResponse | void>({
        path: `/api/calendars/${userId}/events/${eventId}/time`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Calendars
     * @name AcceptEventByIdAsync
     * @summary Request is used to accept calendar event invitation
     * @request POST:/api/calendars/{userId}/events/{eventId}/accept
     * @secure
     */
    acceptEventByIdAsync: (userId: number, eventId: number, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse>({
        path: `/api/calendars/${userId}/events/${eventId}/accept`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Calendars
     * @name DeclineEventByIdAsync
     * @summary Request is used to decline calendar event invitation
     * @request POST:/api/calendars/{userId}/events/{eventId}/decline
     * @secure
     */
    declineEventByIdAsync: (userId: number, eventId: number, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse>({
        path: `/api/calendars/${userId}/events/${eventId}/decline`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Calendars
     * @name CreateAppointmentSlotsEventAsync
     * @summary Request is used to create appointment slots event
     * @request POST:/api/calendars/{userId}/appointmentSlots
     * @secure
     */
    createAppointmentSlotsEventAsync: (
      userId: number,
      data: AppointmentSlotsCreateRequest,
      params: RequestParams = {}
    ) =>
      this.http.request<CalendarEventResponse, ApiErrorResponse | void>({
        path: `/api/calendars/${userId}/appointmentSlots`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Calendars
     * @name GetFreeAppointmentSlotsAsync
     * @summary Request is used to get free time slots for appointment slots event
     * @request GET:/api/calendars/{userId}/appointmentSlots/{eventId}/free
     * @secure
     */
    getFreeAppointmentSlotsAsync: (userId: number, eventId: number, params: RequestParams = {}) =>
      this.http.request<CalendarEventResponse, ApiErrorResponse>({
        path: `/api/calendars/${userId}/appointmentSlots/${eventId}/free`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Calendars
     * @name CreateBookingEventAsync
     * @summary Request is used to create booking event
     * @request POST:/api/calendars/{userId}/appointmentSlots/{eventId}/book
     * @secure
     */
    createBookingEventAsync: (
      userId: number,
      eventId: number,
      data: AppointmentSlotBookRequest,
      params: RequestParams = {}
    ) =>
      this.http.request<CalendarEventResponse, ApiErrorResponse | void>({
        path: `/api/calendars/${userId}/appointmentSlots/${eventId}/book`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Calendars
     * @name GetCalendarSubscriptionsListAsync
     * @summary Request is used to get list of subscriptions for current user
     * @request GET:/api/calendars/list
     * @secure
     */
    getCalendarSubscriptionsListAsync: (params: RequestParams = {}) =>
      this.http.request<CalendarSubscriptionResponse[], ApiErrorResponse>({
        path: `/api/calendars/list`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Calendars
     * @name SubscribeToCalendarAsync
     * @summary Request is used to subscribe to users calendar
     * @request POST:/api/calendars/{userId}/subscribe
     * @secure
     */
    subscribeToCalendarAsync: (userId: number, params: RequestParams = {}) =>
      this.http.request<CalendarSubscriptionResponse, ApiErrorResponse>({
        path: `/api/calendars/${userId}/subscribe`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Calendars
     * @name UnsubscribeFromCalendarAsync
     * @summary Request is used to unsubscribe from users calendar
     * @request DELETE:/api/calendars/{userId}/unsubscribe
     * @secure
     */
    unsubscribeFromCalendarAsync: (userId: number, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse>({
        path: `/api/calendars/${userId}/unsubscribe`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Calendars
     * @name EnableCalendarSubscriptionAsync
     * @summary Request is used to enable calendar subscription
     * @request PUT:/api/calendars/{userId}/display
     * @secure
     */
    enableCalendarSubscriptionAsync: (
      userId: number,
      data: UpdateCalendarSubscriptionDisplayRequest,
      params: RequestParams = {}
    ) =>
      this.http.request<void, ApiErrorResponse | void>({
        path: `/api/calendars/${userId}/display`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Calendars
     * @name UpdateCalendarSubscriptionColorAsync
     * @summary Request is used to update calendar subscription color
     * @request PUT:/api/calendars/{userId}/color
     * @secure
     */
    updateCalendarSubscriptionColorAsync: (
      userId: number,
      data: UpdateCalendarSubscriptionColorRequest,
      params: RequestParams = {}
    ) =>
      this.http.request<void, ApiErrorResponse | void>({
        path: `/api/calendars/${userId}/color`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  }
  chatMessage = {
    /**
     * No description
     *
     * @tags ChatMessage
     * @name GetPrivateChatsInfoAsync
     * @summary Request is used to get all private chats info by content id
     * @request GET:/api/chatMessage/chats/bycontent/{contentId}
     * @secure
     */
    getPrivateChatsInfoAsync: (contentId: number, params: RequestParams = {}) =>
      this.http.request<ChatInfoResponse[], ApiErrorResponse>({
        path: `/api/chatMessage/chats/bycontent/${contentId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ChatMessage
     * @name GetByContentIdAsync
     * @summary Request is used to get all chat messages by content id
     * @request GET:/api/chatMessage/bycontent/{contentId}
     * @secure
     */
    getByContentIdAsync: (
      contentId: number,
      query: {
        /**
         * Unique id of the user within the system
         * @format int32
         */
        userId?: number
        /**
         * Unique id of the topic within the system
         * @format int32
         */
        topicId: number
        /**
         * Topic type
         *
         * 1 = Session
         *
         * 2 = Page
         *
         * 3 = FormAnswer
         */
        topicType: TopicType
        /**
         * Number of messages to skip
         * @format int32
         * @default 0
         */
        messagesSkip?: number
        /**
         * Number of messages to take
         * @format int32
         * @min 1
         * @default 25
         */
        messagesTake?: number
      },
      params: RequestParams = {}
    ) =>
      this.http.request<ChatMessageResponse[], ApiErrorResponse>({
        path: `/api/chatMessage/bycontent/${contentId}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ChatMessage
     * @name GetAsync
     * @summary Request is used to get chat message by id
     * @request GET:/api/chatMessage/{id}
     * @secure
     */
    getAsync: (id: number, params: RequestParams = {}) =>
      this.http.request<ChatMessageResponse, ApiErrorResponse>({
        path: `/api/chatMessage/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ChatMessage
     * @name PostAsync
     * @summary Request is used to send new message in session
     * @request POST:/api/chatMessage
     * @secure
     */
    postAsync: (data: CreateChatMessageRequest, params: RequestParams = {}) =>
      this.http.request<ChatMessageResponse, ApiErrorResponse | void>({
        path: `/api/chatMessage`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ChatMessage
     * @name CreateChatMessageWithAssetAsync
     * @summary Request is used to send new message with asset in session
     * @request POST:/api/chatMessage/file
     * @secure
     */
    createChatMessageWithAssetAsync: (data: CreateChatMessageWithAssetRequest, params: RequestParams = {}) =>
      this.http.request<ChatMessageResponse, ApiErrorResponse | void>({
        path: `/api/chatMessage/file`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ChatMessage
     * @name Languages
     * @summary Request is used to get a list of supported languages for translation
     * @request GET:/api/chatMessage/translate/languages
     * @secure
     */
    languages: (params: RequestParams = {}) =>
      this.http.request<Record<string, string>, ApiErrorResponse>({
        path: `/api/chatMessage/translate/languages`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ChatMessage
     * @name TranslateAsync
     * @summary Request is used to translate message to selected language
     * @request POST:/api/chatMessage/translate
     * @secure
     */
    translateAsync: (data: ChatMessageTranslationRequest, params: RequestParams = {}) =>
      this.http.request<string, ApiErrorResponse | void>({
        path: `/api/chatMessage/translate`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ChatMessage
     * @name MarkAsReadAsync
     * @summary Request is used to mark chat messages as read
     * @request POST:/api/chatMessage/markAsRead
     * @secure
     */
    markAsReadAsync: (data: MarkChatMessageAsReadRequest, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse | void>({
        path: `/api/chatMessage/markAsRead`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ChatMessage
     * @name GetUserChatsCountAsync
     * @summary Get user chats count
     * @request GET:/api/chatMessage/chats/byuser/count
     * @secure
     */
    getUserChatsCountAsync: (
      query?: {
        /** @default false */
        unread?: boolean
      },
      params: RequestParams = {}
    ) =>
      this.http.request<UserChatsSortingColumnEnum, ApiErrorResponse>({
        path: `/api/chatMessage/chats/byuser/count`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ChatMessage
     * @name GetUserChatsListAsync
     * @summary Get user chats list
     * @request POST:/api/chatMessage/chats/byuser
     * @secure
     */
    getUserChatsListAsync: (data: UserChatsSearchRequest, params: RequestParams = {}) =>
      this.http.request<UserChatsResponse[], ApiErrorResponse | void>({
        path: `/api/chatMessage/chats/byuser`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  }
  config = {
    /**
     * No description
     *
     * @tags Config
     * @name GetSessionApprovalSettingsAsync
     * @summary Get Session Approval Settings
     * @request GET:/api/Config/sessionApprovalSettings
     * @secure
     */
    getSessionApprovalSettingsAsync: (params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/Config/sessionApprovalSettings`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Config
     * @name GetVideoBridgeUrlAsync
     * @summary Get Video Bridge Url
     * @request GET:/api/Config/getvideobridgeconfig
     * @secure
     */
    getVideoBridgeUrlAsync: (params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/Config/getvideobridgeconfig`,
        method: 'GET',
        secure: true,
        ...params,
      }),
  }
  contentFolder = {
    /**
     * No description
     *
     * @tags ContentFolder
     * @name GetAllAsync
     * @summary Get All
     * @request GET:/api/contentfolder
     * @secure
     */
    getAllAsync: (params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse | void>({
        path: `/api/contentfolder`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ContentFolder
     * @name PostAsync
     * @summary Post
     * @request POST:/api/contentfolder
     * @secure
     */
    postAsync: (data: ContentFolderRequest, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse | void>({
        path: `/api/contentfolder`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ContentFolder
     * @name GetAsync
     * @summary Get
     * @request GET:/api/contentfolder/{id}
     * @secure
     */
    getAsync: (id: number, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse | void>({
        path: `/api/contentfolder/${id}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ContentFolder
     * @name PutAsync
     * @summary Put
     * @request PUT:/api/contentfolder/{id}
     * @secure
     */
    putAsync: (id: number, data: ContentFolderRequest, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse | void>({
        path: `/api/contentfolder/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ContentFolder
     * @name DeleteAsync
     * @summary Delete
     * @request DELETE:/api/contentfolder/{id}
     * @secure
     */
    deleteAsync: (id: number, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse | void>({
        path: `/api/contentfolder/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ContentFolder
     * @name SwitchContentFolderAsync
     * @summary Move content to folder.
     * @request POST:/api/contentfolder/switchContentFolder
     * @secure
     */
    switchContentFolderAsync: (data: ContentFolderRequest, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse | void>({
        path: `/api/contentfolder/switchContentFolder`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  }
  contentForm = {
    /**
     * No description
     *
     * @tags ContentForm
     * @name GetContentFormAsync
     * @summary Get Content Form
     * @request GET:/api/contentform/getcontentform
     * @secure
     */
    getContentFormAsync: (
      query?: {
        /** @format int32 */
        contentId?: number
        /** @format int32 */
        formId?: number
      },
      params: RequestParams = {}
    ) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/contentform/getcontentform`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ContentForm
     * @name GetContentFormsStatusesCountByContentFormIdAsync
     * @summary Retrieving form answers status statistics for particular form in session.
     * @request GET:/api/contentform/getanswersstatusescountbycontentformid/{contentFormId}
     * @secure
     */
    getContentFormsStatusesCountByContentFormIdAsync: (contentFormId: number, params: RequestParams = {}) =>
      this.http.request<ContentFormListResponse, ApiErrorResponse>({
        path: `/api/contentform/getanswersstatusescountbycontentformid/${contentFormId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ContentForm
     * @name GetFormByContentFormIdAsync
     * @summary Get Form By Content Form Id
     * @request GET:/api/contentform/getformbycontentformid/{contentFormId}
     * @secure
     */
    getFormByContentFormIdAsync: (contentFormId: number, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/contentform/getformbycontentformid/${contentFormId}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ContentForm
     * @name GetFormsByContentIdAsync
     * @summary Get Forms By Content Id
     * @request GET:/api/contentform/getformsbycontentid/{contentId}
     * @secure
     */
    getFormsByContentIdAsync: (
      contentId: number,
      query?: {
        /** @format date-time */
        lastUpdated?: string
      },
      params: RequestParams = {}
    ) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/contentform/getformsbycontentid/${contentId}`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ContentForm
     * @name GetFormByContentIdAsync
     * @summary Get Form By Content Id
     * @request GET:/api/contentform/getformbycontentid/{contentId}
     * @secure
     */
    getFormByContentIdAsync: (contentId: number, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/contentform/getformbycontentid/${contentId}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ContentForm
     * @name GetSessionsByFormIdAsync
     * @summary Get Sessions By Form Id
     * @request GET:/api/contentform/getsessionsbyformid/{formId}
     * @secure
     */
    getSessionsByFormIdAsync: (formId: number, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/contentform/getsessionsbyformid/${formId}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ContentForm
     * @name DetachFormFromContentAsync
     * @summary Detach Form From Content
     * @request DELETE:/api/contentform/detachFormFromContent/{contentId}/{formId}
     * @secure
     */
    detachFormFromContentAsync: (contentId: number, formId: number, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/contentform/detachFormFromContent/${contentId}/${formId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ContentForm
     * @name GetDeletedUserIdsWithAnsweredQuestions
     * @summary Get ids of content users who answered questions
     * @request GET:/api/contentform/answers/{contentId}/deletedUserIds
     * @secure
     */
    getDeletedUserIdsWithAnsweredQuestions: (contentId: number, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/contentform/answers/${contentId}/deletedUserIds`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ContentForm
     * @name GetAllAsync
     * @summary Get All
     * @request GET:/api/contentform
     * @secure
     */
    getAllAsync: (params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse | void>({
        path: `/api/contentform`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ContentForm
     * @name PostAsync
     * @summary Post
     * @request POST:/api/contentform
     * @secure
     */
    postAsync: (data: ContentFormResponse, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse | void>({
        path: `/api/contentform`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ContentForm
     * @name GetAsync
     * @summary Get
     * @request GET:/api/contentform/{id}
     * @secure
     */
    getAsync: (id: number, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse | void>({
        path: `/api/contentform/${id}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ContentForm
     * @name PutAsync
     * @summary Put
     * @request PUT:/api/contentform/{id}
     * @secure
     */
    putAsync: (id: number, data: ContentFormResponse, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse | void>({
        path: `/api/contentform/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ContentForm
     * @name DeleteAsync
     * @summary Delete
     * @request DELETE:/api/contentform/{id}
     * @secure
     */
    deleteAsync: (id: number, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse | void>({
        path: `/api/contentform/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ContentForm
     * @name GetContentFormsByContentIdAsync
     * @summary Request for retrieving the list of all forms attached to the session.
     * @request GET:/api/contentform/getcontentformsbycontentId/{contentId}
     * @secure
     */
    getContentFormsByContentIdAsync: (contentId: number, params: RequestParams = {}) =>
      this.http.request<ContentFormsListWithoutStatusesResponseIAsyncEnumerable, ApiErrorResponse>({
        path: `/api/contentform/getcontentformsbycontentId/${contentId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Sample response: { "ContentFormId": 123 }
     *
     * @tags ContentForm
     * @name AttachFormToContentAsync
     * @summary Request for attaching a particular form to the session.
     * @request POST:/api/contentform/attachformtocontent
     * @secure
     */
    attachFormToContentAsync: (data: AttachFormRequest, params: RequestParams = {}) =>
      this.http.request<ContentFormIdResponse, ApiErrorResponse | void>({
        path: `/api/contentform/attachformtocontent`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Sample response (4 forms attached): { "ContentFormsIds": [123, 456, 876, 345] }
     *
     * @tags ContentForm
     * @name AttachFormsToContentAsync
     * @summary Request for attaching multiple forms to the session.
     * @request POST:/api/contentform/attachFormsListToContent
     * @secure
     */
    attachFormsToContentAsync: (data: AttachFormsRequest, params: RequestParams = {}) =>
      this.http.request<ContentFormsIdsResponse, ApiErrorResponse | void>({
        path: `/api/contentform/attachFormsListToContent`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ContentForm
     * @name GetUserContentFormsCountAsync
     * @summary Get user content forms count
     * @request GET:/api/contentform/byuser/count
     * @secure
     */
    getUserContentFormsCountAsync: (params: RequestParams = {}) =>
      this.http.request<UserChatsSortingColumnEnum, ApiErrorResponse>({
        path: `/api/contentform/byuser/count`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ContentForm
     * @name GetUserContentFormsAsync
     * @summary Get user content forms list
     * @request POST:/api/contentform/byuser
     * @secure
     */
    getUserContentFormsAsync: (data: UserContentFormsSearchRequest, params: RequestParams = {}) =>
      this.http.request<ContentFormsByUserResponse, ApiErrorResponse | void>({
        path: `/api/contentform/byuser`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  }
  contentFormRecord = {
    /**
     * No description
     *
     * @tags ContentFormRecord
     * @name GetAllAsync
     * @summary Get All
     * @request GET:/api/contentformrecord
     * @secure
     */
    getAllAsync: (params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse | void>({
        path: `/api/contentformrecord`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ContentFormRecord
     * @name PostAsync
     * @summary Post
     * @request POST:/api/contentformrecord
     * @secure
     */
    postAsync: (data: ContentFormRecordRequest, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse | void>({
        path: `/api/contentformrecord`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ContentFormRecord
     * @name GetAsync
     * @summary Get
     * @request GET:/api/contentformrecord/{id}
     * @secure
     */
    getAsync: (id: number, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse | void>({
        path: `/api/contentformrecord/${id}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ContentFormRecord
     * @name PutAsync
     * @summary Put
     * @request PUT:/api/contentformrecord/{id}
     * @secure
     */
    putAsync: (id: number, data: ContentFormRecordRequest, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse | void>({
        path: `/api/contentformrecord/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ContentFormRecord
     * @name DeleteAsync
     * @summary Delete
     * @request DELETE:/api/contentformrecord/{id}
     * @secure
     */
    deleteAsync: (id: number, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse | void>({
        path: `/api/contentformrecord/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
 * No description
 *
 * @tags ContentFormRecord
 * @name CreateRecordAsync
 * @summary Request creates a snapshot of the form in session.
Snapshoted form contains form answers with statuses of particular user
and counter values that existed at the time of record creation.
 * @request POST:/api/contentformrecord/create
 * @secure
 */
    createRecordAsync: (data: ContentFormRecordRequest, params: RequestParams = {}) =>
      this.http.request<ContentFormRecordResponse, ApiErrorResponse | void>({
        path: `/api/contentformrecord/create`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ContentFormRecord
     * @name RemoveRecordAsync
     * @summary Request removes the form record
     * @request DELETE:/api/contentformrecord/remove/{recordId}
     * @secure
     */
    removeRecordAsync: (recordId: number, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse>({
        path: `/api/contentformrecord/remove/${recordId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),
  }
  contents = {
    /**
     * No description
     *
     * @tags Contents
     * @name GetPartialContentAsync
     * @summary Get Partial Content
     * @request GET:/api/contents/getpartialcontent/{contentId}
     * @secure
     */
    getPartialContentAsync: (contentId: number, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/contents/getpartialcontent/${contentId}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contents
     * @name GetAllAsync
     * @summary Get All
     * @request GET:/api/contents
     * @secure
     */
    getAllAsync: (
      query?: {
        /** Gets or sets the search query to filter contents. */
        SearchQuery?: string
        /**
         * Gets or sets the folder ID to filter contents.
         * @format int32
         */
        FolderId?: number
        /** Gets or sets a value indicating whether to include deleted contents. */
        IsDeleted?: boolean
        /** Gets or sets a value indicating whether to retrieve contents from all folders. */
        AllFolders?: boolean
        /** Gets or sets a value indicating whether to include thumbnails in the response. */
        IncludeThumbnails?: boolean
        /**
         * Gets or sets the number of records to skip for pagination.
         * @format int32
         */
        Skip?: number
        /**
         * Gets or sets the number of records to take for pagination.
         * @format int32
         */
        Take?: number
        /**
         * Gets or sets the display type of the sessions.
         *
         * 10 = UserSessions
         *
         * 20 = AllSessions
         *
         * 30 = PublishedSessions
         */
        DisplayType?: SessionsDisplayType
        /**
         * Gets or sets the page size for pagination.
         * @format int32
         */
        PageSize?: number
        /**
         * Gets or sets the page number for pagination.
         * @format int32
         */
        PageNumber?: number
      },
      params: RequestParams = {}
    ) =>
      this.http.request<GetContentsByUserResponse[], ApiErrorResponse>({
        path: `/api/contents`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contents
     * @name PostAsync
     * @summary Post
     * @request POST:/api/contents
     * @secure
     */
    postAsync: (data: ContentResponse, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse | void>({
        path: `/api/contents`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contents
     * @name PutAsync
     * @summary Put
     * @request PUT:/api/contents
     * @deprecated
     * @secure
     */
    putAsync: (data: ContentUpdateRequest, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse | void>({
        path: `/api/contents`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contents
     * @name AlertOwnerAsync
     * @summary Alert Owner
     * @request GET:/api/contents/alertOwner
     * @secure
     */
    alertOwnerAsync: (
      query?: {
        /** @format int32 */
        contentId?: number
      },
      params: RequestParams = {}
    ) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/contents/alertOwner`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contents
     * @name AlertOwnersAsync
     * @summary Alert Owner
     * @request GET:/api/contents/alertOwners
     * @secure
     */
    alertOwnersAsync: (params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/contents/alertOwners`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contents
     * @name DeleteAsync
     * @summary Delete
     * @request DELETE:/api/contents/{id}
     * @secure
     */
    deleteAsync: (id: number, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/contents/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contents
     * @name GetPagedContentsAsync
     * @summary Get Paged Contents
     * @request GET:/api/contents/paged/{pageSize}/{pageNumber}
     * @secure
     */
    getPagedContentsAsync: (pageSize: number, pageNumber: number, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/contents/paged/${pageSize}/${pageNumber}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contents
     * @name GetTenantSncQuestionsAsync
     * @summary Get Tenant Snc Questions
     * @request GET:/api/contents/tenant/questions
     * @secure
     */
    getTenantSncQuestionsAsync: (
      query?: {
        isDeleted?: boolean
        cacheId?: string
        /**
         * @format int32
         * @default 1
         */
        pageNumber?: number
        /**
         * @format int32
         * @default 10
         */
        pageSize?: number
      },
      params: RequestParams = {}
    ) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/contents/tenant/questions`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contents
     * @name GetSncAnswersByQuestionAsync
     * @summary Get Snc Answers By Question
     * @request GET:/api/contents/tenant/answers
     * @secure
     */
    getSncAnswersByQuestionAsync: (
      query: {
        isDeleted?: boolean
        /** @format int32 */
        questionId: number
        cacheId?: string
        /**
         * @format int32
         * @default 1
         */
        pageNumber?: number
        /**
         * @format int32
         * @default 10
         */
        pageSize?: number
      },
      params: RequestParams = {}
    ) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/contents/tenant/answers`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contents
     * @name GetContentByPageAsync
     * @summary Get Content By Page
     * @request GET:/api/contents/page/{pageId}
     * @secure
     */
    getContentByPageAsync: (pageId: number, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/contents/page/${pageId}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contents
     * @name LoadContentsAsync
     * @summary Load Contents
     * @request GET:/api/contents/loadContents
     * @secure
     */
    loadContentsAsync: (params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/contents/loadContents`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contents
     * @name PostGenerateThumbAsync
     * @summary Post Generate Thumb
     * @request POST:/api/contents/{contentId}/{pageId}/generateThumbnail
     * @secure
     */
    postGenerateThumbAsync: (contentId: number, pageId: number, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse>({
        path: `/api/contents/${contentId}/${pageId}/generateThumbnail`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contents
     * @name PostLeaveContentAsync
     * @summary Post Leave Content
     * @request POST:/api/contents/{contentId}/leave
     * @secure
     */
    postLeaveContentAsync: (contentId: number, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/contents/${contentId}/leave`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contents
     * @name SwitchUserRoleAsync
     * @summary Switch User Role
     * @request POST:/api/contents/user/role
     * @secure
     */
    switchUserRoleAsync: (data: SwitchUserRoleRequest, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse | void>({
        path: `/api/contents/user/role`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contents
     * @name PostLogDeviceAsync
     * @summary Post Log Device
     * @request POST:/api/contents/{contentId}/logdevice
     * @secure
     */
    postLogDeviceAsync: (contentId: number, data: DeviceInfoRequest, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse | void>({
        path: `/api/contents/${contentId}/logdevice`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contents
     * @name GetGeosearchContentsAsync
     * @summary Get Geosearch Contents
     * @request GET:/api/contents/geosearch
     * @secure
     */
    getGeosearchContentsAsync: (params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/contents/geosearch`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contents
     * @name GetContentsToSwitchAsync
     * @summary Get Contents To Switch
     * @request GET:/api/contents/getToSwitch
     * @secure
     */
    getContentsToSwitchAsync: (
      query?: {
        /** @format int32 */
        folderId?: number
      },
      params: RequestParams = {}
    ) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/contents/getToSwitch`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contents
     * @name SetPresenterAsync
     * @summary Set Presenter
     * @request POST:/api/contents/setpresenter
     * @secure
     */
    setPresenterAsync: (data: SetPresenterRequest, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse | void>({
        path: `/api/contents/setpresenter`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contents
     * @name GetJitsiTokenAsync
     * @summary Get Jitsi Token
     * @request GET:/api/contents/getjitsitoken
     * @secure
     */
    getJitsiTokenAsync: (
      query?: {
        roomName?: string
        /** @default "web" */
        audience?: string
      },
      params: RequestParams = {}
    ) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/contents/getjitsitoken`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contents
     * @name TrackSessionLiveStatusAsync
     * @summary Request is used to track session live status
     * @request POST:/api/contents/live
     * @secure
     */
    trackSessionLiveStatusAsync: (params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/contents/live`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contents
     * @name LeaveContentAsync
     * @summary Leave Content
     * @request POST:/api/contents/leavecontent
     * @secure
     */
    leaveContentAsync: (data: LeaveContentRequest, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse | void>({
        path: `/api/contents/leavecontent`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contents
     * @name ConfirmPresenterStateAsync
     * @summary Confirm Presenter State
     * @request GET:/api/contents/confirmpresenterstate/{contentId}
     * @secure
     */
    confirmPresenterStateAsync: (contentId: number, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/contents/confirmpresenterstate/${contentId}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contents
     * @name SetVideoBridgeAsync
     * @summary Set Video Bridge
     * @request POST:/api/contents/setvideobridge
     * @secure
     */
    setVideoBridgeAsync: (data: SetVideoBridgeRequest, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse | void>({
        path: `/api/contents/setvideobridge`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contents
     * @name DeleteContentPermanentlyAsync
     * @summary Delete Content Permanently
     * @request POST:/api/contents/deletepermanently/{contentId}
     * @secure
     */
    deleteContentPermanentlyAsync: (contentId: number, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/contents/deletepermanently/${contentId}`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contents
     * @name RestoreDeletedContentAsync
     * @summary Restore Deleted Content
     * @request POST:/api/contents/restorecontent/{contentId}
     * @secure
     */
    restoreDeletedContentAsync: (contentId: number, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/contents/restorecontent/${contentId}`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contents
     * @name PublishContentAsync
     * @summary Publish Content
     * @request POST:/api/contents/publishcontent/{contentId}
     * @secure
     */
    publishContentAsync: (contentId: number, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/contents/publishcontent/${contentId}`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contents
     * @name UnpublishContentAsync
     * @summary Unpublish Content
     * @request POST:/api/contents/unpublishcontent/{contentId}
     * @secure
     */
    unpublishContentAsync: (contentId: number, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/contents/unpublishcontent/${contentId}`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contents
     * @name BulkCopyAsync
     * @summary Bulk Copy
     * @request POST:/api/contents/bulkcopy/{contentId}
     * @secure
     */
    bulkCopyAsync: (contentId: number, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/contents/bulkcopy/${contentId}`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contents
     * @name GetPublishedContentsAsync
     * @summary Get Published Contents
     * @request GET:/api/contents/publishedcontents
     * @secure
     */
    getPublishedContentsAsync: (params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/contents/publishedcontents`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contents
     * @name GetContentDescriptionsAsync
     * @summary Get Content Descriptions
     * @request GET:/api/contents/getcontentdescriptions/{contentId}
     * @secure
     */
    getContentDescriptionsAsync: (contentId: number, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/contents/getcontentdescriptions/${contentId}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contents
     * @name ExportHtmlToPdfAsync
     * @summary The request to export a content form to a PDF page in the gallery.
     * @request POST:/api/contents/exporthtmltopdf
     * @secure
     */
    exportHtmlToPdfAsync: (data: FormPdfExportRequest, params: RequestParams = {}) =>
      this.http.request<PageBaseRequest[], ApiErrorResponse | void>({
        path: `/api/contents/exporthtmltopdf`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
 * @description Sample request with session naming convention: POST api/contents/createcontent { "Description": "USA_Arizona_Phoenix_123", "ContentNameParts": [ { "Order": 0, "Question": "Country", "Answer": "USA" }, { "Order": 1, "Question": "State", "Answer": "Arizona" }, { "Order": 2, "Question": "City", "Answer": "Phoenix" }, { "Order": 3, "Question": "SomeId", "Answer": 123 } ] } Sample request without session naming convention: POST api/contents/createcontent { "Description": null (or any string value) }
 *
 * @tags Contents
 * @name CreateContentAsync
 * @summary Request for creating a new session.
Session is created with default drawing board page.
Body description:
Description: string, optional. The name of the session. If null - then session will be created with current date as a name.
ContentNameParts: (array of objects, required for displaying session name in json format in reports)
Order: integer, required. The order of question.
Question: string, required. The answered question.
Answer: string, required. The answer for the question.
 * @request POST:/api/contents/createcontent
 * @secure
 */
    createContentAsync: (data: ContentCreateRequest, params: RequestParams = {}) =>
      this.http.request<ContentCreatedResponse, ApiErrorResponse | void>({
        path: `/api/contents/createcontent`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
 * @description Sample request with session naming convention: POST api/contents/updatecontentname { "ContentId": 12345, "Description": "USA_Arizona_Phoenix_123", "ContentNameParts": [ { "Order": 0, "Question": "Country", "Answer": "USA" }, { "Order": 1, "Question": "State", "Answer": "Arizona" }, { "Order": 2, "Question": "City", "Answer": "Phoenix" }, { "Order": 3, "Question": "SomeId", "Answer": 123 } ] } Sample request without session naming convention: POST api/contents/updatecontentname { "ContentId": 12345, "Description": "A new session name" }
 *
 * @tags Contents
 * @name UpdateContentNameAsync
 * @summary Request for the session name(description) updating.
Body description:
Description: string, required. A new name of the session.
ContentNameParts: (array of objects, required for displaying session name in json format in reports)
Order: integer, required. An order of the question-answer pair in the new description of the session.
Question: string, required. A question value.
Answer: string, required. An answer value.
 * @request POST:/api/contents/updatecontentname
 * @secure
 */
    updateContentNameAsync: (data: UpdateContentNameRequest, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse | void>({
        path: `/api/contents/updatecontentname`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Sample request: POST { "ContentId": 123, "NewOwnerId": 321 }
     *
     * @tags Contents
     * @name PostSwitchOwnerAsync
     * @summary Switch session Owner
     * @request POST:/api/contents/switchOwner
     * @secure
     */
    postSwitchOwnerAsync: (data: SwitchOwnerRequest, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse | void>({
        path: `/api/contents/switchOwner`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contents
     * @name ActivateContentAsync
     * @summary If approval limit has not been reached activates an expired session otherwise creates a request for a session activation that must be approved by an admin.
     * @request POST:/api/contents/activate
     * @secure
     */
    activateContentAsync: (data: ContentActivateRequest, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse | void>({
        path: `/api/contents/activate`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Sample request: POST { "contentId": 123, "userId": 321 }
     *
     * @tags Contents
     * @name PostRemoveUserContentAsync
     * @summary Remove user from session
     * @request POST:/api/contents/removeUser
     * @secure
     */
    postRemoveUserContentAsync: (data: RemoveUserContentRequest, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse | void>({
        path: `/api/contents/removeUser`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Allowed roles are User, Viewer and Guest. If role is not provided, User is set by default. Sample request: POST { "ContentId": 123456, "UserIds": [ 1234, 4321 ], "Role": 0 }
     *
     * @tags Contents
     * @name PostAddUserContentAsync
     * @summary Adds users to the session
     * @request POST:/api/contents/addUsers
     * @secure
     */
    postAddUserContentAsync: (data: AddUsersContentRequest, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse | void>({
        path: `/api/contents/addUsers`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
 * No description
 *
 * @tags Contents
 * @name GetContentsByDescriptionAsync
 * @summary Returns a list of found sessions. The list is empty if there are no sessions that meet the search criteria.
Admins can find any of the tenant's sessions, ordinary users can only find the sessions they are participating in.
 * @request POST:/api/contents/byDescription
 * @secure
 */
    getContentsByDescriptionAsync: (data: ContentByDescriptionRequest, params: RequestParams = {}) =>
      this.http.request<ContentByDescriptionResponse[], ApiErrorResponse | void>({
        path: `/api/contents/byDescription`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contents
     * @name UpdateSessionsStoroageAsync
     * @request PUT:/api/contents/{contentId}/storage
     * @secure
     */
    updateSessionsStoroageAsync: (contentId: number, data: SessionStorageSwitchRequest, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse | void>({
        path: `/api/contents/${contentId}/storage`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contents
     * @name GetSessionContentAsync
     * @summary Returns session content and all its constituents.
     * @request GET:/api/contents/getsessioncontent/{contentId}
     * @secure
     */
    getSessionContentAsync: (
      contentId: number,
      query?: {
        /**
         * Array of annotation types:
         *
         *             0 - Pen, Ai Pen, Flag Pen.
         *
         *             3 - Text, Text message in Flag (Dialog, Rectangle, Ellipse, Pen, Arrow, Line, Polygon), Form Answer annotation.
         *
         *             4 - Audio message in Flag (Dialog, Rectangle, Ellipse, Pen, Arrow, Line, Polygon).
         *
         *             6 - Form Answer annotation, Reply.
         *
         *             7 - 360 View annotation, To Recorded Video, To Snapshot annotations.
         *
         *             8 - CV Class (Shield, Pen, Unfilled square, Polygon).
         *
         *             9 - AI Object (Shield, Pen, Unfilled square, Polygon).
         *
         *             100 - Shape Line, Flag Line.
         *
         *             101 - AI Unfilled square, Flag Rectangle, Shape Unfilled square.
         *
         *             102 - Flag Ellipse, Shape Unfilled circle.
         *
         *             103 - Shape Filled square.
         *
         *             104 - Shape Filled circle.
         *
         *             105 - Flag Arrow, Shape Arrow.
         *
         *             106 - Shape Double-sided arrow.
         *
         *             107 - AI Polygon, Flag Polygon, Shape Polygon.
         */
        types?: number[]
      },
      params: RequestParams = {}
    ) =>
      this.http.request<PageInfoResponse[], ApiErrorResponse>({
        path: `/api/contents/getsessioncontent/${contentId}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contents
     * @name MuteSessionChatNotificationsAsync
     * @summary Request is used to mute chat notifications for session
     * @request PUT:/api/contents/{contentId}/toggleChatNotificationsMute
     * @secure
     */
    muteSessionChatNotificationsAsync: (
      contentId: number,
      query?: {
        /**
         * Mute state
         * @default false
         */
        value?: boolean
      },
      params: RequestParams = {}
    ) =>
      this.http.request<void, ApiErrorResponse>({
        path: `/api/contents/${contentId}/toggleChatNotificationsMute`,
        method: 'PUT',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contents
     * @name RestoreAllPagesAsync
     * @summary Restores all the deleted pages and folders in the content's trash bin
     * @request PUT:/api/contents/{contentId}/trashbin/restore
     * @secure
     */
    restoreAllPagesAsync: (contentId: number, params: RequestParams = {}) =>
      this.http.request<IActionResult, ApiErrorResponse>({
        path: `/api/contents/${contentId}/trashbin/restore`,
        method: 'PUT',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contents
     * @name DeleteAllPagesPermanentlyAsync
     * @summary Permanently deletes all pages and folders in the content's trash bin
     * @request DELETE:/api/contents/{contentId}/trashbin/empty
     * @secure
     */
    deleteAllPagesPermanentlyAsync: (contentId: number, params: RequestParams = {}) =>
      this.http.request<IActionResult, ApiErrorResponse>({
        path: `/api/contents/${contentId}/trashbin/empty`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contents
     * @name SearchTargetContentsForMergingAsync
     * @summary Find the latest contents, which description corresponds to the supplied search query.
     * @request POST:/api/contents/searchTargetForMerging
     * @secure
     */
    searchTargetContentsForMergingAsync: (data: SearchTargetContentRequest, params: RequestParams = {}) =>
      this.http.request<TargetContentForMergingResponse[], ApiErrorResponse | void>({
        path: `/api/contents/searchTargetForMerging`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contents
     * @name CancelIncomingCallAsync
     * @summary Send CancelIncomingCall notification
     * @request GET:/api/contents/cancelIncomingCall/{callUuid}
     * @secure
     */
    cancelIncomingCallAsync: (callUuid: string, params: RequestParams = {}) =>
      this.http.request<IActionResult, ApiErrorResponse>({
        path: `/api/contents/cancelIncomingCall/${callUuid}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  }
  contentSharedLink = {
    /**
     * No description
     *
     * @tags ContentSharedLink
     * @name GetAsync
     * @summary Get shared content link
     * @request GET:/api/ContentSharedLink
     * @secure
     */
    getAsync: (
      query?: {
        /** @format int32 */
        contentId?: number
        /** @format int32 */
        tenantId?: number
      },
      params: RequestParams = {}
    ) =>
      this.http.request<GetContentSharedLinkResponse, ApiErrorResponse>({
        path: `/api/ContentSharedLink`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ContentSharedLink
     * @name GenerateAsync
     * @summary Generate shared content link
     * @request POST:/api/ContentSharedLink
     * @secure
     */
    generateAsync: (data: CreateContentSharedLinkRequest, params: RequestParams = {}) =>
      this.http.request<ContentSharedLinkResponse, ApiErrorResponse | void>({
        path: `/api/ContentSharedLink`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ContentSharedLink
     * @name RegenerateAsync
     * @summary Regenerate shared content link
     * @request PUT:/api/ContentSharedLink/regenerate
     * @secure
     */
    regenerateAsync: (data: ContentSharedLinkIdRequest, params: RequestParams = {}) =>
      this.http.request<ContentSharedLinkResponse, ApiErrorResponse | void>({
        path: `/api/ContentSharedLink/regenerate`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ContentSharedLink
     * @name RevokeAsync
     * @summary Revoke shared content link
     * @request PUT:/api/ContentSharedLink/revoke
     * @secure
     */
    revokeAsync: (data: ContentSharedLinkIdRequest, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse | void>({
        path: `/api/ContentSharedLink/revoke`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ContentSharedLink
     * @name IntroduceAsync
     * @summary Introduce existing shared content link
     * @request PUT:/api/ContentSharedLink/introduce
     * @secure
     */
    introduceAsync: (data: ContentSharedLinkIdRequest, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse | void>({
        path: `/api/ContentSharedLink/introduce`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  }
  contentSharings = {
    /**
     * No description
     *
     * @tags ContentSharings
     * @name CopyContentAsync
     * @summary Copy Content
     * @request POST:/api/contentsharings/copycontent
     * @secure
     */
    copyContentAsync: (data: CopyContentRequest, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse | void>({
        path: `/api/contentsharings/copycontent`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ContentSharings
     * @name RevokeContentSharingAsync
     * @summary Revoke Content Sharing
     * @request GET:/api/contentsharings/revokesharing/{contentSharingId}
     * @secure
     */
    revokeContentSharingAsync: (contentSharingId: number, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/contentsharings/revokesharing/${contentSharingId}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ContentSharings
     * @name GetContentReviewsAsync
     * @summary Get Content Reviews
     * @request GET:/api/contentsharings/getreviews/{contentId}
     * @secure
     */
    getContentReviewsAsync: (contentId: number, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/contentsharings/getreviews/${contentId}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ContentSharings
     * @name SendReviewFeedbackAsync
     * @summary Send Review Feedback
     * @request POST:/api/contentsharings/sendReviewFeedback
     * @secure
     */
    sendReviewFeedbackAsync: (data: ContentReviewRequest, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse | void>({
        path: `/api/contentsharings/sendReviewFeedback`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ContentSharings
     * @name CompleteReviewAsync
     * @summary Complete Review
     * @request POST:/api/contentsharings/completeReview
     * @secure
     */
    completeReviewAsync: (data: ReviewResultRequest, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse | void>({
        path: `/api/contentsharings/completeReview`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ContentSharings
     * @name SwitchReviewerAsync
     * @summary Switch Reviewer
     * @request POST:/api/contentsharings/switchReviewer
     * @secure
     */
    switchReviewerAsync: (data: SwitchReviewerRequest, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse | void>({
        path: `/api/contentsharings/switchReviewer`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ContentSharings
     * @name GetTenantContentReviewsAsync
     * @summary Get Tenant Content Reviews
     * @request GET:/api/contentsharings/getTenantContentReviews/{contentId}
     * @secure
     */
    getTenantContentReviewsAsync: (contentId: number, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/contentsharings/getTenantContentReviews/${contentId}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ContentSharings
     * @name JoinContentReviewAsync
     * @summary Join Content Review
     * @request POST:/api/contentsharings/joinContentReview
     * @secure
     */
    joinContentReviewAsync: (data: JoinContentReviewRequest, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse | void>({
        path: `/api/contentsharings/joinContentReview`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ContentSharings
     * @name GetTenantsListForReviewAsync
     * @summary Get Tenants List For Review
     * @request GET:/api/contentsharings/gettenantslistforreview/{contentId}
     * @secure
     */
    getTenantsListForReviewAsync: (contentId: number, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/contentsharings/gettenantslistforreview/${contentId}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ContentSharings
     * @name GetDataForSharingByFormsRequestAsync
     * @summary Get Data For Sharing By Forms Request
     * @request POST:/api/contentsharings/dataByContentforms
     * @secure
     */
    getDataForSharingByFormsRequestAsync: (data: ContentSharingFormsRequest, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse | void>({
        path: `/api/contentsharings/dataByContentforms`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ContentSharings
     * @name PostAsync
     * @summary Share content to copy or review
     * @request POST:/api/contentsharings
     * @secure
     */
    postAsync: (data: ContentSharingRequest, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse | void>({
        path: `/api/contentsharings`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
 * No description
 *
 * @tags ContentSharings
 * @name RenameContentForTenantAsync
 * @summary A request for renaming content name (description) in a reviewer tenant.
A content name must be modified using a naming convention form of a reviewer tenant.
 * @request PUT:/api/contentsharings/renameContent
 * @secure
 */
    renameContentForTenantAsync: (data: UpdateContentDescriptionForTenantRequest, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse | void>({
        path: `/api/contentsharings/renameContent`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ContentSharings
     * @name SendForInContentReviewAsync
     * @summary Sends content for an in-content review.
     * @request POST:/api/contentsharings/incontentreview
     * @secure
     */
    sendForInContentReviewAsync: (data: ContentIdResponse, params: RequestParams = {}) =>
      this.http.request<IActionResult, ApiErrorResponse | void>({
        path: `/api/contentsharings/incontentreview`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ContentSharings
     * @name BeginInContentReviewAsync
     * @summary Begins an in-content review.
     * @request POST:/api/contentsharings/incontentreview/begin
     * @secure
     */
    beginInContentReviewAsync: (data: ContentIdResponse, params: RequestParams = {}) =>
      this.http.request<IActionResult, ApiErrorResponse | void>({
        path: `/api/contentsharings/incontentreview/begin`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ContentSharings
     * @name CompleteInContentReviewAsync
     * @summary Completes an in-content review.
     * @request POST:/api/contentsharings/incontentreview/complete
     * @secure
     */
    completeInContentReviewAsync: (data: ContentIdResponse, params: RequestParams = {}) =>
      this.http.request<IActionResult, ApiErrorResponse | void>({
        path: `/api/contentsharings/incontentreview/complete`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ContentSharings
     * @name InContentReviewSendFeedbackAsync
     * @summary Sends feedback for an in-content review.
     * @request POST:/api/contentsharings/incontentreview/sendfeedback
     * @secure
     */
    inContentReviewSendFeedbackAsync: (data: ContentIdResponse, params: RequestParams = {}) =>
      this.http.request<IActionResult, ApiErrorResponse | void>({
        path: `/api/contentsharings/incontentreview/sendfeedback`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ContentSharings
     * @name GetSessionReviewStatusAsync
     * @summary Gets a review status for a content.
     * @request GET:/api/contentsharings/getreviewstatus/{contentId}
     * @secure
     */
    getSessionReviewStatusAsync: (contentId: number, params: RequestParams = {}) =>
      this.http.request<ReviewStatus, ApiErrorResponse>({
        path: `/api/contentsharings/getreviewstatus/${contentId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
 * No description
 *
 * @tags ContentSharings
 * @name LinkContentRequestAsync
 * @summary A request to link up current user content (First) with another content (Second).
If 'Second content' owner accepts this request then the contents become linked with each other.
The linked contents have a possibility to pass selected data back and forth.
 * @request POST:/api/contentsharings/link/request
 * @secure
 */
    linkContentRequestAsync: (data: ContentLinkRequest, params: RequestParams = {}) =>
      this.http.request<ContentLinkResponse, ApiErrorResponse | void>({
        path: `/api/contentsharings/link/request`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ContentSharings
     * @name GetLinkedContentsAsync
     * @summary A request to get a list of linked contents by requested content Id.
     * @request GET:/api/contentsharings/linkedcontents/{contentId}
     * @secure
     */
    getLinkedContentsAsync: (contentId: number, params: RequestParams = {}) =>
      this.http.request<ContentLinkResponse, ApiErrorResponse>({
        path: `/api/contentsharings/linkedcontents/${contentId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ContentSharings
     * @name DeleteContentsLinkAsync
     * @summary A request to delete existing contents' link.
     * @request DELETE:/api/contentsharings/linkedcontents/{contentsLinkId}
     * @secure
     */
    deleteContentsLinkAsync: (contentsLinkId: number, params: RequestParams = {}) =>
      this.http.request<ContentLinkResponse, ApiErrorResponse>({
        path: `/api/contentsharings/linkedcontents/${contentsLinkId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ContentSharings
     * @name UpdateInContentReviewStatusAsync
     * @summary A request to update review status.
     * @request PUT:/api/contentsharings/incontentreviewstatus
     * @secure
     */
    updateInContentReviewStatusAsync: (data: ContentReviewStatusRequest, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse | void>({
        path: `/api/contentsharings/incontentreviewstatus`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  }
  contentsUploads = {
    /**
     * No description
     *
     * @tags ContentsUploads
     * @name PostPdfAsync
     * @summary Post Pdf
     * @request POST:/api/contents/{contentId}/pdf
     * @deprecated
     * @secure
     */
    postPdfAsync: (
      contentId: number,
      query?: {
        pdfUrl?: string
        /** @format int32 */
        index?: number
        /** @format int32 */
        timeZoneOffset?: number
        /** @format int32 */
        folderId?: number
        /** @default "" */
        pdfName?: string
      },
      params: RequestParams = {}
    ) =>
      this.http.request<void, ApiErrorResponse>({
        path: `/api/contents/${contentId}/pdf`,
        method: 'POST',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ContentsUploads
     * @name ExportPdfAsync
     * @summary Export Pdf
     * @request POST:/api/contents/exportpdf
     * @secure
     */
    exportPdfAsync: (data: StartExportPdfRequest, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse | void>({
        path: `/api/contents/exportpdf`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ContentsUploads
     * @name ExportImagesAsync
     * @summary Export Images
     * @request POST:/api/contents/exportimages
     * @secure
     */
    exportImagesAsync: (data: StartExportImagesRequest, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse | void>({
        path: `/api/contents/exportimages`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ContentsUploads
     * @name PostReturnSasAsync
     * @summary Get Shared Access Signature for uploading directly to blob storage.
     * @request GET:/api/contents/upload-params
     * @secure
     */
    postReturnSasAsync: (
      query: {
        FileName: string
        /**
         *
         *
         * 1 = Page
         *
         * 2 = FormThumbnail
         *
         * 3 = SettingData
         *
         * 4 = AiExpressionImage
         *
         * 5 = ArticleDocument
         *
         * 6 = FormData
         *
         * 7 = AudioChatMessage
         *
         * 8 = AssistantDocument
         *
         * 9 = ThreeDimensionalModel
         *
         * 10 = ThreeDimensionalModelThumbnail
         */
        UploadContentType?: UploadContentType
        /**
         * The Id of the session to which file will be linked.
         * @format int32
         */
        ContentId?: number
      },
      params: RequestParams = {}
    ) =>
      this.http.request<string, ApiErrorResponse>({
        path: `/api/contents/upload-params`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ContentsUploads
     * @name SasBackwardCompatibilityAsync
     * @request POST:/api/contents/sas
     * @deprecated
     * @secure
     */
    sasBackwardCompatibilityAsync: (data: GetUploadSasRequestBackwardCompatibility, params: RequestParams = {}) =>
      this.http.request<string, ApiErrorResponse | void>({
        path: `/api/contents/sas`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  }
  contentUsers = {
    /**
     * No description
     *
     * @tags ContentUsers
     * @name GetQualifications
     * @request GET:/api/content-users/qualifications
     * @secure
     */
    getQualifications: (
      query: {
        /** @format int32 */
        contentId: number
        /** @format int32 */
        userId: number
      },
      params: RequestParams = {}
    ) =>
      this.http.request<void, any>({
        path: `/api/content-users/qualifications`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ContentUsers
     * @name UpdateQualifications
     * @request PUT:/api/content-users/qualifications
     * @secure
     */
    updateQualifications: (data: UpdateContentUserQualificationsRequest, params: RequestParams = {}) =>
      this.http.request<void, void>({
        path: `/api/content-users/qualifications`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  }
  drones = {
    /**
     * No description
     *
     * @tags Drones
     * @name GetDroneUrls
     * @summary Get Drone Urls
     * @request GET:/api/drones/urls
     * @secure
     */
    getDroneUrls: (params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/drones/urls`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Drones
     * @name GetAllAsync
     * @summary Get All
     * @request GET:/api/drones
     * @secure
     */
    getAllAsync: (params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/drones`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Drones
     * @name PostAsync
     * @summary Post
     * @request POST:/api/drones
     * @secure
     */
    postAsync: (data: DroneRequest, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse | void>({
        path: `/api/drones`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Drones
     * @name UpdateAsync
     * @summary Put
     * @request PUT:/api/drones
     * @secure
     */
    updateAsync: (data: DroneRequest, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse | void>({
        path: `/api/drones`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Drones
     * @name GetAsync
     * @summary Get
     * @request GET:/api/drones/{id}
     * @secure
     */
    getAsync: (id: number, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/drones/${id}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Drones
     * @name DeleteAsync
     * @summary Delete
     * @request DELETE:/api/drones/{id}
     * @secure
     */
    deleteAsync: (id: number, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/drones/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Drones
     * @name PutAsync
     * @summary Put
     * @request PUT:/api/drones/{id}
     * @secure
     */
    putAsync: (id: number, data: DroneRequest, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse | void>({
        path: `/api/drones/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Drones
     * @name StartRecordingAsync
     * @summary Start Recording
     * @request GET:/api/drones/startRecording/{pageId}
     * @secure
     */
    startRecordingAsync: (pageId: number, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/drones/startRecording/${pageId}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Drones
     * @name StopRecordingAsync
     * @summary Stop Recording
     * @request GET:/api/drones/stopRecording/{pageId}
     * @secure
     */
    stopRecordingAsync: (pageId: number, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/drones/stopRecording/${pageId}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Drones
     * @name ReleaseDroneByDroneKeyAsync
     * @summary Release Drone By Drone Key
     * @request GET:/api/drones/releaseDroneByDroneKey/{droneKey}
     * @secure
     */
    releaseDroneByDroneKeyAsync: (droneKey: string, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/drones/releaseDroneByDroneKey/${droneKey}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Drones
     * @name ReleaseDroneByPageIdAsync
     * @summary Release Drone By Page Id
     * @request GET:/api/drones/releaseDroneByPageId/{pageId}
     * @secure
     */
    releaseDroneByPageIdAsync: (pageId: number, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/drones/releaseDroneByPageId/${pageId}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Drones
     * @name AddDronePageAsync
     * @summary Add Drone Page
     * @request POST:/api/drones/addDronePage
     * @secure
     */
    addDronePageAsync: (data: DronePageRequest, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse | void>({
        path: `/api/drones/addDronePage`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Drones
     * @name GetRecordingStatusAsync
     * @summary Get Recording Status
     * @request GET:/api/drones/recordingStatus/{pageId}
     * @secure
     */
    getRecordingStatusAsync: (pageId: number, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/drones/recordingStatus/${pageId}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Drones
     * @name AddRecordedPageAsync
     * @summary Add Recorded Page
     * @request GET:/api/drones/addRecordedPage/{recordId}
     * @secure
     */
    addRecordedPageAsync: (recordId: number, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse>({
        path: `/api/drones/addRecordedPage/${recordId}`,
        method: 'GET',
        secure: true,
        ...params,
      }),
  }
  folders = {
    /**
     * No description
     *
     * @tags Folders
     * @name GetAsync
     * @summary Get
     * @request GET:/api/folders/currentFolder/{id}
     * @secure
     */
    getAsync: (id: number, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/folders/currentFolder/${id}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Folders
     * @name GetDeletedFoldersAsync
     * @summary Get Deleted Folders
     * @request GET:/api/folders/deleted
     * @secure
     */
    getDeletedFoldersAsync: (params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/folders/deleted`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Folders
     * @name DeleteAsync
     * @summary Delete
     * @request DELETE:/api/folders/{id}
     * @secure
     */
    deleteAsync: (id: number, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/folders/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Folders
     * @name PutAsync
     * @summary Put
     * @request PUT:/api/folders/{id}
     * @secure
     */
    putAsync: (id: number, data: FolderResponse, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse | void>({
        path: `/api/folders/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Folders
     * @name DeletePermanentlyAsync
     * @summary Delete Permanently
     * @request POST:/api/folders/deletePermanently/{folderId}
     * @secure
     */
    deletePermanentlyAsync: (folderId: number, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/folders/deletePermanently/${folderId}`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Folders
     * @name RestoreFolderAsync
     * @summary Restore Folder
     * @request POST:/api/folders/restore/{folderId}
     * @secure
     */
    restoreFolderAsync: (folderId: number, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/folders/restore/${folderId}`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Folders
     * @name PostAddUsersAsync
     * @summary Post Add Users
     * @request POST:/api/folders/addUsers
     * @secure
     */
    postAddUsersAsync: (data: AddUsersFolderRequest, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse | void>({
        path: `/api/folders/addUsers`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Folders
     * @name GetFolderUsersAsync
     * @summary Get Folder Users
     * @request GET:/api/folders/getUsers
     * @secure
     */
    getFolderUsersAsync: (
      query?: {
        /** @format int32 */
        folderId?: number
      },
      params: RequestParams = {}
    ) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/folders/getUsers`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Folders
     * @name PutEditUsersAsync
     * @summary Put Edit Users
     * @request PUT:/api/folders/editUser
     * @secure
     */
    putEditUsersAsync: (data: EditFolderUsersRequest, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse | void>({
        path: `/api/folders/editUser`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Folders
     * @name LeaveAsync
     * @summary Leave
     * @request POST:/api/folders/leave
     * @secure
     */
    leaveAsync: (data: LeaveFolderRequest, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse | void>({
        path: `/api/folders/leave`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Folders
     * @name IsContentFolderParticipantAsync
     * @summary Is Content Folder Participant
     * @request GET:/api/folders/isContentFolderParticipant
     * @secure
     */
    isContentFolderParticipantAsync: (
      query?: {
        /** @format int32 */
        folderId?: number
        /** @format int32 */
        contentId?: number
      },
      params: RequestParams = {}
    ) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/folders/isContentFolderParticipant`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Folders
     * @name PostAsync
     * @summary Post
     * @request POST:/api/folders
     * @secure
     */
    postAsync: (data: FolderResponse, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse | void>({
        path: `/api/folders`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Folders
     * @name GetAllAsync
     * @summary Retrieving the list of folders for current user
     * @request GET:/api/folders
     * @secure
     */
    getAllAsync: (params: RequestParams = {}) =>
      this.http.request<FolderBaseResponse[], ApiErrorResponse>({
        path: `/api/folders`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Folders
     * @name CreateAsync
     * @summary Request creates new folder for contents
     * @request POST:/api/folders/create
     * @secure
     */
    createAsync: (data: CreateFolderRequest, params: RequestParams = {}) =>
      this.http.request<FolderBaseResponse, ApiErrorResponse | void>({
        path: `/api/folders/create`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Folders
     * @name RenameAsync
     * @summary Request for folder renaming
     * @request PUT:/api/folders/rename
     * @secure
     */
    renameAsync: (data: RenameContentFolderRequest, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse | void>({
        path: `/api/folders/rename`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  }
  formActions = {
    /**
     * No description
     *
     * @tags FormActions
     * @name TriggerAsync
     * @summary Request is used to trigger a form action
     * @request POST:/api/formActions/trigger
     * @secure
     */
    triggerAsync: (data: TriggerFormActionRequest, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse | void>({
        path: `/api/formActions/trigger`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags FormActions
     * @name NotifyFileReady
     * @summary Request is used to notify that a PDF report is ready
     * @request POST:/api/formActions/notify/fileReady
     * @secure
     */
    notifyFileReady: (data: NotifyFileReadyRequest, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse | void>({
        path: `/api/formActions/notify/fileReady`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  }
  formAnswers = {
    /**
     * No description
     *
     * @tags FormAnswers
     * @name CheckAsync
     * @summary Check
     * @request POST:/api/formanswers/conditions/check
     * @secure
     */
    checkAsync: (data: CheckConditionsRequest, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse | void>({
        path: `/api/formanswers/conditions/check`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags FormAnswers
     * @name SetFormAnswerStatusByReviewerAsync
     * @summary Set Form Answer Status By Reviewer
     * @request PUT:/api/formanswers/setformanswerstatusbyreviewer
     * @secure
     */
    setFormAnswerStatusByReviewerAsync: (data: SetFormAnswerStatusRequest, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse | void>({
        path: `/api/formanswers/setformanswerstatusbyreviewer`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags FormAnswers
     * @name GetAnswersByFormIdAsync
     * @summary Get Answers By Form Id
     * @request GET:/api/formanswers/getanswersbyformId/{contentFormId}/{userId}/{pageId}
     * @secure
     */
    getAnswersByFormIdAsync: (
      contentFormId: number,
      userId: number,
      pageId: string,
      query?: {
        /** @format int32 */
        pageId?: number
      },
      params: RequestParams = {}
    ) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/formanswers/getanswersbyformId/${contentFormId}/${userId}/${pageId}`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags FormAnswers
     * @name GetLatestAnswerByFormIdAsync
     * @summary Get Latest Answer By Form Id
     * @request GET:/api/formanswers/getlatestanswerbyformId/{contentFormId}/{contentSharingId}
     * @secure
     */
    getLatestAnswerByFormIdAsync: (
      contentFormId: number,
      contentSharingId: string,
      query?: {
        /** @format int32 */
        contentSharingId?: number
      },
      params: RequestParams = {}
    ) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/formanswers/getlatestanswerbyformId/${contentFormId}/${contentSharingId}`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags FormAnswers
     * @name GetAnswersByTabIdAsync
     * @summary Get Answers By Tab Id
     * @request GET:/api/formanswers/getAnswersByTabId
     * @secure
     */
    getAnswersByTabIdAsync: (
      query?: {
        /** @format int32 */
        contentFormId?: number
        /** @format int32 */
        userId?: number
        formTabs?: number[]
        /** @format int32 */
        pageId?: number
      },
      params: RequestParams = {}
    ) =>
      this.http.request<FormControlAnswerResponse[], ApiErrorResponse>({
        path: `/api/formanswers/getAnswersByTabId`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags FormAnswers
     * @name GetLatestAnswersByTabIdAsync
     * @summary Get Latest Answers By Tab Id
     * @request GET:/api/formanswers/getLatestAnswersByTabId
     * @secure
     */
    getLatestAnswersByTabIdAsync: (
      query?: {
        /** @format int32 */
        contentFormId?: number
        /** @format int32 */
        contentSharingId?: number
      },
      params: RequestParams = {}
    ) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/formanswers/getLatestAnswersByTabId`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags FormAnswers
     * @name ClearAnswersAsync
     * @summary Clear Answers
     * @request POST:/api/formanswers/clearanswers/{formAnswerId}
     * @secure
     */
    clearAnswersAsync: (formAnswerId: number, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/formanswers/clearanswers/${formAnswerId}`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags FormAnswers
     * @name GetPagesWithContentFormControlAnswersAsync
     * @summary Get Pages With Content Form Control Answers
     * @request POST:/api/formanswers/getPagesWithFormControlAnswers
     * @secure
     */
    getPagesWithContentFormControlAnswersAsync: (
      data: PagesWithFormControlAnswersGetRequest,
      params: RequestParams = {}
    ) =>
      this.http.request<PageByFormControlAnswer[], ApiErrorResponse | void>({
        path: `/api/formanswers/getPagesWithFormControlAnswers`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags FormAnswers
     * @name ConfirmFormAnswersAsync
     * @summary Confirm Form Answers
     * @request GET:/api/formanswers/confirmAnswers/{contentFormId}/{timezoneOffset}
     * @secure
     */
    confirmFormAnswersAsync: (contentFormId: number, timezoneOffset: number, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/formanswers/confirmAnswers/${contentFormId}/${timezoneOffset}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags FormAnswers
     * @name GetAnswersByRecordAsync
     * @summary Get Answers By Record
     * @request GET:/api/formanswers/getAnswersByRecord
     * @secure
     */
    getAnswersByRecordAsync: (
      query?: {
        /** @format int32 */
        recordId?: number
      },
      params: RequestParams = {}
    ) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/formanswers/getAnswersByRecord`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags FormAnswers
     * @name PostAsync
     * @summary Request to create new form answers
     * @request POST:/api/formanswers
     * @secure
     */
    postAsync: (data: CreateFormAnswerRequest, params: RequestParams = {}) =>
      this.http.request<FormControlAnswerResponse, ApiErrorResponse | void>({
        path: `/api/formanswers`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags FormAnswers
     * @name SetFormAnswerStatusAsync
     * @summary Request to update form answer status.
     * @request PUT:/api/formanswers/setformanswerstatus
     * @secure
     */
    setFormAnswerStatusAsync: (data: SetFormAnswerStatusRequest, params: RequestParams = {}) =>
      this.http.request<SetFormAnswerStatusResponse, ApiErrorResponse | void>({
        path: `/api/formanswers/setformanswerstatus`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags FormAnswers
     * @name GetFormAnswersByPageIdAsync
     * @summary Request is used to get list of answers by page
     * @request GET:/api/formanswers/bypage/{pageId}
     * @secure
     */
    getFormAnswersByPageIdAsync: (
      pageId: number,
      query?: {
        /**
         * Unique id of the user within the system
         * @format int32
         */
        userId?: number
        /**
         * Unique id of the form within the system
         * @format int32
         */
        formId?: number
        /**
         * Statuses
         *
         * 0 = Pending
         *
         * 1 = Pass
         *
         * 2 = Fail
         *
         * 3 = Empty
         *
         * 4 = ApprovedByAI
         *
         * 5 = RejectedByAI
         *
         * 6 = ApprovedByReviewer
         *
         * 7 = RejectedByReviewer
         */
        statuses?: FormAnswerStatus[]
        /**
         * Number of answers to skip
         * @format int32
         * @default 0
         */
        skip?: number
        /**
         * Number of answers to take
         * @format int32
         * @default 50
         */
        take?: number
      },
      params: RequestParams = {}
    ) =>
      this.http.request<FormControlAnswerResponse[], ApiErrorResponse>({
        path: `/api/formanswers/bypage/${pageId}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags FormAnswers
     * @name GetFormAnswersByQuestionIdAsync
     * @summary Request is used to get list of answers by question
     * @request GET:/api/formanswers/byformquestion/{contentFormId}/{questionId}
     * @secure
     */
    getFormAnswersByQuestionIdAsync: (
      questionId: number,
      contentFormId: number,
      query?: {
        /**
         * Unique id of the user within the system
         * @format int32
         */
        userId?: number
        /**
         * Statuses
         *
         * 0 = Pending
         *
         * 1 = Pass
         *
         * 2 = Fail
         *
         * 3 = Empty
         *
         * 4 = ApprovedByAI
         *
         * 5 = RejectedByAI
         *
         * 6 = ApprovedByReviewer
         *
         * 7 = RejectedByReviewer
         */
        statuses?: FormAnswerStatus[]
        /**
         * Number of answers to skip
         * @format int32
         * @default 0
         */
        skip?: number
        /**
         * Number of answers to take
         * @format int32
         * @default 50
         */
        take?: number
      },
      params: RequestParams = {}
    ) =>
      this.http.request<FormControlAnswerResponse[], ApiErrorResponse>({
        path: `/api/formanswers/byformquestion/${contentFormId}/${questionId}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  }
  formControlOptions = {
    /**
     * No description
     *
     * @tags FormControlOptions
     * @name AttachAiExpressionAsync
     * @summary Attach AI expression
     * @request POST:/api/formControlOptions/{formControlOptionId}/aiExpression/{expressionId}
     * @secure
     */
    attachAiExpressionAsync: (formControlOptionId: number, expressionId: number, params: RequestParams = {}) =>
      this.http.request<ControlOptionsResponse, ApiErrorResponse>({
        path: `/api/formControlOptions/${formControlOptionId}/aiExpression/${expressionId}`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags FormControlOptions
     * @name DetachFromFormControlOptionAsync
     * @summary Detach AI expression
     * @request DELETE:/api/formControlOptions/{formControlOptionId}/aiExpression
     * @secure
     */
    detachFromFormControlOptionAsync: (formControlOptionId: number, params: RequestParams = {}) =>
      this.http.request<ControlOptionsResponse, ApiErrorResponse>({
        path: `/api/formControlOptions/${formControlOptionId}/aiExpression`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),
  }
  formFolders = {
    /**
     * No description
     *
     * @tags FormFolders
     * @name PublishAsync
     * @summary Publish
     * @request POST:/api/formFolders/publish
     * @secure
     */
    publishAsync: (data: PublishFormFolderRequest, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse | void>({
        path: `/api/formFolders/publish`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags FormFolders
     * @name UnpublishAsync
     * @summary Unpublish
     * @request POST:/api/formFolders/unpublish
     * @secure
     */
    unpublishAsync: (data: PublishFormFolderRequest, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse | void>({
        path: `/api/formFolders/unpublish`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
 * No description
 *
 * @tags FormFolders
 * @name GetAllAsync
 * @summary Request returns a list of form folders for current user
A folder is available if it's created by current user or if it's published to the current user's tenant
 * @request GET:/api/formFolders
 * @secure
 */
    getAllAsync: (params: RequestParams = {}) =>
      this.http.request<FormFolderResponse[], ApiErrorResponse>({
        path: `/api/formFolders`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Sample request: { "Name": "New folder" } Sample response: { "FolderId": 123, "Name": "New folder", "UserId": "112233", "CanBeDeleted": true, "TenantId": 99, "TenantName": "tenant", "PublishedFolderTenants": [] }
     *
     * @tags FormFolders
     * @name PostAsync
     * @summary Request creates a new form folder
     * @request POST:/api/formFolders
     * @secure
     */
    postAsync: (data: CreateFormFolderRequest, params: RequestParams = {}) =>
      this.http.request<FormFolderResponse, ApiErrorResponse | void>({
        path: `/api/formFolders`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags FormFolders
     * @name DeleteAsync
     * @summary Request is used to delete existing form folder
     * @request DELETE:/api/formFolders/{folderId}
     * @secure
     */
    deleteAsync: (folderId: number, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse>({
        path: `/api/formFolders/${folderId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * @description Sample request: { "FolderId": 999, "Name": "Another great name" }
     *
     * @tags FormFolders
     * @name RenameAsync
     * @summary Request is used to rename existing form folder
     * @request PUT:/api/formFolders/rename
     * @secure
     */
    renameAsync: (data: RenameFormFolderRequest, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse | void>({
        path: `/api/formFolders/rename`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags FormFolders
     * @name GetFormsByFolderIdAsync
     * @summary Request returns a list of forms from a particular folder
     * @request GET:/api/formFolders/formsInFolder/{folderId}
     * @deprecated
     * @secure
     */
    getFormsByFolderIdAsync: (folderId: number, params: RequestParams = {}) =>
      this.http.request<FormResponse[], ApiErrorResponse>({
        path: `/api/formFolders/formsInFolder/${folderId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags FormFolders
     * @name MoveFormToFolderAsync
     * @summary Request is used to move a form to/from a folder.
     * @request POST:/api/formFolders/move
     * @secure
     */
    moveFormToFolderAsync: (data: FormFolderRequest, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse | void>({
        path: `/api/formFolders/move`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  }
  forms = {
    /**
 * No description
 *
 * @tags Forms
 * @name GetFormsListForCurrentUserAsync
 * @summary Request returns a list of forms available for attaching.
A form is available if it's created by current user or if it's published to the current user's tenant.
 * @request GET:/api/forms/getAvailable
 * @secure
 */
    getFormsListForCurrentUserAsync: (
      query?: {
        /**
         * Id of the folder to return forms from. If null, the method returns only those forms that do not belong to any folder.
         * @format int32
         */
        folderId?: number
        /**
         * If true, the method returns all the forms incuding those inside folders.
         * @default false
         */
        allForms?: boolean
      },
      params: RequestParams = {}
    ) =>
      this.http.request<FormResponse[], ApiErrorResponse>({
        path: `/api/forms/getAvailable`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Forms
     * @name GetAllFormsAsync
     * @summary Get All Forms
     * @request GET:/api/forms/allForms
     * @secure
     */
    getAllFormsAsync: (
      query?: {
        /**
         * @format int32
         * @default 1
         */
        pageNumber?: number
        /**
         * @format int32
         * @default 50
         */
        pageSize?: number
        /** @default "" */
        searchQuery?: string
      },
      params: RequestParams = {}
    ) =>
      this.http.request<AllTenantFormsView[], ApiErrorResponse>({
        path: `/api/forms/allForms`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Forms
     * @name PublishAsync
     * @summary Publish
     * @request POST:/api/forms/publish
     * @secure
     */
    publishAsync: (data: PublishFormRequest, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse | void>({
        path: `/api/forms/publish`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Forms
     * @name UnpublishAsync
     * @summary Unpublish
     * @request POST:/api/forms/unpublish
     * @secure
     */
    unpublishAsync: (data: PublishFormRequest, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse | void>({
        path: `/api/forms/unpublish`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Forms
     * @name UpdateAsync
     * @summary Put
     * @request PUT:/api/forms
     * @secure
     */
    updateAsync: (data: FormCreateOrUpdateRequest, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse | void>({
        path: `/api/forms`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
 * No description
 *
 * @tags Forms
 * @name GetAllAsync
 * @summary Request returns a paginated list of forms for current user.
A form is available if it's created by current user or if it's published to the current user's tenant.
 * @request GET:/api/forms
 * @secure
 */
    getAllAsync: (
      query?: {
        /**
         * Gets or sets search string used to filter forms by their name.
         * @maxLength 256
         */
        Search?: string
        /**
         * Gets or sets the folder ID to filter contents.
         * @format int32
         */
        FolderId?: number
        /**
         * Gets or sets the number of records to skip for pagination.
         * @format int32
         * @min 0
         * @max 2147483647
         */
        Skip?: number
        /**
         * Gets or sets the number of records to take for pagination.
         * @format int32
         * @min 1
         * @max 100
         */
        Take?: number
      },
      params: RequestParams = {}
    ) =>
      this.http.request<GetFormsResponse, ApiErrorResponse>({
        path: `/api/forms`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Sample request (simple form with 3 questions): { "Name": "Metal form", "Controls": [ { "ControlType": 1 (Text), "Label": "Type the name of your favourite band", "Order": 0 }, { "ControlType": 3 (Checkboxlist), "Label": "Select the bands you prefer most", "Order": 1, "Options": [ { "Value": "Metallica", "Order": 0 }, { "Value": "Manowar", "Order": 1 }, { "Value": "Tool", "Order": 2 }, { "Value": "Rammstein", "Order": 3 } ] }, { "ControlType": 4 (Radiobuttonlist), "Label": "Have you ever attended your favourite band show?", "Order": 2, "Options": [ { "Value": "Yes", "Order": 0 }, { "Value": "No", "Order": 1 } ] } ] } Sample response: { "FormId": 123, "Name": "Metal form", "Questions": [ { "Id": 48234, "Label": "Type the name of your favourite band" }, { "Id": 48235, "Label": "Select the bands you prefer most" }, { "Id": 48236, "Label": "Have you ever attended your favourite band show?" } ] }
     *
     * @tags Forms
     * @name CreateAsync
     * @summary Request creates a new form.
     * @request POST:/api/forms
     * @secure
     */
    createAsync: (data: FormCreateOrUpdateRequest, params: RequestParams = {}) =>
      this.http.request<CreatedFormResponse, ApiErrorResponse | void>({
        path: `/api/forms`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Forms
     * @name UpdateFormControlsProcessingAsync
     * @summary Update Form Control's Processing
     * @request PUT:/api/forms/formcontrols/processing
     * @secure
     */
    updateFormControlsProcessingAsync: (data: FormControlProcessingUpdateRequest, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse | void>({
        path: `/api/forms/formcontrols/processing`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Forms
     * @name ProcessFormControlsAsync
     * @summary Process Form Controls
     * @request POST:/api/forms/{formId}/form-controls/processing/start
     * @secure
     */
    processFormControlsAsync: (formId: number, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/forms/${formId}/form-controls/processing/start`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Forms
     * @name DeleteAsync
     * @summary Delete
     * @request DELETE:/api/forms/{formId}
     * @secure
     */
    deleteAsync: (formId: number, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/forms/${formId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Forms
     * @name GetAsync
     * @summary Returns a form by its Id. Response includes all form parts, such as controls, options, etc.
     * @request GET:/api/forms/{formId}
     * @secure
     */
    getAsync: (formId: number, params: RequestParams = {}) =>
      this.http.request<GetFormResponse, ApiErrorResponse>({
        path: `/api/forms/${formId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Forms
     * @name CopyAsync
     * @summary Request is used to create a copy of an existing form
     * @request POST:/api/forms/copy/{formId}
     * @secure
     */
    copyAsync: (formId: number, params: RequestParams = {}) =>
      this.http.request<FormIdResponse, ApiErrorResponse>({
        path: `/api/forms/copy/${formId}`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Forms
     * @name UpdateControlInfoThumbnailAsync
     * @summary Update Control Info Thumbnail
     * @request POST:/api/forms/updateControlInfoThumbnail
     * @secure
     */
    updateControlInfoThumbnailAsync: (data: UpdateThumbnailRequest, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse | void>({
        path: `/api/forms/updateControlInfoThumbnail`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Forms
     * @name UpdateFormControlInfoContentAsync
     * @summary Update Form Control Info Content
     * @request POST:/api/forms/updateFormControlInfoContent
     * @secure
     */
    updateFormControlInfoContentAsync: (data: ControlInfoRequest, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse | void>({
        path: `/api/forms/updateFormControlInfoContent`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Forms
     * @name ExportCsvAsync
     * @summary Export Csv
     * @request POST:/api/forms/exportcsv
     * @secure
     */
    exportCsvAsync: (data: FormAnswersJsonExportRequest, params: RequestParams = {}) =>
      this.http.request<ExportContentFormsResponse, ApiErrorResponse | void>({
        path: `/api/forms/exportcsv`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Forms
     * @name ExportJsonAsync
     * @summary Request is used to export session forms in json format
     * @request POST:/api/forms/exportjson
     * @secure
     */
    exportJsonAsync: (data: FormAnswersJsonExportRequest, params: RequestParams = {}) =>
      this.http.request<ExportContentFormsResponse, ApiErrorResponse | void>({
        path: `/api/forms/exportjson`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  }
  formsPermissions = {
    /**
     * No description
     *
     * @tags FormsPermissions
     * @name GetFormPermissionsByNewFormAsync
     * @request GET:/api/form-permissions/forms/default
     * @secure
     */
    getFormPermissionsByNewFormAsync: (params: RequestParams = {}) =>
      this.http.request<GetFormPermissionsByNewFormResponse, ApiErrorResponse>({
        path: `/api/form-permissions/forms/default`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags FormsPermissions
     * @name GetAdvancedFormSettingsByFormAsync
     * @request GET:/api/form-permissions/forms/{formId}
     * @secure
     */
    getAdvancedFormSettingsByFormAsync: (formId: number, params: RequestParams = {}) =>
      this.http.request<GetFormPermissionsByNewFormResponse, ApiErrorResponse>({
        path: `/api/form-permissions/forms/${formId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags FormsPermissions
     * @name UpdateFormPermissionsByFormAsync
     * @request PUT:/api/form-permissions/forms/{formId}
     * @secure
     */
    updateFormPermissionsByFormAsync: (
      formId: number,
      data: UpdateFormPermissionsByFormRequest,
      params: RequestParams = {}
    ) =>
      this.http.request<void, ApiErrorResponse | void>({
        path: `/api/form-permissions/forms/${formId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags FormsPermissions
     * @name DeleteFormPermissionsOverrideByFormAsync
     * @request DELETE:/api/form-permissions/forms/{formId}
     * @secure
     */
    deleteFormPermissionsOverrideByFormAsync: (formId: number, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse>({
        path: `/api/form-permissions/forms/${formId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags FormsPermissions
     * @name GetFormPermissionsByTenantAsync
     * @request GET:/api/form-permissions/tenants/{subdomain}
     * @secure
     */
    getFormPermissionsByTenantAsync: (subdomain: string, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/form-permissions/tenants/${subdomain}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags FormsPermissions
     * @name UpdateFormPermissionsByTenantAsync
     * @request PUT:/api/form-permissions/tenants/{subdomain}
     * @secure
     */
    updateFormPermissionsByTenantAsync: (
      subdomain: string,
      data: UpdateFormPermissionsByTenantRequest,
      params: RequestParams = {}
    ) =>
      this.http.request<any, ApiErrorResponse | void>({
        path: `/api/form-permissions/tenants/${subdomain}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags FormsPermissions
     * @name DeleteFormPermissionsOverrideByTenantAsync
     * @request DELETE:/api/form-permissions/tenants/{subdomain}
     * @secure
     */
    deleteFormPermissionsOverrideByTenantAsync: (subdomain: string, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/form-permissions/tenants/${subdomain}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),
  }
  images = {
    /**
     * No description
     *
     * @tags Images
     * @name AddTextToImageAsync
     * @summary Add Text To Image
     * @request GET:/api/images/addtext
     */
    addTextToImageAsync: (
      query?: {
        Text?: string
        Color?: string
        /** @format int32 */
        FontSize?: number
        ImageUrl?: string
        /** @format int32 */
        PageWidth?: number
        /** @format int32 */
        PageHeight?: number
        /** @format int32 */
        TextShift?: number
      },
      params: RequestParams = {}
    ) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/images/addtext`,
        method: 'GET',
        query: query,
        ...params,
      }),
  }
  invites = {
    /**
     * No description
     *
     * @tags Invites
     * @name GetAllAsync
     * @summary Get All
     * @request GET:/api/invites
     * @secure
     */
    getAllAsync: (params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/invites`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Invites
     * @name GetContentInvitesAsync
     * @summary Get Content Invites
     * @request GET:/api/invites/getcontentinvites/{contentId}
     * @secure
     */
    getContentInvitesAsync: (
      contentId: number,
      query?: {
        /**
         * Search text
         * @default ""
         */
        search?: string
      },
      params: RequestParams = {}
    ) =>
      this.http.request<InviteWithQualificationsResponse[], ApiErrorResponse>({
        path: `/api/invites/getcontentinvites/${contentId}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Invites
     * @name InviteIsValid
     * @summary Invite Is Valid
     * @request GET:/api/invites/isvalid
     * @secure
     */
    inviteIsValid: (
      query?: {
        token?: string
      },
      params: RequestParams = {}
    ) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/invites/isvalid`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Invites
     * @name CheckContentInviteAsync
     * @summary Check Content Invite
     * @request GET:/api/invites/checkcontent/{contentId}
     * @secure
     */
    checkContentInviteAsync: (contentId: number, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/invites/checkcontent/${contentId}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Invites
     * @name SendInvitesAsync
     * @summary Send Invite
     * @request POST:/api/invites/send
     * @secure
     */
    sendInvitesAsync: (data: InvitesCreateRequest, params: RequestParams = {}) =>
      this.http.request<InviteWithQualificationsResponse[], ApiErrorResponse | void>({
        path: `/api/invites/send`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Invites
     * @name ResendInviteAsync
     * @summary Request is used to resend invite
     * @request POST:/api/invites/{inviteId}/resend
     * @secure
     */
    resendInviteAsync: (inviteId: number, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse>({
        path: `/api/invites/${inviteId}/resend`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Invites
     * @name GetInviteUrlByIdAsync
     * @summary Request is used to get invite url
     * @request GET:/api/invites/{inviteId}/url
     * @secure
     */
    getInviteUrlByIdAsync: (inviteId: number, params: RequestParams = {}) =>
      this.http.request<string, ApiErrorResponse>({
        path: `/api/invites/${inviteId}/url`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Invites
     * @name UpdateQuickAccessUrlPasswordAsync
     * @summary Request is used to create quick access url
     * @request POST:/api/invites/{inviteId}/url
     * @secure
     */
    updateQuickAccessUrlPasswordAsync: (
      inviteId: number,
      data: InviteQuickLinkPasswordUpdateRequest,
      params: RequestParams = {}
    ) =>
      this.http.request<void, ApiErrorResponse | void>({
        path: `/api/invites/${inviteId}/url`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Invites
     * @name RevokeQuickAccessUrlAsync
     * @summary Request is used to revoke quick access url
     * @request DELETE:/api/invites/{inviteId}/url/revoke
     * @secure
     */
    revokeQuickAccessUrlAsync: (inviteId: number, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse>({
        path: `/api/invites/${inviteId}/url/revoke`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Invites
     * @name UpdateInviteTimeAsync
     * @summary Request is used to update invite time
     * @request PUT:/api/invites/{inviteId}/time
     * @secure
     */
    updateInviteTimeAsync: (inviteId: number, data: InviteTimeUpdateRequest, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse | void>({
        path: `/api/invites/${inviteId}/time`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Invites
     * @name UpdateInviteRoleAsync
     * @summary Request is used to update invite role
     * @request PUT:/api/invites/{inviteId}/role
     * @secure
     */
    updateInviteRoleAsync: (inviteId: number, data: InviteRoleUpdateRequest, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse | void>({
        path: `/api/invites/${inviteId}/role`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Invites
     * @name AcceptInviteAsync
     * @summary Request is used to accept invite
     * @request PUT:/api/invites/{inviteId}/accept
     * @secure
     */
    acceptInviteAsync: (inviteId: number, params: RequestParams = {}) =>
      this.http.request<InviteResponse, ApiErrorResponse>({
        path: `/api/invites/${inviteId}/accept`,
        method: 'PUT',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Invites
     * @name RejectInviteAsync
     * @summary Request is used to reject invite
     * @request PUT:/api/invites/{inviteId}/reject
     * @secure
     */
    rejectInviteAsync: (inviteId: number, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse>({
        path: `/api/invites/${inviteId}/reject`,
        method: 'PUT',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Invites
     * @name CancelInviteAsync
     * @summary Request is used to cancel invite
     * @request DELETE:/api/invites/{inviteId}/cancel
     * @secure
     */
    cancelInviteAsync: (inviteId: number, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse>({
        path: `/api/invites/${inviteId}/cancel`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),
  }
  maintenance = {
    /**
     * No description
     *
     * @tags Maintenance
     * @name GetMaintenanceMessageAsync
     * @summary Get maintenance message
     * @request GET:/api/Maintenance/message
     */
    getMaintenanceMessageAsync: (params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/api/Maintenance/message`,
        method: 'GET',
        ...params,
      }),
  }
  matterPort = {
    /**
     * No description
     *
     * @tags MatterPort
     * @name SendUnarchiveModelAsync
     * @summary Send Unarchive Model
     * @request POST:/api/matterport/model/unarchive
     * @secure
     */
    sendUnarchiveModelAsync: (data: UnarchiveRequest, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse | void>({
        path: `/api/matterport/model/unarchive`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  }
  measurement = {
    /**
     * No description
     *
     * @tags Measurement
     * @name PrepareModelAsync
     * @summary Prepare Model
     * @request POST:/api/measurement/prepareModel
     * @secure
     */
    prepareModelAsync: (data: PreparePointCloudModelRequest, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse | void>({
        path: `/api/measurement/prepareModel`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Measurement
     * @name NotifyModelCreatedAsync
     * @summary Notify Model Created
     * @request POST:/api/measurement/notifyModelCreated
     * @secure
     */
    notifyModelCreatedAsync: (data: PointCloudCreatedModel, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse | void>({
        path: `/api/measurement/notifyModelCreated`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  }
  mobileForms = {
    /**
     * No description
     *
     * @tags MobileForms
     * @name GetContentFormsByContentIdAsync
     * @summary Get Content Forms By Content Id
     * @request GET:/api/mobileforms/getcontentformsbycontentId/{contentId}
     * @secure
     */
    getContentFormsByContentIdAsync: (contentId: number, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/mobileforms/getcontentformsbycontentId/${contentId}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags MobileForms
     * @name GetContentFormsAnswersAsync
     * @summary Get Content Forms Answers
     * @request GET:/api/mobileforms/getcontentformsanswers
     * @secure
     */
    getContentFormsAnswersAsync: (
      query?: {
        /** @format int32 */
        contentId?: number
        /** @format int32 */
        userId?: number
        /** @format date-time */
        lastUpdated?: string
      },
      params: RequestParams = {}
    ) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/mobileforms/getcontentformsanswers`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags MobileForms
     * @name GetContentFormsAnswersStatusesAsync
     * @summary Get Content Forms Answers Statuses
     * @request GET:/api/mobileforms/getcontentformsanswersstatuses/{contentId}
     * @secure
     */
    getContentFormsAnswersStatusesAsync: (contentId: number, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/mobileforms/getcontentformsanswersstatuses/${contentId}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags MobileForms
     * @name GetAllAsync
     * @summary Get All
     * @request GET:/api/mobileforms
     * @secure
     */
    getAllAsync: (params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/mobileforms`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags MobileForms
     * @name PostAsync
     * @summary Post
     * @request POST:/api/mobileforms
     * @secure
     */
    postAsync: (data: ContentFormResponse, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse | void>({
        path: `/api/mobileforms`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags MobileForms
     * @name GetAsync
     * @summary Get
     * @request GET:/api/mobileforms/{id}
     * @secure
     */
    getAsync: (id: number, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/mobileforms/${id}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags MobileForms
     * @name PutAsync
     * @summary Put
     * @request PUT:/api/mobileforms/{id}
     * @secure
     */
    putAsync: (id: number, data: ContentFormResponse, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse | void>({
        path: `/api/mobileforms/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags MobileForms
     * @name DeleteAsync
     * @summary Delete
     * @request DELETE:/api/mobileforms/{id}
     * @secure
     */
    deleteAsync: (id: number, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/mobileforms/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),
  }
  notifications = {
    /**
     * No description
     *
     * @tags Notifications
     * @name GetAllAsync
     * @summary Get All
     * @request GET:/api/notifications
     * @secure
     */
    getAllAsync: (params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/notifications`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Notifications
     * @name GetAsync
     * @summary Get
     * @request GET:/api/notifications/{id}
     * @secure
     */
    getAsync: (id: number, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/notifications/${id}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Notifications
     * @name PutAsync
     * @summary Put
     * @request PUT:/api/notifications/{id}
     * @secure
     */
    putAsync: (id: number, data: NotificationResponse, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse | void>({
        path: `/api/notifications/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Notifications
     * @name PostUserEventAsync
     * @summary Post User Event
     * @request POST:/api/notifications/userevent/{eventType}
     * @secure
     */
    postUserEventAsync: (eventType: number, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/notifications/userevent/${eventType}`,
        method: 'POST',
        secure: true,
        ...params,
      }),
  }
  pageFolder = {
    /**
     * No description
     *
     * @tags PageFolder
     * @name GetAsync
     * @summary Request is used to get session folder by id
     * @request GET:/api/pagefolder/{id}
     * @secure
     */
    getAsync: (id: number, params: RequestParams = {}) =>
      this.http.request<PageFolderResponse, ApiErrorResponse>({
        path: `/api/pagefolder/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PageFolder
     * @name DeleteAsync
     * @summary Request is used to delete existing session folder
     * @request DELETE:/api/pagefolder/{id}
     * @secure
     */
    deleteAsync: (id: number, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse>({
        path: `/api/pagefolder/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags PageFolder
     * @name GetByContentAsync
     * @summary Request is used to get all folders from session
     * @request GET:/api/pagefolder/bycontent/{contentId}
     * @secure
     */
    getByContentAsync: (contentId: number, params: RequestParams = {}) =>
      this.http.request<PageFolderResponse[], ApiErrorResponse>({
        path: `/api/pagefolder/bycontent/${contentId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PageFolder
     * @name PostAsync
     * @summary Request is used to create new session folder
     * @request POST:/api/pagefolder
     * @secure
     */
    postAsync: (data: CreatePageFolderRequest, params: RequestParams = {}) =>
      this.http.request<PageFolderResponse, ApiErrorResponse | void>({
        path: `/api/pagefolder`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PageFolder
     * @name RenameAsync
     * @summary Request is used to rename existing session folder
     * @request PUT:/api/pagefolder/rename
     * @secure
     */
    renameAsync: (data: RenamePageFolderResponse, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse | void>({
        path: `/api/pagefolder/rename`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags PageFolder
     * @name GetAllWithDeletedPagesAsync
     * @summary Returns a list of folders containing deleted pages which may be restored
     * @request GET:/api/pagefolder/{contentId}/deleted
     * @secure
     */
    getAllWithDeletedPagesAsync: (contentId: number, params: RequestParams = {}) =>
      this.http.request<PageFolderResponse[], ApiErrorResponse>({
        path: `/api/pagefolder/${contentId}/deleted`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PageFolder
     * @name RestoreAsync
     * @summary Restores all the deleted pages in the folder
     * @request PUT:/api/pagefolder/{folderId}/restore
     * @secure
     */
    restoreAsync: (folderId: number, params: RequestParams = {}) =>
      this.http.request<IActionResult, ApiErrorResponse>({
        path: `/api/pagefolder/${folderId}/restore`,
        method: 'PUT',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PageFolder
     * @name DeleteFolderPermanentlyAsync
     * @summary Permanently deletes pages in the folder
     * @request DELETE:/api/pagefolder/{folderId}/permanently
     * @secure
     */
    deleteFolderPermanentlyAsync: (folderId: number, params: RequestParams = {}) =>
      this.http.request<IActionResult, ApiErrorResponse>({
        path: `/api/pagefolder/${folderId}/permanently`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PageFolder
     * @name SetFolderPrivacyAsync
     * @summary Updates folder's privacy state
     * @request PUT:/api/pagefolder/setPrivacy
     * @secure
     */
    setFolderPrivacyAsync: (data: UpdatePrivacyRequest, params: RequestParams = {}) =>
      this.http.request<IActionResult, ApiErrorResponse | void>({
        path: `/api/pagefolder/setPrivacy`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  }
  pageFolderPermission = {
    /**
     * No description
     *
     * @tags PageFolderPermission
     * @name GetUsersPermissionsByFolderAsync
     * @summary Returns a list of users permissions by the folder id
     * @request GET:/api/pagefolderpermissions/byFolder/{folderId}
     * @secure
     */
    getUsersPermissionsByFolderAsync: (folderId: number, params: RequestParams = {}) =>
      this.http.request<PageFolderPermissionModel[], ApiErrorResponse>({
        path: `/api/pagefolderpermissions/byFolder/${folderId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PageFolderPermission
     * @name SetPermissionsAsync
     * @summary Grants permissions to a user
     * @request POST:/api/pagefolderpermissions/{folderId}
     * @secure
     */
    setPermissionsAsync: (folderId: number, data: SetPermissionsAsyncPayload, params: RequestParams = {}) =>
      this.http.request<IActionResult, ApiErrorResponse | void>({
        path: `/api/pagefolderpermissions/${folderId}`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  }
  pages = {
    /**
     * No description
     *
     * @tags Pages
     * @name PostAsync
     * @summary Post
     * @request POST:/api/pages
     * @secure
     */
    postAsync: (data: PageBaseRequest, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse | void>({
        path: `/api/pages`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Pages
     * @name GetPosterAsync
     * @summary Get Poster
     * @request GET:/api/pages/{pageId}/poster
     * @deprecated
     * @secure
     */
    getPosterAsync: (
      pageId: number,
      query?: {
        /** @default "default.jpg" */
        name?: string
        /**
         * @format int32
         * @default 1500
         */
        size?: number
      },
      params: RequestParams = {}
    ) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/pages/${pageId}/poster`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Pages
     * @name GetPosterLinkAsync
     * @summary Get Poster Link
     * @request GET:/api/pages/{pageId}/posterlink
     * @secure
     */
    getPosterLinkAsync: (
      pageId: number,
      query?: {
        /** @default false */
        withAnnotations?: boolean
      },
      params: RequestParams = {}
    ) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/pages/${pageId}/posterlink`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Pages
     * @name GetFormAnswersAsync
     * @summary Get Form Answers
     * @request GET:/api/pages/{pageId}/formcsv
     * @secure
     */
    getFormAnswersAsync: (pageId: number, params: RequestParams = {}) =>
      this.http.request<string, ApiErrorResponse>({
        path: `/api/pages/${pageId}/formcsv`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Pages
     * @name RotatePageAsync
     * @summary Rotate Page
     * @request POST:/api/pages/rotate
     * @secure
     */
    rotatePageAsync: (data: RotatePageRequest, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse | void>({
        path: `/api/pages/rotate`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Pages
     * @name GetGeosearchPagesAsync
     * @summary Get Geosearch Pages
     * @request GET:/api/pages/geosearch
     * @secure
     */
    getGeosearchPagesAsync: (params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/pages/geosearch`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Pages
     * @name GetGeosearchPagesThumbnailsAsync
     * @summary Get Geosearch Pages
     * @request POST:/api/pages/geosearch/thumbnails
     * @secure
     */
    getGeosearchPagesThumbnailsAsync: (data: GetGeosearchPagesThumbnailsAsyncPayload, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse | void>({
        path: `/api/pages/geosearch/thumbnails`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Pages
     * @name GetPagesByAnswerStatusAsync
     * @summary Get Pages By Answer Status
     * @request POST:/api/pages/getpagesbyanswerstatus
     * @secure
     */
    getPagesByAnswerStatusAsync: (data: LoadPageByAnswerStatusRequest, params: RequestParams = {}) =>
      this.http.request<PageBaseRequest[], ApiErrorResponse | void>({
        path: `/api/pages/getpagesbyanswerstatus`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Pages
     * @name GetPagesPerQuestionsOrderAsync
     * @summary Get Pages Per Questions Order
     * @request GET:/api/pages/getpagesperquestionsorder/{contentId}/{folderId}
     * @secure
     */
    getPagesPerQuestionsOrderAsync: (contentId: number, folderId: number, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/pages/getpagesperquestionsorder/${contentId}/${folderId}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Pages
     * @name UpdatePageNameAsync
     * @summary Update Page Name
     * @request PUT:/api/pages/updatepagename
     * @secure
     */
    updatePageNameAsync: (data: UpdatePageNameRequest, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse | void>({
        path: `/api/pages/updatepagename`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Pages
     * @name NotifyClientsOfUpdatedPageAsync
     * @summary Notify Clients Of Updated Page
     * @request POST:/api/pages/notifyPageUpdated
     * @secure
     */
    notifyClientsOfUpdatedPageAsync: (data: NotifyPageUpdatedRequest, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse | void>({
        path: `/api/pages/notifyPageUpdated`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Pages
     * @name GetActivitiesAsync
     * @summary Request is used to get form answers timeline for page
     * @request GET:/api/pages/{id}/answersTimeline
     * @secure
     */
    getActivitiesAsync: (id: number, params: RequestParams = {}) =>
      this.http.request<FormAnswersTimelineItemResponse[], ApiErrorResponse>({
        path: `/api/pages/${id}/answersTimeline`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Pages
     * @name GetPotreePointCloudSas
     * @summary Get readonly Shared Access Signature for potree point cloud blobs.
     * @request GET:/api/pages/{id}/potreePointCloudSas
     * @secure
     */
    getPotreePointCloudSas: (id: number, params: RequestParams = {}) =>
      this.http.request<PointCloudPageSasTokenResponse, ApiErrorResponse>({
        path: `/api/pages/${id}/potreePointCloudSas`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Pages
     * @name GetPageMeasurementSettingsAsync
     * @summary Request is used to get page measurement settings
     * @request GET:/api/pages/{id}/measurementSettings
     * @secure
     */
    getPageMeasurementSettingsAsync: (id: number, params: RequestParams = {}) =>
      this.http.request<PageMeasurementSettingsResponse, ApiErrorResponse>({
        path: `/api/pages/${id}/measurementSettings`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Pages
     * @name UpdatePageMeasurementSettingsAsync
     * @summary Request is used to update page measurement settings
     * @request PUT:/api/pages/{id}/measurementSettings
     * @secure
     */
    updatePageMeasurementSettingsAsync: (
      id: number,
      data: PageMeasurementSettingsUpdateRequest,
      params: RequestParams = {}
    ) =>
      this.http.request<void, ApiErrorResponse | void>({
        path: `/api/pages/${id}/measurementSettings`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Pages
     * @name GetPageSourcePagesAssetsAsync
     * @summary Request is used to get point cloud source pages assets
     * @request GET:/api/pages/{id}/source-pages-assets
     * @secure
     */
    getPageSourcePagesAssetsAsync: (id: number, params: RequestParams = {}) =>
      this.http.request<PointCloudPageSourcePageAssetResponse[], ApiErrorResponse>({
        path: `/api/pages/${id}/source-pages-assets`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Pages
     * @name GetContentPointCloudPagesAsync
     * @summary Request is used to get session point cloud pages locations
     * @request GET:/api/pages/point-clouds/locations
     * @secure
     */
    getContentPointCloudPagesAsync: (
      query: {
        /** @format int32 */
        contentId: number
      },
      params: RequestParams = {}
    ) =>
      this.http.request<PointCloudPageLocationResponse[], ApiErrorResponse>({
        path: `/api/pages/point-clouds/locations`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Pages
     * @name AddFileAsync
     * @summary Request is used to add file to session
     * @request POST:/api/pages/file
     * @secure
     */
    addFileAsync: (data: CreateFilePageRequest, params: RequestParams = {}) =>
      this.http.request<PageBaseRequest, ApiErrorResponse | void>({
        path: `/api/pages/file`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Pages
     * @name AddDrawingBoardAsync
     * @summary Request is used to add drawing board to session
     * @request POST:/api/pages/drawingboard
     * @secure
     */
    addDrawingBoardAsync: (data: CreateDrawingBoardPageRequest, params: RequestParams = {}) =>
      this.http.request<PageBaseRequest, ApiErrorResponse | void>({
        path: `/api/pages/drawingboard`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Pages
     * @name AddImageAsync
     * @summary Request is used to add image to session
     * @request POST:/api/pages/image
     * @secure
     */
    addImageAsync: (data: CreateImagePageRequest, params: RequestParams = {}) =>
      this.http.request<PageBaseRequest, ApiErrorResponse | void>({
        path: `/api/pages/image`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Pages
     * @name AddVideoAsync
     * @summary Request is used to add video to session
     * @request POST:/api/pages/video
     * @secure
     */
    addVideoAsync: (data: CreateVideoPageRequest, params: RequestParams = {}) =>
      this.http.request<PageBaseRequest, ApiErrorResponse | void>({
        path: `/api/pages/video`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Pages
     * @name AddWordDocumentAsync
     * @summary Request is used to add Word document to session
     * @request POST:/api/pages/word
     * @secure
     */
    addWordDocumentAsync: (data: CreateWordPageRequest, params: RequestParams = {}) =>
      this.http.request<PageBaseRequest, ApiErrorResponse | void>({
        path: `/api/pages/word`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Pages
     * @name AddPptDocumentAsync
     * @summary Request is used to add PowerPoint document to session
     * @request POST:/api/pages/powerpoint
     * @secure
     */
    addPptDocumentAsync: (data: CreatePowerPointPageRequest, params: RequestParams = {}) =>
      this.http.request<PageBaseRequest, ApiErrorResponse | void>({
        path: `/api/pages/powerpoint`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Pages
     * @name AddExcelDocumentAsync
     * @summary Request is used to add Excel document to session
     * @request POST:/api/pages/excel
     * @secure
     */
    addExcelDocumentAsync: (data: CreateExcelPageRequest, params: RequestParams = {}) =>
      this.http.request<PageBaseRequest, ApiErrorResponse | void>({
        path: `/api/pages/excel`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Pages
     * @name AddWebPageAsync
     * @summary Request is used to add Web page to session
     * @request POST:/api/pages/web
     * @secure
     */
    addWebPageAsync: (data: CreateWebPageRequest, params: RequestParams = {}) =>
      this.http.request<PageBaseRequest, ApiErrorResponse | void>({
        path: `/api/pages/web`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Pages
     * @name AddPointCloudModelAsync
     * @summary Request is used to add point cloud model page to session
     * @request POST:/api/pages/pointCloud
     * @secure
     */
    addPointCloudModelAsync: (data: CreatePointCloudPageModel, params: RequestParams = {}) =>
      this.http.request<PageBaseRequest, ApiErrorResponse | void>({
        path: `/api/pages/pointCloud`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Pages
     * @name Add360ViewAsync
     * @summary Request is used to add 360 view page to session
     * @request POST:/api/pages/360view
     * @secure
     */
    add360ViewAsync: (data: SpatialViewPageCreateRequest, params: RequestParams = {}) =>
      this.http.request<PageBaseRequest, ApiErrorResponse | void>({
        path: `/api/pages/360view`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Pages
     * @name PostPdfAsync
     * @summary Request is used to add pdf to session
     * @request POST:/api/pages/pdf
     * @secure
     */
    postPdfAsync: (data: CreatePdfPageRequest, params: RequestParams = {}) =>
      this.http.request<PageBaseRequest[], ApiErrorResponse | void>({
        path: `/api/pages/pdf`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Pages
     * @name AddAutodeskFileAsync
     * @summary Request is used to add BIM/CAD file to session
     * @request POST:/api/pages/autodesk
     * @secure
     */
    addAutodeskFileAsync: (data: CreateAutodeskPageRequest, params: RequestParams = {}) =>
      this.http.request<PageBaseRequest, ApiErrorResponse | void>({
        path: `/api/pages/autodesk`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description If the optional parameter pageFolderId is not provided, all gallery pages are retrieved. If specified, only the pages within the given pageFolderId are retrieved.
     *
     * @tags Pages
     * @name GetPagesByContentIdAsync
     * @summary The request to retrieve gallery pages from the session.
     * @request GET:/api/pages/bycontent/{contentId}/{pageFolderId}
     * @secure
     */
    getPagesByContentIdAsync: (contentId: number, pageFolderId: number, params: RequestParams = {}) =>
      this.http.request<PageBaseRequest[], ApiErrorResponse>({
        path: `/api/pages/bycontent/${contentId}/${pageFolderId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Pages
     * @name GetDeletedPagesAsync
     * @summary Returns a list of deleted pages which may be restored
     * @request GET:/api/pages/{contentId}/deleted
     * @secure
     */
    getDeletedPagesAsync: (
      contentId: number,
      query?: {
        /**
         * Indentifies if response must include assets
         * @default false
         */
        withAssets?: boolean
      },
      params: RequestParams = {}
    ) =>
      this.http.request<PageBaseRequest[], ApiErrorResponse>({
        path: `/api/pages/${contentId}/deleted`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Pages
     * @name RestorePageAsync
     * @summary Restores a page
     * @request PUT:/api/pages/{pageId}/restore
     * @secure
     */
    restorePageAsync: (pageId: number, params: RequestParams = {}) =>
      this.http.request<IActionResult, ApiErrorResponse>({
        path: `/api/pages/${pageId}/restore`,
        method: 'PUT',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Pages
     * @name BulkPagesRestoreAsync
     * @summary Restores a list of the deleted pages
     * @request PUT:/api/pages/bulk/restore
     * @secure
     */
    bulkPagesRestoreAsync: (data: BulkPagesRestoreAsyncPayload, params: RequestParams = {}) =>
      this.http.request<IActionResult, ApiErrorResponse | void>({
        path: `/api/pages/bulk/restore`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Pages
     * @name DeleteAsync
     * @summary Request is used to delete page from session
     * @request DELETE:/api/pages/{id}
     * @secure
     */
    deleteAsync: (id: number, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse>({
        path: `/api/pages/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Pages
     * @name GetAsync
     * @summary Request is used to get page from session
     * @request GET:/api/pages/{id}
     * @secure
     */
    getAsync: (id: number, params: RequestParams = {}) =>
      this.http.request<PageBaseRequest, ApiErrorResponse>({
        path: `/api/pages/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Pages
     * @name DeletePagePermanentlyAsync
     * @summary Permanently deletes a page
     * @request DELETE:/api/pages/{pageId}/permanently
     * @secure
     */
    deletePagePermanentlyAsync: (pageId: number, params: RequestParams = {}) =>
      this.http.request<IActionResult, ApiErrorResponse>({
        path: `/api/pages/${pageId}/permanently`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Pages
     * @name BulkPagesDeletePermanentlyAsync
     * @summary Permanently deletes a list of the pages
     * @request PUT:/api/pages/bulk/delete/permanently
     * @secure
     */
    bulkPagesDeletePermanentlyAsync: (data: BulkPagesDeletePermanentlyAsyncPayload, params: RequestParams = {}) =>
      this.http.request<IActionResult, ApiErrorResponse | void>({
        path: `/api/pages/bulk/delete/permanently`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Pages
     * @name GetPointCloudPageSettingsAsync
     * @summary Request is used to get point cloud page settings
     * @request GET:/api/pages/{id}/pointCloudSettings
     * @secure
     */
    getPointCloudPageSettingsAsync: (id: number, params: RequestParams = {}) =>
      this.http.request<PointCloudPageSettingsResponse, ApiErrorResponse>({
        path: `/api/pages/${id}/pointCloudSettings`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Pages
     * @name UpdatePointCloudPageSettingsAsync
     * @summary Request is used to update point cloud page settings
     * @request PUT:/api/pages/{id}/pointCloudSettings
     * @secure
     */
    updatePointCloudPageSettingsAsync: (
      id: number,
      data: PointCloudPageSettingsUpdateRequest,
      params: RequestParams = {}
    ) =>
      this.http.request<void, ApiErrorResponse | void>({
        path: `/api/pages/${id}/pointCloudSettings`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Pages
     * @name Put
     * @summary Request is used to rename existing page
     * @request PUT:/api/pages/rename
     * @secure
     */
    put: (data: RenamePageRequest, params: RequestParams = {}) =>
      this.http.request<PageBaseRequest, ApiErrorResponse | void>({
        path: `/api/pages/rename`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Pages
     * @name UpdatePagesFolder
     * @summary Request is used to move existing pages to folder
     * @request PUT:/api/pages/moveto
     * @secure
     */
    updatePagesFolder: (data: UpdatePagesFolderRequest, params: RequestParams = {}) =>
      this.http.request<PageBaseRequest, ApiErrorResponse | void>({
        path: `/api/pages/moveto`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  }
  permissions = {
    /**
     * No description
     *
     * @tags Permissions
     * @name GetBySessionAsync
     * @summary Request is used to retrieve list of users permissions in session
     * @request GET:/api/permissions/session/{contentId}
     * @secure
     */
    getBySessionAsync: (contentId: number, params: RequestParams = {}) =>
      this.http.request<SessionPermissionIEnumerablePermissionsResponse, ApiErrorResponse>({
        path: `/api/permissions/session/${contentId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Permissions
     * @name GetByFolderAsync
     * @summary Request is used to retrieve list of users permissions in folder
     * @request GET:/api/permissions/folder/{folderId}
     * @secure
     */
    getByFolderAsync: (folderId: number, params: RequestParams = {}) =>
      this.http.request<FolderPermissionPermissionsResponse, ApiErrorResponse>({
        path: `/api/permissions/folder/${folderId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Permissions
     * @name GetByTenantAsync
     * @summary Request is used to retrieve list of users permissions in tenant
     * @request GET:/api/permissions/tenant
     * @secure
     */
    getByTenantAsync: (params: RequestParams = {}) =>
      this.http.request<TenantPermissionIEnumerablePermissionsResponse, ApiErrorResponse>({
        path: `/api/permissions/tenant`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  }
  places = {
    /**
     * No description
     *
     * @tags Places
     * @name GetNearbyHospitalsAsync
     * @summary Request is used to get nearby hospitals
     * @request GET:/api/places/hospitals
     * @secure
     */
    getNearbyHospitalsAsync: (
      query: {
        /**
         * Latitude
         * @format double
         * @min -90
         * @max 90
         */
        latitude: number
        /**
         * Longitude
         * @format double
         * @min -180
         * @max 180
         */
        longitude: number
        /**
         * Search radius in meters
         * @format double
         * @min 1
         * @max 50000
         * @default 5000
         */
        radius?: number
        /** Page token */
        pageToken?: string
      },
      params: RequestParams = {}
    ) =>
      this.http.request<PlacesPagedResponse, ApiErrorResponse>({
        path: `/api/places/hospitals`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  }
  pointCloudGpsMetadata = {
    /**
     * No description
     *
     * @tags PointCloudGpsMetadata
     * @name InitPointCloudGeoSearchAsync
     * @request POST:/api/pointCloudGpsMetadata/init
     * @secure
     */
    initPointCloudGeoSearchAsync: (params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/pointCloudGpsMetadata/init`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags PointCloudGpsMetadata
     * @name GetPointCloudGpsMetadataByContentIdAsync
     * @request GET:/api/pointCloudGpsMetadata/contents/{contentId}
     * @secure
     */
    getPointCloudGpsMetadataByContentIdAsync: (contentId: number, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/pointCloudGpsMetadata/contents/${contentId}`,
        method: 'GET',
        secure: true,
        ...params,
      }),
  }
  policies = {
    /**
     * No description
     *
     * @tags Policies
     * @name AcceptAsync
     * @summary Accept
     * @request POST:/api/policies/accept
     * @secure
     */
    acceptAsync: (data: AcceptPoliciesRequest, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse | void>({
        path: `/api/policies/accept`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Policies
     * @name PostAsync
     * @summary Post
     * @request POST:/api/policies
     * @secure
     */
    postAsync: (data: PolicyRequest, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse | void>({
        path: `/api/policies`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Policies
     * @name GetIsNeedsUpdateAsync
     * @summary Get Is Needs Update
     * @request GET:/api/policies/needsUpdate
     * @secure
     */
    getIsNeedsUpdateAsync: (params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/policies/needsUpdate`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Policies
     * @name GetLatestPoliciesWithAcceptanceStatusAsync
     * @summary Get Latest Policies With Acceptance Status
     * @request GET:/api/policies/latestPolicies
     * @secure
     */
    getLatestPoliciesWithAcceptanceStatusAsync: (params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/policies/latestPolicies`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Policies
     * @name GetAsync
     * @summary Get
     * @request GET:/api/policies/{version}
     * @secure
     */
    getAsync: (version: number, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/policies/${version}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Policies
     * @name GetLatestPolicyByTypeAsync
     * @summary Get Latest Policy By Type
     * @request GET:/api/policies/latest/{policyType}
     * @secure
     */
    getLatestPolicyByTypeAsync: (
      policyType: PolicyType,
      query?: {
        subdomain?: string
      },
      params: RequestParams = {}
    ) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/policies/latest/${policyType}`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),
  }
  readonlyContent = {
    /**
     * No description
     *
     * @tags ReadonlyContent
     * @name GetAsync
     * @summary Get readonly content
     * @request GET:/api/content/shared/{token}
     * @secure
     */
    getAsync: (token: string, params: RequestParams = {}) =>
      this.http.request<GetReadonlyContentResponse, ApiErrorResponse>({
        path: `/api/content/shared/${token}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReadonlyContent
     * @name GetReadonlyPageAsync
     * @summary Get readonly page
     * @request GET:/api/content/shared/{token}/pages/{pageId}
     * @secure
     */
    getReadonlyPageAsync: (token: string, pageId: number, params: RequestParams = {}) =>
      this.http.request<ReadonlyPageResponse, ApiErrorResponse>({
        path: `/api/content/shared/${token}/pages/${pageId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReadonlyContent
     * @name GetContentFormAsync
     * @summary Get readonly content form
     * @request GET:/api/content/shared/{token}/contentForm/{contentFormId}
     * @secure
     */
    getContentFormAsync: (token: string, contentFormId: number, params: RequestParams = {}) =>
      this.http.request<GetReadonlyContentFormsResponse, ApiErrorResponse>({
        path: `/api/content/shared/${token}/contentForm/${contentFormId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReadonlyContent
     * @name GetLatestFormAnswersByTabAsync
     * @summary Get readonly latest form answers
     * @request GET:/api/content/shared/{token}/contentForm/{contentFormId}/tabs
     * @secure
     */
    getLatestFormAnswersByTabAsync: (
      token: string,
      contentFormId: number,
      query?: {
        tabIds?: number[]
      },
      params: RequestParams = {}
    ) =>
      this.http.request<ReadonlyFormAnswerResponse[], ApiErrorResponse>({
        path: `/api/content/shared/${token}/contentForm/${contentFormId}/tabs`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  }
  recording = {
    /**
     * No description
     *
     * @tags Recording
     * @name PrepareRecordingAsync
     * @summary Prepare Recording
     * @request POST:/api/recording/PrepareRecording
     * @secure
     */
    prepareRecordingAsync: (data: RecordingRequest, params: RequestParams = {}) =>
      this.http.request<RecordStatusResponse, ApiErrorResponse | void>({
        path: `/api/recording/PrepareRecording`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Recording
     * @name StartRecordingAsync
     * @summary Start Recording
     * @request POST:/api/recording/StartRecording
     * @secure
     */
    startRecordingAsync: (data: RecordingRequest, params: RequestParams = {}) =>
      this.http.request<RecordStatusResponse, ApiErrorResponse | void>({
        path: `/api/recording/StartRecording`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Recording
     * @name PauseRecordingAsync
     * @summary Pause Recording
     * @request POST:/api/recording/PauseRecording
     * @secure
     */
    pauseRecordingAsync: (data: RecordingRequest, params: RequestParams = {}) =>
      this.http.request<RecordStatusResponse, ApiErrorResponse | void>({
        path: `/api/recording/PauseRecording`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Recording
     * @name ContinueRecordingAsync
     * @summary Continue Recording
     * @request POST:/api/recording/ContinueRecording
     * @secure
     */
    continueRecordingAsync: (data: RecordingRequest, params: RequestParams = {}) =>
      this.http.request<RecordStatusResponse, ApiErrorResponse | void>({
        path: `/api/recording/ContinueRecording`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Recording
     * @name StopRecordingAsync
     * @summary Stop Recording
     * @request POST:/api/recording/StopRecording
     * @secure
     */
    stopRecordingAsync: (data: RecordingRequest, params: RequestParams = {}) =>
      this.http.request<RecordStatusResponse, ApiErrorResponse | void>({
        path: `/api/recording/StopRecording`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Recording
     * @name StatusRecordingAsync
     * @summary Status Recording
     * @request POST:/api/recording/StatusRecording
     * @secure
     */
    statusRecordingAsync: (data: RecordingRequest, params: RequestParams = {}) =>
      this.http.request<RecordStatusResponse, ApiErrorResponse | void>({
        path: `/api/recording/StatusRecording`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Recording
     * @name LinkFormAnswersWithLocalRecording
     * @summary Link local recording page with answers created during the recording
     * @request POST:/api/recording/localRecording/linkFormAnswers
     * @secure
     */
    linkFormAnswersWithLocalRecording: (data: LocalRecordingRequest, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse | void>({
        path: `/api/recording/localRecording/linkFormAnswers`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Recording
     * @name AddRecordedPageAsync
     * @summary Add Recorded Page
     * @request GET:/api/recording/AddRecordedPage/{recordId}/{server}
     * @deprecated
     * @secure
     */
    addRecordedPageAsync: (recordId: number, server: string, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse>({
        path: `/api/recording/AddRecordedPage/${recordId}/${server}`,
        method: 'GET',
        secure: true,
        ...params,
      }),
  }
  reminders = {
    /**
     * No description
     *
     * @tags Reminders
     * @name CreateAsync
     * @summary Request to create new reminder.
     * @request POST:/api/Reminders
     * @secure
     */
    createAsync: (data: ReminderRequest, params: RequestParams = {}) =>
      this.http.request<ReminderRequest, ApiErrorResponse | void>({
        path: `/api/Reminders`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reminders
     * @name UpdateAsync
     * @summary Request to update existing reminder.
     * @request PUT:/api/Reminders
     * @secure
     */
    updateAsync: (data: ReminderResponse, params: RequestParams = {}) =>
      this.http.request<ReminderResponse, ApiErrorResponse | void>({
        path: `/api/Reminders`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reminders
     * @name DeleteReminderAsync
     * @summary Request to remove existing reminder
     * @request DELETE:/api/Reminders/{reminderId}
     * @secure
     */
    deleteReminderAsync: (reminderId: number, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse>({
        path: `/api/Reminders/${reminderId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reminders
     * @name ListAvailableFormAnswerReminderReceiversAsync
     * @summary List of users ids which can receive reminder and have enough permissions to answer to the form
     * @request GET:/api/Reminders/contents/{contentId}/forms/{formId}/receivers
     * @secure
     */
    listAvailableFormAnswerReminderReceiversAsync: (contentId: number, formId: number, params: RequestParams = {}) =>
      this.http.request<number[], ApiErrorResponse>({
        path: `/api/Reminders/contents/${contentId}/forms/${formId}/receivers`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reminders
     * @name GetByContentIdAsync
     * @summary Request to get the list of all reminders created in the content.
     * @request GET:/api/Reminders/contents/{contentId}
     * @secure
     */
    getByContentIdAsync: (contentId: number, params: RequestParams = {}) =>
      this.http.request<ReminderResponse[], ApiErrorResponse>({
        path: `/api/Reminders/contents/${contentId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  }
  sectionedContentMetadata = {
    /**
     * No description
     *
     * @tags SectionedContentMetadata
     * @name GetTabs
     * @request GET:/api/sectionedContentMetadata/tabs
     * @deprecated
     */
    getTabs: (params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/api/sectionedContentMetadata/tabs`,
        method: 'GET',
        ...params,
      }),
  }
  statistics = {
    /**
     * No description
     *
     * @tags Statistics
     * @name GetRecordingTimeUsedStatisticsAsync
     * @summary Get Recording Time Used Statistics
     * @request GET:/api/admin/statistics/sessions/{id}/recordingtime
     * @secure
     */
    getRecordingTimeUsedStatisticsAsync: (id: number, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/admin/statistics/sessions/${id}/recordingtime`,
        method: 'GET',
        secure: true,
        ...params,
      }),
  }
  structureModel = {
    /**
     * No description
     *
     * @tags StructureModel
     * @name UploadFileAsync
     * @summary Upload File
     * @request POST:/api/ai/uploadFile
     * @secure
     */
    uploadFileAsync: (data: UploadFileModel, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse | void>({
        path: `/api/ai/uploadFile`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags StructureModel
     * @name NotifyStructureModelCreatedAsync
     * @summary Notify Structure Model Created
     * @request POST:/api/ai/notifyStructureCreated
     * @secure
     */
    notifyStructureModelCreatedAsync: (data: StructureModelCreated, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse | void>({
        path: `/api/ai/notifyStructureCreated`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  }
  tabeebWebApi = {
    /**
     * No description
     *
     * @tags Tabeeb.Web.Api
     * @name MapTabeebHealthChecksB30
     * @request GET:/api/health/apim
     */
    mapTabeebHealthChecksB30: (params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/api/health/apim`,
        method: 'GET',
        ...params,
      }),
  }
  tenantForm = {
    /**
     * No description
     *
     * @tags TenantForm
     * @name GetTenantFormsBySubdomainAsync
     * @summary Get Tenant Forms By Subdomain
     * @request GET:/api/tenantform/gettenantformsbysubdomain/{subdomain}
     * @secure
     */
    getTenantFormsBySubdomainAsync: (subdomain: string, params: RequestParams = {}) =>
      this.http.request<TenantFormResponse[], ApiErrorResponse>({
        path: `/api/tenantform/gettenantformsbysubdomain/${subdomain}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags TenantForm
     * @name GetTenantFormBySubdomainAsync
     * @summary Get Tenant Form By Subdomain
     * @request GET:/api/tenantform/gettenantformbysubdomain/{subdomain}
     * @secure
     */
    getTenantFormBySubdomainAsync: (subdomain: string, params: RequestParams = {}) =>
      this.http.request<FormUpdateResponse, ApiErrorResponse>({
        path: `/api/tenantform/gettenantformbysubdomain/${subdomain}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags TenantForm
     * @name GetAdditionalTenantFormAsync
     * @summary Get Additional Tenant Form
     * @request GET:/api/tenantform/getadditionaltenantform/{formId}
     * @secure
     */
    getAdditionalTenantFormAsync: (formId: number, params: RequestParams = {}) =>
      this.http.request<FormUpdateResponse, ApiErrorResponse>({
        path: `/api/tenantform/getadditionaltenantform/${formId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags TenantForm
     * @name AttachFormToTenantAsync
     * @summary Attach Form To Tenant
     * @request POST:/api/tenantform/attachformtotenant
     * @secure
     */
    attachFormToTenantAsync: (data: AttachFormToTenantRequest, params: RequestParams = {}) =>
      this.http.request<TenantFormResponse, ApiErrorResponse | void>({
        path: `/api/tenantform/attachformtotenant`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags TenantForm
     * @name DetachFormFromTenantAsync
     * @summary Detach Form From Tenant
     * @request DELETE:/api/tenantform/detachformfromtenant/{tenantFormId}
     * @secure
     */
    detachFormFromTenantAsync: (tenantFormId: number, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse>({
        path: `/api/tenantform/detachformfromtenant/${tenantFormId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags TenantForm
     * @name CheckConditionsAsync
     * @summary Check Conditions
     * @request POST:/api/tenantform/checkconditions
     * @secure
     */
    checkConditionsAsync: (data: CheckFormControlConditionsRequest, params: RequestParams = {}) =>
      this.http.request<ConditionsResponse, ApiErrorResponse | void>({
        path: `/api/tenantform/checkconditions`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags TenantForm
     * @name GetAllAsync
     * @summary Get All
     * @request GET:/api/tenantform
     * @secure
     */
    getAllAsync: (params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/tenantform`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags TenantForm
     * @name PostAsync
     * @summary Post
     * @request POST:/api/tenantform
     * @secure
     */
    postAsync: (data: FormAnswerBaseResponse, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse | void>({
        path: `/api/tenantform`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags TenantForm
     * @name GetAsync
     * @summary Get
     * @request GET:/api/tenantform/{id}
     * @secure
     */
    getAsync: (id: number, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/tenantform/${id}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags TenantForm
     * @name PutAsync
     * @summary Put
     * @request PUT:/api/tenantform/{id}
     * @secure
     */
    putAsync: (id: number, data: FormAnswerBaseResponse, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse | void>({
        path: `/api/tenantform/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags TenantForm
     * @name DeleteAsync
     * @summary Delete
     * @request DELETE:/api/tenantform/{id}
     * @secure
     */
    deleteAsync: (id: number, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/tenantform/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),
  }
  threeDimensionalModels = {
    /**
     * No description
     *
     * @tags ThreeDimensionalModels
     * @name GetAllAsync
     * @summary Request is used to get all tenants 3d models
     * @request GET:/api/threeDModels
     * @secure
     */
    getAllAsync: (params: RequestParams = {}) =>
      this.http.request<ThreeDimensionalModelResponse[], ApiErrorResponse>({
        path: `/api/threeDModels`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ThreeDimensionalModels
     * @name CreateAsync
     * @summary Request is used to create 3d model
     * @request POST:/api/threeDModels
     * @secure
     */
    createAsync: (data: ThreeDimensionalModelCreateRequest, params: RequestParams = {}) =>
      this.http.request<ThreeDimensionalModelResponse, ApiErrorResponse | void>({
        path: `/api/threeDModels`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ThreeDimensionalModels
     * @name GetAsync
     * @summary Request is used to get 3d model by id
     * @request GET:/api/threeDModels/{modelId}
     * @secure
     */
    getAsync: (modelId: number, params: RequestParams = {}) =>
      this.http.request<ThreeDimensionalModelResponse, ApiErrorResponse>({
        path: `/api/threeDModels/${modelId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ThreeDimensionalModels
     * @name DeleteAsync
     * @summary Request is used to delete 3d model
     * @request DELETE:/api/threeDModels/{modelId}
     * @secure
     */
    deleteAsync: (modelId: number, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse>({
        path: `/api/threeDModels/${modelId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ThreeDimensionalModels
     * @name CreateSplatAsync
     * @request POST:/api/threeDModels/splat
     * @secure
     */
    createSplatAsync: (data: CreateSplatModelRequest, params: RequestParams = {}) =>
      this.http.request<PageBaseRequest, ApiErrorResponse | void>({
        path: `/api/threeDModels/splat`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ThreeDimensionalModels
     * @name PrepareCreateSplatAsync
     * @request POST:/api/threeDModels/splat/prepare
     * @secure
     */
    prepareCreateSplatAsync: (data: CreateSplatModelRequest, params: RequestParams = {}) =>
      this.http.request<PrepareSplatModelResponse, ApiErrorResponse | void>({
        path: `/api/threeDModels/splat/prepare`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ThreeDimensionalModels
     * @name SendForSegmentationAsync
     * @request POST:/api/threeDModels/splat/segmentation
     * @secure
     */
    sendForSegmentationAsync: (
      query?: {
        /** @format int32 */
        pageId?: number
      },
      params: RequestParams = {}
    ) =>
      this.http.request<IActionResult, ApiErrorResponse>({
        path: `/api/threeDModels/splat/segmentation`,
        method: 'POST',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  }
  token = {
    /**
     * No description
     *
     * @tags Token
     * @name LoginViaUserNameAndPasswordAsync
     * @summary Request is used to receive an authorization token and login to the system.
     * @request POST:/api/Token
     */
    loginViaUserNameAndPasswordAsync: (data: LoginViaUserNameAndPasswordAsyncPayload, params: RequestParams = {}) =>
      this.http.request<JwtTokenResponse, ApiErrorResponse>({
        path: `/api/Token`,
        method: 'POST',
        body: data,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),
  }
  tracking = {
    /**
     * No description
     *
     * @tags Tracking
     * @name GetAllAsync
     * @summary Get All
     * @request GET:/api/tracking
     * @secure
     */
    getAllAsync: (
      query?: {
        /** @format date-time */
        startTime?: string
        /** @format date-time */
        endTime?: string
        /** @format int32 */
        contentId?: number
      },
      params: RequestParams = {}
    ) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/tracking`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tracking
     * @name PostAsync
     * @summary Post
     * @request POST:/api/tracking
     * @secure
     */
    postAsync: (data: CreateTrackingRequest, params: RequestParams = {}) =>
      this.http.request<TrackingResponse, ApiErrorResponse | void>({
        path: `/api/tracking`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tracking
     * @name GetLatestAsync
     * @summary Get Latest
     * @request GET:/api/tracking/latest/{contentId}
     * @secure
     */
    getLatestAsync: (
      contentId: number,
      query?: {
        /**
         * @format int32
         * @default 2
         */
        count?: number
      },
      params: RequestParams = {}
    ) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/tracking/latest/${contentId}`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tracking
     * @name DeleteAsync
     * @summary Delete
     * @request DELETE:/api/tracking/{id}
     * @secure
     */
    deleteAsync: (id: number, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/tracking/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tracking
     * @name GetSnapshotAsync
     * @request POST:/api/tracking/content/{contentId}/snapshot
     * @secure
     */
    getSnapshotAsync: (contentId: number, data: GetTrackingSnapshotRequest, params: RequestParams = {}) =>
      this.http.request<TrackingsSnaphotResponse, ApiErrorResponse | void>({
        path: `/api/tracking/content/${contentId}/snapshot`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tracking
     * @name CreateBatchAsync
     * @request POST:/api/tracking/content/{contentId}/batch
     * @secure
     */
    createBatchAsync: (contentId: number, data: CreateTrackingBatchRequest, params: RequestParams = {}) =>
      this.http.request<TrackingResponse[], ApiErrorResponse | void>({
        path: `/api/tracking/content/${contentId}/batch`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tracking
     * @name DeleteUserRecordsAsync
     * @request DELETE:/api/tracking/content/{contentId}/trackingUser/{trackingUserId}
     * @secure
     */
    deleteUserRecordsAsync: (
      contentId: number,
      trackingUserId: number,
      query?: {
        /** @format date-time */
        date?: string
      },
      params: RequestParams = {}
    ) =>
      this.http.request<void, ApiErrorResponse>({
        path: `/api/tracking/content/${contentId}/trackingUser/${trackingUserId}`,
        method: 'DELETE',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tracking
     * @name GetAsync
     * @summary Request is used to retrieve list of users trackings
     * @request GET:/api/tracking/all
     * @secure
     */
    getAsync: (
      query?: {
        /**
         * List of trackings events to return
         *
         * If it's missing, then only ChechIns and CheckOuts are returned.
         * @default [0,1]
         */
        EventTypes?: TrackingEventType[]
        /**
         * Id of the session for which data is retrieved
         *
         * If it's missing, then data for all available sessions is returned:
         * - from all sessions within current tenant with System/Billing/Tenant/Session Admin token;
         * - from all sessions of some user, whose token was used and only this user's tags with User token.
         * @format int32
         */
        ContentId?: number
        /**
         * Id of the tenant for which data is retrieved
         *
         * If it's missing, then data for current tenant (in accordance to user’s token) is returned.
         * @format int32
         */
        TenantId?: number
        /**
         * Id of the user for whom data is retrieved
         *
         * If it's missing then data for all available users is returned:
         * - for all users within current tenant with System/Billing/Tenant/Session Admin token;
         * - for current user, whose token was used, and only this user's tags with User token.
         * @format int32
         */
        UserId?: number
        /**
         * Start date of time period for which data is retrieved
         *
         * If it's missing, data for default time value is returned.
         * The Maximum period of time is 24 hours.
         * Default value: 15 minutes before the current time.
         * @format date-time
         */
        StartDate?: string
        /**
         * End date of time period for which data is retrieved
         *
         * If it's missing, data for default time value is returned.
         * The Maximum period of time is 24 hours.
         * Default value: current time.
         * @format date-time
         */
        EndDate?: string
      },
      params: RequestParams = {}
    ) =>
      this.http.request<TrackingResponse[], ApiErrorResponse>({
        path: `/api/tracking/all`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  }
  uploads = {
    /**
     * No description
     *
     * @tags Uploads
     * @name UploadAudioAsync
     * @summary Request is used to upload audio file to storage
     * @request POST:/api/uploads/audio
     * @deprecated
     * @secure
     */
    uploadAudioAsync: (data: UploadAudioRequest, params: RequestParams = {}) =>
      this.http.request<UploadedFileResponse, ApiErrorResponse | void>({
        path: `/api/uploads/audio`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Max file size: 2GB. Request timeout: 10 minutes.
     *
     * @tags Uploads
     * @name CreateAsync
     * @summary Request is used to upload file to storage
     * @request POST:/api/uploads/{contentId}
     * @secure
     */
    createAsync: (contentId: number, data: CreateAsyncPayload1, params: RequestParams = {}) =>
      this.http.request<string, ApiErrorResponse>({
        path: `/api/uploads/${contentId}`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),
  }
  userClaimsEndpoints = {
    /**
     * No description
     *
     * @tags UserClaimsEndpoints
     * @name GetUserClaims
     * @request GET:/api/user-claims
     */
    getUserClaims: (params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/api/user-claims`,
        method: 'GET',
        ...params,
      }),
  }
  userRoles = {
    /**
     * No description
     *
     * @tags UserRoles
     * @name AssignRoleAsync
     * @summary Change the role for a user in the tenant
     * @request POST:/api/admin/userroles/assignrole
     * @secure
     */
    assignRoleAsync: (data: ChangeUserRoleRequest, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse | void>({
        path: `/api/admin/userroles/assignrole`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserRoles
     * @name GetRoles
     * @summary Get Roles
     * @request GET:/api/admin/userroles/getroles
     * @secure
     */
    getRoles: (params: RequestParams = {}) =>
      this.http.request<string[], ApiErrorResponse>({
        path: `/api/admin/userroles/getroles`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  }
  users = {
    /**
     * No description
     *
     * @tags Users
     * @name GetAsync
     * @summary Get
     * @request GET:/api/users
     * @secure
     */
    getAsync: (
      query?: {
        /** @default "" */
        search?: string
        /** @format int32 */
        contentId?: number
        /** @format int32 */
        tenantId?: number
        roles?: number[]
      },
      params: RequestParams = {}
    ) =>
      this.http.request<UserSearchInfoResponse[], ApiErrorResponse>({
        path: `/api/users`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name PutAsync
     * @summary Put
     * @request PUT:/api/users
     * @secure
     */
    putAsync: (data: UserUpdateRequest, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse | void>({
        path: `/api/users`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name GetAvailableUsersAsync
     * @summary Get Available Users
     * @request GET:/api/users/all
     * @secure
     */
    getAvailableUsersAsync: (params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/users/all`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name GetByCommonContentsAsync
     * @summary Get by common contents
     * @request GET:/api/users/bycommoncontents
     * @secure
     */
    getByCommonContentsAsync: (
      query?: {
        /** @default "" */
        search?: string
        /**
         * @format int32
         * @default 0
         */
        skip?: number
        /**
         * @format int32
         * @default 20
         */
        take?: number
      },
      params: RequestParams = {}
    ) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/users/bycommoncontents`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name PostUserListAsync
     * @summary Post User List
     * @request POST:/api/users/upload
     * @secure
     */
    postUserListAsync: (params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/users/upload`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name GetUserByIdAsync
     * @summary Get User By Id
     * @request GET:/api/users/getuserbyid/{userId}
     * @secure
     */
    getUserByIdAsync: (userId: number, params: RequestParams = {}) =>
      this.http.request<UserResponse, ApiErrorResponse>({
        path: `/api/users/getuserbyid/${userId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name GetUserByIdentityGuidAsync
     * @summary Get User By IdentityGuid
     * @request GET:/api/users/get-user-by-identity-guid/{identityGuid}
     * @secure
     */
    getUserByIdentityGuidAsync: (identityGuid: string, params: RequestParams = {}) =>
      this.http.request<UserResponse, ApiErrorResponse>({
        path: `/api/users/get-user-by-identity-guid/${identityGuid}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name GetUsersByIdentityGuidsAsync
     * @summary Get users by identity guids
     * @request GET:/api/users/by-identity-guids
     * @secure
     */
    getUsersByIdentityGuidsAsync: (
      query: {
        /** @minItems 1 */
        IdentityGuids: string[]
      },
      params: RequestParams = {}
    ) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/users/by-identity-guids`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name GetUsersByIdAsync
     * @summary Get Users By Ids
     * @request POST:/api/users/get-by-ids
     * @secure
     */
    getUsersByIdAsync: (data: UsersByIdsGetRequest, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse | void>({
        path: `/api/users/get-by-ids`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name GetUsersByEmailsAsync
     * @summary Get Users By Emails
     * @request POST:/api/users/get-by-emails-or-phone-numbers
     * @secure
     */
    getUsersByEmailsAsync: (data: UsersByEmailsOrPhoneNumbersGetRequest, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse | void>({
        path: `/api/users/get-by-emails-or-phone-numbers`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name GetUserByGuidAsync
     * @summary Get User By Guid
     * @request GET:/api/users/getuserbyguid/{userGuid}
     * @secure
     */
    getUserByGuidAsync: (userGuid: string, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/api/users/getuserbyguid/${userGuid}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name GetUsersStatusAsync
     * @summary Get Users Status
     * @request POST:/api/users/getusersstatus
     * @secure
     */
    getUsersStatusAsync: (data: GetSearchTermRequest, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse | void>({
        path: `/api/users/getusersstatus`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name GetUsersByListOfEmailAsync
     * @summary Get Users By List Of Email
     * @request POST:/api/users/getusersbylistofemail
     * @secure
     */
    getUsersByListOfEmailAsync: (data: GetSearchTermRequest, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse | void>({
        path: `/api/users/getusersbylistofemail`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UpdateUserSignatureAsync
     * @summary Update user signature
     * @request PUT:/api/users/signature
     * @secure
     */
    updateUserSignatureAsync: (data: UserSignatureRequest, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse | void>({
        path: `/api/users/signature`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  }
  videoConcat = {
    /**
     * No description
     *
     * @tags VideoConcat
     * @name CreateConcatenatedVideoSelectedAsync
     * @summary Create Concatenated Video Selected
     * @request POST:/api/videoconcat/CreateVideo
     * @secure
     */
    createConcatenatedVideoSelectedAsync: (data: DocumentExportRequest, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse | void>({
        path: `/api/videoconcat/CreateVideo`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags VideoConcat
     * @name FinishConcatenateAsync
     * @summary Finish Concatenate
     * @request GET:/api/videoconcat/FinishConcatenate/{recordId}/{server}
     * @deprecated
     * @secure
     */
    finishConcatenateAsync: (recordId: number, server: string, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse>({
        path: `/api/videoconcat/FinishConcatenate/${recordId}/${server}`,
        method: 'GET',
        secure: true,
        ...params,
      }),
  }
}
